import i18next from "i18next";



import { resx } from "./resx";


const currentTranslations = {
    whitelist: ["en", "fr", "de", "it"],
    resources: {
        en: {
            translation: {
                activity: {
                    failedLoading: "Last activities could not be loaded.",
                    loadingActivities: "Last activities are being loaded...",
                    noActivities: "No activities available",
                },
                allocationHistory: {
                    allLocations: "All locations",
                    fields: {
                        additionalInfo: "Additional information",
                        allocated: "Visited",
                        deallocated: "Left",
                        isCovidComplete: "Covid valid",
                        isValid: "Valid",
                        isSignedUp: "Registered",
                        phone: "Tel. no.",
                        zip: "Zip",
                    },
                },
                attribute: {
                    fields: {
                        displayAs: "Display as",
                        filter: "Filter",
                        icon: "Icon",
                        isEnabled: "Enabled",
                        type: "Type",
                    },
                    types: {
                        standard: "Standard",
                        custom: "Custom",
                    },
                    effectDescription: {
                        Include: "If this filter is applied, only items with this attribute are displayed.",
                        Exclude: "If this filter is applied, only items without this attribute are displayed.",
                    },
                    standardFieldsLocked:
                        "Standard attribute: name, icon and filter are the same for every location and can only be changed centrally.",
                    standardCannotBeDeleted:
                        "A standard attribute is available to every location and cannot be removed. Disable it instead.",
                    cannotBeDisplayedAsFilter:
                        "No filter effect is defined for this standard attribute, so it cannot be displayed as a filter.",
                },
                receipt: {
                    receipt: "Receipt",
                    sendReceipt: "Send receipt",
                    printReceipt: "Print receipt",
                },
                print: {
                    orderReceiptPrinted: "Print job sent",
                    failedPrintReceipt: "Print job failed",
                    noProductionSiteEnabledForRoom: "No activated receipt printer is assigned to this table / room.",
                },
                apiVersion: {
                    fields: {
                        package: "Packet",
                        version: "Version",
                    },
                },
                cancellation: {
                    allModes: "All modes",
                    allPositions: "All items",
                    cancelPositions: "Individual items",
                    cancelWholePayment: "Entire payment",
                    fields: {
                        amount: "Amount",
                        cancelled: "Cancelled",
                        executedBy: "Performed by",
                        mode: "Mode",
                        positions: "Items",
                        reason: "Reason",
                        refund: "Refund",
                        refunded: "Refunded",
                    },
                },
                dashboard: {
                    allocations: "Check-Ins",
                    signups: "Sign-ups",
                    turnover: "Sales",
                    selectLocation: "Please select a location to view reports.",
                    salesChart: {
                        chartTitle: "Revenue incl. tip",
                        orders: "orders",
                        payments: "payments",
                    },
                    salesByPaymentMethodChart: {
                        chartTitle: "Payment methods",
                        onlineBrowser: "Online - Browser",
                        onlinePaymentDevice: "Online - Payment Device",
                        offline: "Offline",
                        nre: "Not revenue-effective",
                    },
                    cancellationsChart: {
                        chartTitle: "Cancellations",
                        noReason: "No reason",
                    },
                    kpiSummary: {
                        tip: "Tip",
                        netSalesNetExclTip: "Net revenue (excl. tip)",
                        grossSalesNetExclTip: "Revenue (excl. tip)",
                        avgOrder: "Average order",
                        avgPayment: "Average payment",
                        avgBill: "Average bill",
                        avgBillDurationMins: "Average bill duration",
                    },
                },
                discount: {
                    fields: {
                        appliesTo: "Applies to",
                        appliesToAll: "All",
                        name: "Name",
                        order: "Order",
                        status: "Status",
                        timesUsed: "Times used",
                        totalDiscounted: "Total discounted",
                        type: "Type",
                        value: "Value",
                    },
                    discountCode: {
                        copiedClipboard: "Discount code was copied to the clipboard.",
                    },
                    cancelDiscountPopupMessage: "Cancel this discount? This cannot be undone. Adjust Start / End if you want to use it again later.",
                },
                documents: {
                    allRooms: "All rooms",
                    failedLimitExceeded: "The maximum number of documents has been exceeded. Contact our sales department to increase your subscription.",
                    fields: {
                        dateFrom: "Date",
                        file: "File",
                        isPublished: "Published",
                        modified: "File modified",
                        timeFrom: "Time",
                        weekdays: "Weekdays",
                    },
                    newCondition: "New planning",
                    unknownRoom: "Unknown room",
                },
                elements: {
                    articleOverview: {
                        collapseAll: "Fold All",
                        expandAll: "Expand All",
                        failedLoading: "Articles could not be loaded.",
                        failedSort: "Order could not be changed.",
                        loadingItems: "Items are being loaded...",
                        newCategory: "New category",
                        newItem: "New item",
                        noItemsAvailable: "No items available in the offer",
                        noItemsText: "To this offer no categories have yet been added to which articles have been assigned.",
                        notAvailable: "Not available",
                        open: "Open",
                    },
                    fileUpload: {
                        invalidMime: "File type is not allowed. Please upload a file in the following format: <b>{{allowed}}</b>",
                        invalidSize: "File too large. Maximum size: <b>{{size}}</b>",
                        noFileSelected: "No file selected",
                        selectFile: "Select file",
                    },
                    imagePicker: {
                        invalidSize: "File too large. Maximum size: <b>{{size}}</b>",
                        noImage: "No image",
                        pleaseSelectImage: "Select image",
                        uploadFailed: "Image could not be saved.",
                    },
                    offerSchedulesEditor: {
                        autoAcceptUnassignedReservations: "Reservations that can’t be assigned to a table may be accepted automatically or presented to the operator for approval",
                        capacityAdjustmentPercentage: "Buffer / Overbooking (% of all seats)",
                        expectedLostSeatRatio: "Expected lost seats for unassigned reservations",
                        messageToUserAfterPendingOperatorReservation: "Message to user after pending (Operator) reservation",
                        operatorsCanBreakReservationRules: "Operators can break the rules",
                        operatorsMustAcceptOrDeclineReservation: "Operators must accept / decline (no immediate response – the calculated seating capacity is always respected)",
                        preOrders: "Pre-orders",
                        nodata: "No shift has been defined yet...",
                        preOrdertime: "Minimum pre-order period",
                        fulfilmentTimeInterval: "Fulfilment time interval",
                        defaultCapacityPerFulfilmentTime: "Default capacity per fulfilment time",
                        orders: "Orders",
                        operatorsMayEditOrders: "Operators may edit orders",
                        editOrderUpToFulfillmentTime: "up to … before fulfilment time",
                        endUsersMayCancelOrders: "End users may cancel",
                        refundability: "Refundability",
                        tableReservations: "Table reservations",
                        excludeTables: "Exclude tables",
                    },
                    optionAllocator: {
                        canUpTo: "options <b>can</b> be selected.",
                        maxPerOption: "Max. quantity per option",
                        maxSum: "Max. sum",
                        mustTotalUpTo: "options <b>must,</b> in total up to",
                        noOptionsSelected: "No options have been selected yet...",
                        preselection: "Preselection",
                    },
                    productionSiteAllocator: {
                        noProductionSites: "No Production site assigned yet...",
                        subtitle: "Not used if item is used as an option.",
                        printOrdersFrom: "Print orders from",
                    },
                    optionGroupAllocator: {
                        noGroups: "No option groups have yet been assigned...",
                    },
                    passwordInput: {
                        minLength: "At least {{count}} characters",
                        minNumbers: "At least {{count}} number",
                        minUpperCase: "At least {{count}} capital letter",
                    },
                    select: {
                        pleaseSelect: "Select",
                    },
                },
                enums: {
                    AttributeEffect: {
                        Include: "Include",
                        Exclude: "Exclude",
                    },
                    AttributeDisplayType: {
                        Icon: "Icon",
                        Flag: "Flag",
                        Filter: "Filter",
                    },
                    AttributeFlagDisplayTo: {
                        EndUsersAndOperators: "End users and operators",
                        EndUsers: "End users",
                        Operators: "Operators",
                    },
                    OperatorPlaySoundMode: {
                        FulfillmentInPreparation: "In preparation / Ready shortly",
                        FulfillmentReady: "Ready",
                        FulfillmentFulfilledNotPaid: "Fulfilled, not paid",
                    },
                    VoucherState: {
                        Enabled: "Enabled",
                        Expired: "Expired",
                        Cancelled: "Cancelled",
                        Redeemed: "Redeemed",
                    },
                    PaymentMethodMode: {
                        Online: "Online",
                        Offline: "Offline",
                    },
                    JoinPrintingItemsMode: {
                        PerOrder: "One printout per order",
                        PerItem: "One printout per item",
                        PerOrderAndPerItem: "One printout per order and one per item",
                    },
                    BuyerRequirement: {
                        EmailConfirmed: "Email confirmed",
                        None: "None",
                        SignedUp: "Registered with email",
                        Email: "Email",
                    },
                    CancellationClaimValue: {
                        None: "None",
                        MakeCancellationsAndRefunds: "Make cancellations and refunds",
                    },
                    OperatorTransferClaimValue: {
                        CannotTransfer: "Cannot transfer",
                        CanTransferOwn: "Can transfer own",
                        CanTransferAll: "Can transfer all",
                    },
                    OperatorItemAvailabilityAndStockLevelClaimValue: {
                        CannotEdit: "Cannot edit",
                        CanEdit: "Can edit",
                    },
                    CancellationMode: {
                        Amount: "Custom amount",
                        Positions: "Individual items",
                        WholeOrder: "Entire order",
                    },
                    CancellationReason: {
                        IncorrectIncompleteItemInformation: "Incorrect / incomplete item information",
                        OrderedIncorrectlyEndUser: "Ordered incorrectly (end user)",
                        OrderedIncorrectlyStaffMember: "Ordered incorrectly (staff member)",
                        EndUserChangedMind: "End user changed his/her mind",
                        ItemNotAvailable: "Item not available",
                        PriceWrong: "Price wrong",
                        BusinessClosedAtFulfilmentTime: "Business closed at fulfilment time",
                        LossBreakageStaffMember: "Loss / Breakage (staff member)",
                        LateFulfilment: "Late fulfilment",
                        BadQualityPresentation: "Bad quality / presentation",
                        LossBreakageEndUser: "Loss / Breakage (end user)",
                        CustomerDidNotPayWalkout: "Customer did not pay (walkout)",
                        Other: "Other",
                    },
                    CancellationState: {
                        Cancelled: "Cancelled",
                        PartiallyCancelled: "Partially cancelled",
                    },
                    ConsumptionSite: {
                        OffSite: "Out of house",
                        OnSite: "On site",
                    },
                    ConsumptionSiteDisplayMode: {
                        DeliveryAddress: "Delivery address",
                        PickUpAddress: "Pick-up address",
                        LocationAddress: "Location address",
                        None: "No",
                    },
                    Country: {
                        Austria: "Austria",
                        France: "France",
                        Germany: "Germany",
                        Italy: "Italy",
                        Netherlands: "Netherlands",
                        Switzerland: "Switzerland",
                    },
                    DashboardStatsPeriod: {
                        Today: "Today",
                        Date: "Date",
                        Yesterday: "Yesterday",
                        Past7Days: "Past 7 days",
                        Past8Days: "Past 8 days",
                        Past4Weeks: "Past 4 weeks",
                        Past5Weeks: "Past 5 weeks",
                        Past3Months: "Past 3 months",
                        Past12Months: "Past 12 months",
                        Past13Months: "Past 13 months",
                        CurrentWeek: "Current week",
                        LastWeek: "Last week",
                        CurrentMonth: "Current month",
                        LastMonth: "Last month",
                        CurrentYear: "Current year",
                        LastYear: "Last year",
                        TwoYearsAgo: "{{year}}",
                        ThreeYearsAgo: "{{year}}",
                        FourYearsAgo: "{{year}}",
                    },
                    DataOrigin: {
                        Portal: "Portal",
                        Pos: "POS",
                    },
                    DiscountAccessMode: {
                        Automatically: "Automatically",
                        Button: "By button",
                        Code: "Code required",
                        CodeOrButton: "With code or by button",
                    },
                    DiscountStatus: {
                        Cancelled: "Cancelled",
                        Enabled: "Enabled",
                        Expired: "Expired",
                        NotYetValid: "Not yet valid",
                    },
                    DiscountType: {
                        Absolute: "Absolute",
                        Percentage: "Percentage",
                    },
                    DocumentType: {
                        Pdf: "PDF",
                        Unknown: "Unknown",
                    },
                    VisibleEndUserProperties: {
                        None: "None",
                        FirstNameShortLastName: "First name, abbreviated last name",
                        Email: "E-mail address",
                        PhoneNumber: "Telephone number",
                        FirstNameLastName: "First name, last name",
                    },
                    PrintWhenOrderHasStatus: {
                        None: "None",
                        Confirmed: "Confirmed (Order for: Now) / Start of Production duration (Order for: Now or later)",
                        Ready: "Ready",
                    },
                    FulfillmentPositionDisplayMode: {
                        None: "None",
                        Duration: "Duration",
                        Position: "Position",
                    },
                    FulfillmentHandling: {
                        None: "None",
                        OnlyOperator: "Operator App",
                        OperatorAndApp: "Operator and Mobile App",
                    },
                    FulfillmentTimeMode: {
                        DeliveryTime: "Delivery time",
                        None: "No",
                        PickupTime: "Pick-up time",
                        Time: "Time (type unspecified)",
                    },
                    OneFulfillmentPerOrderMode: {
                        NotForced: "Not mandatory",
                        Forced: "Mandatory",
                        LetCustomerDecide: "Let orderer decide",
                    },
                    FulfilmentTileSize: {
                        Large: "Large",
                        Normal: "Normal",
                    },
                    IssueState: {
                        Closed: "Closed",
                        InProgress: "In progress",
                        Open: "Open",
                    },
                    Language: {
                        English: "English",
                        French: "French",
                        German: "German",
                        Italian: "Italian",
                    },
                    LocationState: {
                        Active: "Active",
                        Deleted: "Deleted",
                        Suspended: "Deactivated",
                    },
                    LogLevel: {
                        Error: "Error",
                        Info: "Info",
                        Warning: "Warning",
                        Information: "Info",
                        Trace: "Trace",
                        Critical: "Critical",
                        Debug: "Debug",
                        None: "None",
                    },
                    Month: {
                        April: "April",
                        August: "August",
                        December: "December",
                        February: "February",
                        January: "January",
                        July: "July",
                        June: "June",
                        March: "March",
                        May: "May",
                        November: "November",
                        October: "October",
                        September: "September",
                    },
                    NewOrdersViewMode: {
                        AtTheBottom: "At the bottom",
                        AtTheTop: "At the top",
                    },
                    OfferScheduleType: {
                        Closed: "Closed time",
                        DifferentOffer: "Deviating planning",
                        Standard: "Standard planning",
                    },
                    OperatorsCanBreakReservationRules: {
                        DoNotAllow: "Don’t allow",
                        AllowAndNotify: "Notify and allow",
                    },
                    OperatorsMustAcceptOrDeclineReservation: {
                        Never: "Never (highest automation, highest risk)",
                        OverbookingAbove: "Overbooking above %",
                        IfNoTableCanBeAssigned: "If no table can be assigned (includes all overbookings)",
                        Always: "Always (lowest automation)",
                    },
                    OrderState: {
                        Canceled: "Voided",
                        Closed: "Done",
                        FullyPaid: "Fully paid",
                        Open: "Open",
                        TimedOut: "Cancelled",
                        NotPaid: "Not paid",
                        ClosedNotPaid: "Fulfilled, not paid",
                        PartiallyPaid: "Partially paid",
                    },
                    OrderStateMode: {
                        All: "All",
                        NotFulfilled: "Not fulfilled",
                        Ready: "Ready",
                        NotPaid: "Not Paid",
                    },
                    PaymentProvider: {
                        Stripe: "Stripe",
                        Wallee: "Wallee",
                        PayTec: "PayTec",
                        Worldline: "Worldline",
                        PostFinance: "PostFinance",
                    },
                    PostFinanceContract: {
                        BrowserAndDevicePayment: "Browser and Payment device",
                        PaymentDeviceOnly: "Payment device only",
                    },
                    PaymentClient: {
                        Browser: "Browser",
                        PaymentDevice: "Payment device",
                    },
                    PaymentState: {
                        Confirmed: "Confirmed",
                        Declined: "Declined",
                        Intented: "Requested",
                    },
                    PreOrderRefundabilityType: {
                        Refundable: "Refundable",
                        NoRefundable: "Non-refundable",
                        RefundableWithFee: "Refundable with fee",
                        RefundOptionalForOperators: "Refund optional for operators",
                    },
                    PricingModel: {
                        Free: "Free",
                        Professional: "Premium",
                        Standard: "Standard",
                    },
                    PrintFontSize: {
                        Small: "Small",
                        Medium: "Medium",
                        Large: "Large",
                    },
                    PrintJobState: {
                        Failed: "Failed",
                        Pending: "Pending",
                        Printed: "Done",
                        Unconfirmed: "Unconfirmed",
                    },
                    PrintLayout: {
                        OrderAndPay76Mm: "Order & Pay (76mm, e.g. TM-U220B)",
                        OrderAndPay80Mm: "Order & Pay (80mm small, e.g. TM-M30)",
                        OrderAndPay80MmBig: "Order & Pay (80mm large, e.g. TM-T88)",
                    },
                    PrinterProtocolType: {
                        EscPos: "ESC/POS",
                    },
                    PrinterState: {
                        ErrorState: "Error",
                        Offline: "Offline",
                        OpenTrail: "Paper tray open",
                        OutOfPaper: "No paper",
                        Ready: "Ready",
                    },
                    ProductionTileViewMode: {
                        Detailed: "Detailed",
                        Overview: "Overview",
                    },
                    RatingValue: {
                        Bad: "Bad",
                        Good: "Good",
                        Ok: "OK",
                        VeryBad: "Very bad",
                        VeryGood: "Very good",
                    },
                    RefundMode: {
                        Offline: "Offline",
                        Online: "Online",
                    },
                    RefundType: {
                        OutsideTastier: "Outside Tastier",
                        StripeRefund: "Stripe refund",
                        WalleeRefund: "Wallee refund",
                    },
                    RoomShape: {
                        Landscape: "Landscape",
                        Portrait: "Portrait",
                        Square: "Square",
                    },
                    ReportClaimValue: {
                        DontHaveAccessInOperatorAndMobilePos: "Can’t view",
                        ViewOnlyOwnSalesAndRevenue: "View own",
                        ViewAllSalesAndRevenue: "View all",
                    },
                    SaleInquiryState: {
                        AutoEnroled: "Access automatically created",
                        Closed: "Closed",
                        FirstContact: "First contact / inquiry",
                        InProgress: "In progress",
                    },
                    SalesReportViewType: {
                        Article: "Items",
                        Category: "Reporting categories",
                        Detail: "Details (items with options)",
                    },
                    OfferCategoryHighlightType: {
                        Normal: "Normal",
                        FullWidth: "Full width",
                    },
                    PermalinkMode: {
                        None: "With no mode",
                        Kiosk: "With kiosk mode",
                        Normal: "With normal mode",
                    },
                    ServiceType: {
                        Covid: "Covid Check",
                        Documents: "Documents",
                        Order: "Order",
                        Ticketing: "Buy tickets",
                        Website: "Link",
                        Offer: "Offer",
                        Pay: "Pay",
                        RoomPlan: "Room Plan",
                    },
                    ShortWeekDay: {
                        Friday: "Fr",
                        Monday: "Mo",
                        Saturday: "Sa",
                        Sunday: "Su",
                        Thursday: "Th",
                        Tuesday: "Tu",
                        Wednesday: "We",
                    },
                    TableShape: {
                        Rectangle: "Rectangle",
                        Round: "Circle",
                    },
                    TaskExecutionState: {
                        Executing: "Is being executed",
                        Inactive: "Inactive",
                        Scheduled: "Scheduled",
                    },
                    TaskSuccessState: {
                        Failed: "Failed",
                        Success: "Successful",
                    },
                    Weekday: {
                        Friday: "Friday",
                        Monday: "Monday",
                        Saturday: "Saturday",
                        Sunday: "Sunday",
                        Thursday: "Thursday",
                        Tuesday: "Tuesday",
                        Wednesday: "Wednesday",
                    },
                    Weekday3Letters: {
                        Friday: "Fri",
                        Monday: "Mon",
                        Saturday: "Sat",
                        Sunday: "Sun",
                        Thursday: "Thu",
                        Tuesday: "Tue",
                        Wednesday: "Wed",
                    },
                    OrdererRequirement: {
                        NotRequired: "Not Required",
                        Required: "Required",
                        Optional: "Optional",
                        ConfirmedBlockOrder: "Confirmed (blocks order)",
                        ConfirmedCancelOrder: "Confirmed (cancels order after 15 min)",
                    },
                    CreateOrderBillWithName: {
                        OrderNumber: "Order number (if activated) / Order code",
                        PartyName: "Party name (if available) / Party number",
                    },
                },
                feedback: {
                    allRatings: "All ratings",
                    failedDelete: "Rating could not be deleted.",
                    fields: {
                        comment: "Comment",
                        created: "Submitted on",
                        rating: "Rating",
                    },
                    reallyDelete: "Should this rating really be deleted?",
                },
                general: {
                    copy: "Copy",
                    activate: "Activate",
                    all: "All",
                    alphabeticallyOrdered: "Alphabetical",
                    andMore: "and {{qty}} more",
                    anonymousUser: "Anonymous end user",
                    attention: "Attention",
                    back: "Back",
                    cancel: "Cancel",
                    change: "Change",
                    close: "Close",
                    confirm: "Confirm",
                    day: "Day",
                    deactivate: "Deactivate",
                    delete: "Delete",
                    deletedLocation: "Deleted location",
                    deletedOrder: "Deleted order",
                    deletedUser: "Deleted user",
                    download: "Download",
                    entities: {
                        fulfillmentGroups: "Fulfillment groups",
                        item: "Item",
                        location: "Location",
                        locations: "Locations",
                        offer: "Offer",
                        offerSchedule: "Planning",
                        offers: "Offers",
                        option: "Option",
                        optionGroup: "Option group",
                        optionGroups: "Option groups",
                        options: "Options",
                        order: "Order",
                        orders: "Orders",
                        orderApplications: "Order applications",
                        productionSite: "Production site",
                        productionSites: "Production sites",
                        room: "Room",
                        rooms: "Rooms",
                        shift: "Shift",
                        shifts: "Shifts",
                        table: "Table",
                        user: "User",
                        cancellation: "Cancellation",
                    },
                    export: "Export",
                    failed: "Failed",
                    failedCreate: "Entry could not be created.",
                    failedLoad: "Entry could not be loaded.",
                    failedLoadingData: "Data could not be loaded.",
                    failedRemove: "Entry could not be deleted.",
                    failedUpdate: "Entry could not be edited.",
                    fields: {
                        active: "Active",
                        available: "Available",
                        birthday: "Date of birth",
                        created: "Created",
                        date: "Date",
                        description: "Description",
                        designation: "Name",
                        displayName: "Deviating designation",
                        email: "Email",
                        firstName: "First name",
                        inactive: "Deactivated",
                        internalName: "Internal designation",
                        internalNote: "Internal note",
                        language: "Language",
                        lastName: "Last name",
                        name: "Name",
                        notes: "Notes",
                        oohPrice: "Out of house price",
                        phone: "Phone",
                        price: "Price",
                        sort: "Order",
                        sortOrder: "Order",
                        state: "Status",
                        time: "Time",
                        type: "Type",
                        open: "Open",
                    },
                    forward: "Continue",
                    loading: "Loading...",
                    locationSwitch: {
                        lastLocations: "Last locations",
                        noLocationsFound: "No locations found",
                        pleaseSelect: "Select a location...",
                        searchResults: "Search results",
                    },
                    month: "Month",
                    no: "No",
                    noItemsFound: "No records found",
                    noSearchResults: "No results found",
                    none: "None",
                    of: "out of",
                    pagination: "Records: {{from}} - {{until}}",
                    reallyRemove: "Are you sure you want to delete this entry permanently?",
                    remove: "Delete",
                    reset: "Reset",
                    save: "Save",
                    search: "Search",
                    searchTerm: "Search term...",
                    searchingResults: "Searching results...",
                    addNewValue: "Add “{{value}}”",
                    send: "Send",
                    successfullyCreated: "Entry successfully saved",
                    successfullyRemoved: "Entry successfully deleted",
                    successfullyUpdated: "Entry successfully edited",
                    timeFormat: {
                        agoCount: "{{count}} ago",
                        always: "Always",
                        daily: "Daily",
                        daysWithCount_one: "{{count}} day",
                        daysWithCount_other: "{{count}} days",
                        end: "End",
                        from: "from",
                        fromStart: "from {{start}}",
                        hoursWithCount_one: "{{count}} hour",
                        hoursWithCount_other: "{{count}} hours",
                        inCount: "in {{count}}",
                        minutesWithCount_one: "{{count}} minute",
                        minutesWithCount_other: "{{count}} minutes",
                        never: "Never",
                        notYet: "Not yet",
                        nowCurrentTime: "Now / current time",
                        range: "{{start}} to {{end}}",
                        secondsWithCount_one: "{{count}} second",
                        secondsWithCount_other: "{{count}} seconds",
                        start: "Start",
                        until: "until",
                        untilEnd: "until {{end}}",
                        weekdays: "Weekdays",
                        wholeDay: "full day",
                    },
                    today: "Today",
                    unknown: "Unknown",
                    yes: "Yes",
                    enabled: "Enabled",
                    disabled: "Disabled",
                },
                identicalEntry: {
                    title: "Identical text found",
                    message: "Another entry already exists with this exact text {{- texts}} in {{- languages}}. Please update the text to avoid a duplicate.",
                    editText: "Edit text",
                    saveAnyway: "Save anyway",
                    languages: {
                        English: "English",
                        German: "German",
                        French: "French",
                        Italian: "Italian",
                    },
                },
                issue: {
                    allStates: "All status",
                    fields: {
                        lastModified: "Last edit",
                        message: "Message",
                        received: "Received",
                    },
                },
                item: {
                    fields: {
                        categories: "Offer Categories",
                    },
                    insufficientStock: "Stock level too low. Please increase it, reduce minimum stock or deactivate stock function.",
                    articleMinQuantityGreaterThanOptionGroupMaxPerOption: "Min. quantity of {{article}} ({{articleMinQuantity}}) may not be greater than Max. quantity per option in Option group {{optionGroup}} ({{optionGroupMaxPerQuantity}}).",
                    noCategory: "No category",
                    noFulfillmentGroup: "No Fulfilment Group",
                    itemCopiedAndEditingNow: "Item copied. You are now editing the copied version of the item.",
                    itemDeletionFailed: "Item could not be deleted",
                    missingStandardServiceDurationForSeats: "Items with the resource “Seats” must have a Fulfilment group with a Standard service duration assigned.",
                    openPriceAndPricePerMinuteExclusive: "An item can't be both a price per minute item and an open price item.",
                    fulfillmentGroupCannotBeRemoved: "This Fulfilment group cannot be deleted because it has already been used in orders.",
                },
                location: {
                    allStates: "All status",
                    covidContactTracing: "Covid Check",
                    failedToExport: "Locations could not be exported.",
                    childLocations: {
                        internalNameOfAllChildLocationsMustBeUniqueError: "The internal name of all child locations must be unique.",
                        internalNameAlreadyInUseByAnotherLocationError: "The internal name is already in use by another location assigned to the same parent location.",
                        linkedLocationCircularRelationError: "A selected location is a parent location of the location currently being edited. Please remove the location and try again.",
                    },
                    psp: {
                        oneIconForAllStripePaymentMethods: "One icon for all Stripe payment methods",
                        oneIconForAllWalleePaymentMethods: "One icon for all Wallee payment methods",
                        missingDefaultPaymentMethodConfiguration: "Missing default configuration for payment method: {{paymentMethodName}}",
                    },
                    translation: {
                        key: "Key",
                        newEntry: "New entry",
                    },
                    twilio: {
                        accountSid: "Account SID",
                        create: "Create account",
                        created: "Twilio account was created successfully.",
                        currentConnected: "Linked account",
                        delete: "Delete",
                        deleted: "Twilio account has been deleted.",
                        failedCreate: "Twilio account could not be linked.",
                        failedDelete: "Twilio account could not be deleted.",
                        reallyCreate: "Do you really want to create an account in Twilio?",
                        reallyDelete: "Delete account permanently? The cost breakdown remains visible.",
                        serviceSid: "Service SID",
                    },
                    locationSlugNotAvailable: "This internet address is already taken, please modify it. Available: {{proposedSlugs}}",
                    locationHasOrdersOrPayments: "This location cannot be deleted due to orders and payments made.",
                    copyFailed: "The location has been saved, but it could not be copied.",
                },
                login: {
                    backToLogin: "Back to login",
                    enterValidEmail: "Please enter a valid email address.",
                    enterValidPassword: "Please enter a valid password.",
                    failedResetPw: "Unfortunately, the password could not be reset.",
                    featureNotImplemented: "Coming Soon - Corporate customers in the free model unfortunately do not have access yet. We are working on it and will inform you as soon as you can log in. For questions: marketing@tastier.ch",
                    login: "Login",
                    loginFailedBlocked: "Login failed due to missing permission. Please make sure you have activated your account.",
                    loginFailedCredentials: "Email or password invalid",
                    passwordLost: "Password forgotten?",
                    resetPassword: "Password Reset",
                    resetPasswordBtn: "Reset",
                    resetPwSuccess: "We have sent you an email to reset your password, please check your inbox and spam folder if necessary.",
                    signinBtn: "Log In",
                    emailAlreadyUsed: "This email is already taken.",
                },
                modal: {
                    addOptionGroup: {
                        newGroupBtn: "New option group",
                        options: "Options",
                        saveItems: "Save ({{items}} items)",
                        showsInItems: "Appears in items",
                        title: "Add option group",
                    },
                    addOptionToGroup: {
                        categories: "Categories",
                        newItemBtn: "New item",
                        saveItems: "Save ({{items}} items)",
                        title: "Add an option",
                    },
                    allocationHistoryExport: {
                        failedToExport: "Visits could not be exported.",
                        fromTo: "Date from / until",
                        selectLocation: "Select location...",
                        selectTable: "Select table...",
                        settings: "Settings",
                        title: "Export visits",
                    },
                    cancellation: {
                        cancellationFailed: "Order could not be cancelled.",
                        cancellationNotAllowedForPayment: "Cancellation is not allowed for this payment",
                        canStockBeReused: "Can the stock be reused?",
                        confirmMessage: "{{amt}} CHF - do you really want to cancel this? This cannot be reversed.",
                        confirmTitle: "Perform cancellation?",
                        failedLoading: "Order could not be loaded.",
                        loading: "Order is being loaded...",
                        notNow: "Not now",
                        notPaid: "Not paid",
                        offlineMode: "Offline refund",
                        paid: "Paid",
                        payment: "Payment",
                        paymentMethod: "Payment method",
                        positionSectionTitle: "Which units of <b>{{itemName}}</b> shall be cancelled?",
                        positionsText: "Select the items to be cancelled:",
                        reason: "Reason",
                        quantity: "Quantity",
                        status: "Status",
                        submitBtn: "Yes, cancel",
                        title: "Cancellation",
                        user: "User",
                        wholeOrderText: "The entire order will be cancelled.",
                        singleCancellationFailed: "Cancellation failed. Please try again.",
                        multipleCancellationsFailed: "At least one cancellation failed. Some payments may not have been refunded. Please try again.",
                        multiplePdPaymentCancellationsNotSupported: "This cancellation includes multiple payments via a payment device. Please limit it to a maximum of one payment device payment.",
                        twintOnlineRefundNotSupported: "Twint payments made on payment devices cannot be refunded.",
                    },
                    documentCondition: {
                        allRooms: "All rooms",
                        failedToSave: "Planning could not be edited.",
                        recurrence: "Shift",
                        time: "Time",
                        timeRange: "Date",
                        titleCreate: "Create planning",
                        titleEdit: "Planning",
                    },
                    documentSchedule: {
                        allRooms: "All rooms",
                        title: "Calendar view",
                    },
                    locationAccess: {
                        editLocation: "Location details",
                        failedGranting: "Permission could not be granted. Reason: {{reason}}",
                        grants: "Permission",
                        title: "Grant new permission",
                    },
                    locationExport: {
                        exportSetting: "Export settings",
                        failedExport: "Locations could not be exported.",
                        title: "Export locations",
                        viewType: "Type",
                        withRooms: "With rooms",
                        withoutRooms: "Normal",
                    },
                    locationSuspend: {
                        suspendBtn: "Deactivate",
                        suspendText: "This location is currently active. Do you want to deactivate this location?",
                        title: "Deactivate location",
                        unsuspendBtn: "Activate",
                        unsuspendText: "This location is currently inactive. Would you like to reactivate this location?",
                        unsuspendTitle: "Activate location",
                    },
                    offerRoomActivation: {
                        failedActivation: "Offer could not be activated.",
                        failedDeactivation: "Offer could not be deactivated.",
                        failedReset: "Reset failed",
                        reset: "Reset to planning",
                        successfulActivation: "Offer successfully activated. This applies until the next planned or manual deactivation.",
                        sucessfulDeactivation: "Offer successfully deactivated. This applies until the next planned or manual activation.",
                        sucessfulReset: "Reset successful",
                        title: "Activate / deactivate offer",
                    },
                    offerSchedule: {
                        title: "Calendar view",
                        differentOffers: "Different offers",
                    },
                    orderExport: {
                        failedExport: "Orders could not be exported.",
                        invalidDateRangeForOrder: "The length of the reporting period cannot exceed 8 days, and the start date must be within the last 90 days.",
                        settings: "Scope",
                        title: "Export orders",
                    },
                    stockExport: {
                        failedExport: "The stock could not be exported.",
                    },
                    printOrderReceipt: {
                        title: "Print receipt",
                    },
                    reprintOrder: {
                        failedSending: "Print job could not be sent.",
                        hint: "Reprint this order on the following production sites.",
                        printBtn: "Print",
                        settings: "Settings",
                        success: "Print job sent again.",
                        title: "Reprint order",
                    },
                    salesReportExport: {
                        dailySummaryReport: "Daily summary report",
                        exportSetting: "Scope",
                        failedExport: "Sales report could not be exported.",
                        invalidReportDateRangeException: "The reporting period must not exceed 93 days. For longer periods, please contact support.",
                        paymentMethodsReport: "Payment methods report",
                        title: "Sales report",
                        useDetailedNames: "Detailed representation",
                        specialReports: "Special reports",
                        levelOfDetail: "Level of detail",
                        orderFulfillmentReport: "Order fulfilment report",
                    },
                    sendOrderReceipt: {
                        failedSending: "Receipt could not be sent.",
                        receiver: "Recipient",
                        sentTo: "Receipt was sent to {{receiver}}",
                        settings: "Settings",
                        title: "Send Receipt",
                    },
                    transactionCompare: {
                        settings: "Settings",
                        dateFromTo: "Date from / to",
                        compareTransactions: "Compare transactions",
                        startComparison: "Start comparison",
                        totalCompared: "Total compared",
                        matches: "Matches",
                        differences: "Differences",
                        comparingHasMade: "Comparison is being created...",
                        comparingTransactionDescription: "This can take a few minutes. Please keep this window open during the comparison.",
                        comparisonFailed: "Comparison failed",
                        pleaseTryAgain: "Please try again later.",
                        transactionsCouldNotBeCompared: "Transactions cannot be compared.",
                        date: "Date",
                        transaction: "Transaction",
                        order: "Order",
                        comment: "Comment",
                        link: "Link",
                    },
                    locationPaymentMethod: {
                        addTitle: "Add location payment method",
                        editTitle: "Edit location payment method",
                        locationPaymentMethod: "Location payment method",
                        contract: "Contract",
                        name: "Name",
                        merchantId: "Merchant id",
                        mode: "Mode",
                        displayIcon: "Display icon",
                        logo: "Logo",
                        provider: "Provider",
                        additionalSettings: "Additional settings",
                        paymentMethodExternalId: "Payment method id",
                        isCreditDebitCard: "Operated by a card scheme company",
                        paymentDevice: "Payment device",
                        isEnabled: "Enabled",
                        order: "Order",
                        failedDelete: "Payment method could not be deleted.",
                        failedEdit: "Payment method could not be edited.",
                        deviceId: "Device Id",
                        allowTipOnlyOnDevice: "Allow tip entry only on device",
                        useTerminalApi: "Use terminal API",
                        apiToken: "API token",
                        integratorId: "Integrator ID",
                        revenueEffective: "Revenue-effective",
                        pairingCode: "Pairing code",
                        pairConnect: "Pair connect",
                        disconnect: "Disconnect",
                        deviceDisconnected: "The device has been disconnected successfully.",
                        deviceConnected: "The device has been connected successfully.",
                        deviceConnectFailed:
                            "The connection to the PayTec terminal failed. Check the pairing code or access token and make sure the terminal is online.",
                        connect: "Connect",
                    },
                    service: {
                        addTitle: "Add a service",
                        editTitle: "Edit service",
                        failedDelete: "Service could not be deleted.",
                        failedEdit: "Service could not be edited.",
                        icon: "Icon",
                        customIcon: "Custom icon",
                        customDesignation: "Custom designation",
                        service: "Service",
                        settings: "Settings",
                        image: "Image",
                    },
                    sessionExpired: {
                        signinBtn: "Log In",
                        text: "You have been logged out due to prolonged inactivity. Please log in again.",
                        title: "Session expired",
                    },
                    supportIssue: {
                        editRequest: "Edit request",
                        failedDelete: "Request could not be deleted.",
                        failedEdit: "Request could not be edited.",
                        title: "Edit support request",
                    },
                    voucherBulk: {
                        title: "New voucher",
                        internalNote: "Internal note",
                        isActive: "Enabled",
                        value: "Value",
                        voucherQty: "Quantity",
                        create: "Create",
                    },
                    tableBulk: {
                        action: "Operation",
                        conventionPlaceholder: "e.g. Table [Number]",
                        conventionText: 'e.g. enter "Table" and click "Insert number".',
                        createAtLeast: "At least 1 room must be created.",
                        deleteMultiple: "Delete multiple tables",
                        editCreateMultipleTables: "Create / edit multiple tables",
                        editPosId: "Edit POS ID",
                        execute: "Execute",
                        failedEdit: "Tables could not be edited.",
                        failedLimitExceeded: "The maximum number of tables has been exceeded. Contact our sales department to adjust your subscription.",
                        failedNoAffected: "No tables were modified by the operation.",
                        failedNoSubscription: "This location currently has no active subscription.",
                        hidePosId: "Hide POS ID",
                        insertNumber: "Insert number",
                        posId: "POS ID",
                        previewNoneDelete: "Attention: no tables will be deleted.",
                        previewPluralDelete: "Attention: {{amount}} tables will be deleted.",
                        previewPluralEdit: "Attention: {{amount}} tables will be overwritten.",
                        previewSingularDelete: "Attention: 1 table will be deleted.",
                        previewSingularEdit: "Attention: 1 table will be overwritten.",
                        seatCount: "Number of seats",
                        preferredMinimumOccupancy: "Preferred minimum occupancy",
                        selectRoom: "Select room...",
                        tableNrFromTo: "Table number from / to",
                        tableNrPlaceholder: "e.g. 10",
                        title: "Several tables",
                        whatToDo: "What should be done?",
                    },
                    transactionExport: {
                        allStates: "All status",
                        dateFromTo: "Date from / until",
                        exportSetting: "Settings",
                        failedExport: "Payments could not be exported.",
                        selectLocation: "Select location...",
                        title: "Export payments",
                    },
                    translation: {
                        addTitle: "Create entry",
                        editTitle: "Edit entry",
                        failedDelete: "Entry could not be deleted.",
                        failedEdit: "Text could not be edited.",
                        key: "Key",
                        systemText: "System text",
                        text: "Text",
                    },
                    userAccess: {
                        editLocation: "Edit location",
                        reportsViewOnlyOwnSalesAndRevenue: "View own (default): Sees only own sales / revenues (current simple Operator permission level)",
                        reportsViewAllSalesAndRevenue: "View all: See sales / revenues of all users / the entire Location (current Lead Operator permission level)",
                        failedEdit: "Permission could not be granted. Reason: {{reason}}",
                        grants: "Permission",
                        kind: "Type",
                        title: "Grant new permission",
                    },
                },
                offer: {
                    activate: "Activate",
                    activateDeactivate: "Activate / Deactivate",
                    activated: "Offer {{offer}} has been activated.",
                    deactivate: "Deactivate",
                    deactivated: "Offer {{offer}} has been deactivated.",
                    failedActivate: "Offer could not be activated.",
                    failedDeactivate: "Offer could not be deactivated.",
                    offerCopiedAndEditingNow: "Offer copied. You are now editing the copied version of the offer.",
                    orderApplications: "Order applications",
                },
                offerSchedule: {
                    allOffers: "All offers",
                    allOrderApplications: "All applications",
                    allRooms: "All rooms",
                    allTypes: "All types",
                    failedIntersection: "Overlap with {{link}}",
                    fields: {
                        currentActive: "Now active",
                        currentSchedule: "Current planning",
                        weekdayAndTime: "Weekdays & Time",
                    },
                    offerScheduleCopiedAndEditingNow: "Planning copied. You are now editing the copied version of the planning.",
                    failedPlanningOverlapsOtherPlanning: "This planning overlaps with another planning",
                },
                optionGroup: {
                    fields: {
                        appearsInItems: "Appears in items",
                    },
                    optionGroupCopiedAndEditingNow: "Option group copied. You are now editing the copied version.",
                },
                offerCategory: {
                    imagesNotCopied: "The images of the source category could not be copied. Please add them manually.",
                    offerCategoryCopiedAndEditingNow: "Offer category copied. You are now editing the copied version.",
                },
                order: {
                    allStates: "All status",
                    deletedTable: "Deleted table",
                    consumptionInclVat: "Consumption (incl. {{vat}}% VAT)",
                    fields: {
                        cancellation: "Cancellation",
                        consumption: "Consumption",
                        discount: "Discount",
                        dailyOrderIncrement: "Order number",
                        fulfillDate: "Date",
                        orderNumber: "Order code",
                        tip: "Tip",
                        useCase: "Application",
                        totalIncTip: "Total incl. tip",
                        total: "Total",
                        fulfilmentTime: "Fulfilment time",
                        scheduled: "Scheduled",
                    },
                },
                productionSite: {
                    cancelJob: "Cancel print job",
                    changeProtocolHint: "Changing the protocol or format deletes all print jobs that have not yet been executed.",
                    failedCancelJob: "Print job could not be cancelled.",
                    failedDeleteJob: "Print job could not be deleted.",
                    failedToSendTestPrint: "Test print could not be sent to printer.",
                    usedAsBackup: "This production site cannot be deleted because it is set as backup in: {{forwardingProductionSites}}. Remove it there first.",
                    fields: {
                        backupPrint: "Forwarded print",
                        backupSite: "Forwarding",
                        forwarded: "Forwarded",
                        isActive: "Activated",
                        lastCommunication: "Last communication",
                        layout: "Format",
                        protocol: "Protocol",
                    },
                    noJobs: "No print jobs available",
                    reallyCancel: "Should this print job really be cancelled?",
                    selectProductionSite: "Select production site...",
                    testPrintSent: "Test print has been sent to printer",
                },
                room: {
                    activateService: "Please activate a service",
                    addService: "Add a service",
                    failedChangingOrder: "Order could not be changed. Please reload the browser window.",
                    failedLimitExceeded: "The maximum number of rooms has been exceeded. Contact our sales department to increase your subscription.",
                    failedLoadingServices: "Services could not be loaded.",
                    failedTableReferences: "Room cannot be deleted because tables are assigned to it.",
                    fields: {
                        deallocationDelay: "Autom. checkout duration",
                        services: "Services",
                        endUserServices: "End user services",
                        operatorServices: "Operator services",
                    },
                },
                saleInquiry: {
                    allStates: "All status",
                    fields: {
                        company: "Business",
                        lastModified: "Last edit",
                        location: "City",
                        person: "User",
                        priceModel: "Model",
                        received: "Received",
                    },
                },
                signup: {
                    accessCreated: "Account created. To activate your account we have sent you an email to <b>{{email}}</b>, please check your inbox and spam folder if necessary.",
                    failed: "Registration could not be completed. Please try again.",
                    fields: {
                        password: "Password",
                    },
                    success: "You have already successfully registered and activated your access to the portal for corporate customers.",
                },
                stock: {
                    disableWarning: "Increase stock and set the item available in order to sell it",
                    failedSave: "Item stock could not be edited.",
                    fields: {
                        safetyStock: "Minimum stock",
                        stock: "Current stock",
                    },
                },
                subscription: {
                    allLocations: "All locations",
                    customForCustomer: "Customised",
                    fields: {
                        covid: "Covid Check",
                        documents: "Documents",
                        pay: "Pay",
                        preset: "Model",
                        validUntil: "Valid until",
                    },
                    unrestricted: "Unlimited",
                },
                system: {
                    fields: {
                        level: "Level",
                        message: "Message",
                        time: "Time",
                        title: "Title",
                    },
                },
                table: {
                    allDataOrigins: "All data sources",
                    allRooms: "All rooms",
                    allUsersDeallocated: "All users were removed from the table.",
                    downloadAllQr: "Download All QR Codes",
                    downloadAllQrText: "Use this to download all QR codes as a zip file. Copy the png files from the zip file into a word editor or graphics program. Add visitor notes and design your printouts (follow recommendations). Alternatively, Tastier offers this service.",
                    downloadBtn: "Download",
                    editPosId: "Edit POS ID",
                    failedDeallocating: "Users could not be removed from the table.",
                    failedReset: "Table could not be reset.",
                    fields: {
                        requireInfo: "Free text entry",
                        seats: "Number of seats",
                        tableNumber: "Table number",
                    },
                    hidePosId: "Hide POS ID",
                    permalink: {
                        copiedClipboard: "URL was copied to the clipboard.",
                        create: "Create direct link",
                        failedCreate: "Direct link could not be created.",
                        failedDelete: "Direct link could not be deleted.",
                        reallyDelete: "Should this direct link be permanently deleted?",
                        mode: "Mode",
                    },
                    successReset: "Table has been reset successfully.",
                    tableNumerInUse: "Table number or POS ID already in use",
                    table: "Table",
                },
                task: {
                    failedStart: "Task execution could not be started.",
                    fields: {
                        duration: "Duration",
                        interval: "Interval",
                        nextExecution: "Next execution",
                        result: "Result",
                        started: "Started",
                    },
                    started: "Task was started.",
                },
                transaction: {
                    allLocations: "All locations",
                    allStates: "All status",
                    fields: {
                        amount: "Amount",
                        fees: "Fee",
                        paymentMethod: "Payment method",
                        paymentMethodButton: "Payment method button",
                        provider: "PSP",
                        client: "Client",
                    },
                },
                useCase: {
                    preorderRoomsWithoutPlanningException: "This Order for: Now or Later Order Application is missing a Planning for: {{roomNames}}. Please add or extend a Planning.",
                    orderApplicationCopiedAndEditingNow: "Order application copied. You are now editing the copied version of the order application.",
                    failedDelete: "Application could not be removed because it is used by the {{dependingName}} service.",
                    tooManyQuickPaymentMethodsEnabled: "Up to {{maxEnabledPaymentMethodsCount}} quick payment methods can be enabled.",
                    atLeastOneDeliveryAreaRequiredError: "At least one delivery area is required",
                    minimumTotalUnitsPerOrderGreaterThanMaximumError: "The minimum total units per order cannot be greater than the maximum.",
                    minimumTotalUnitsPerOrderInvalidError: "The minimum total units per order must be at least 1.",
                    maximumTotalUnitsPerOrderInvalidError: "The maximum total units per order must be at least 1.",
                    fields: {
                        buyerRequirement: "Orderer requirement",
                        consumptionSite: "Place of consumption",
                        fulfillmentPositionDisplayMode: "Display fulfilment",
                        fulfillmentHandling: "Where?",
                        fulfillmentTimeMode: "Display fulfilment time",
                        tip: "Tip",
                        usePayment: "Payment",
                        usePreorder: "Order for",
                        maxPreorderPeriod: "Maximum pre-order period",
                    },
                    guest: "Guest",
                    payment: {
                        offline: "Offline Payment Methods",
                        online: "Online Payment Methods",
                        other: "Others",
                        paymentDevices: "Payment Devices",
                    },
                    preorderOff: "Now",
                    preorderOn: "Now or later",
                    waiter: "Servers",
                    operators: "Operators",
                    endUsers: "End users",
                    quickButton: "Quick payment method",
                    defaultMessageToUserBeforeOrder: "Hello, we look forward to your order.",
                    defaultOrderReminderPushNotificationMessage: "Your order is scheduled for pick-up in 1 h",
                    defaultOrderReminderPushNotificationTitle: "Pick-up scheduled",
                    pickupOrderPushNotificationTitle: "Pick up order",
                    pickupOrderPushNotificationMessage: "Your order is ready for pick-up",
                    notRevenueEffective: "Not revenue-effective",
                    permission: "Permission",
                },
                notification: {
                    notifiedWhenOrderReadyWithDuration: "You'll be notified when your order is ready for pick-up. Expected waiting time (indicative, may change anytime):",
                    notifiedWhenOrderReadyWithPosition: "You'll be notified when your order is ready for pick-up. Current position on the waiting list:",
                },
                user: {
                    allRoles: "All roles",
                    allUsers: "All users",
                    anonymous: "Anonymous",
                    anonymousUser: "Anonymous end user",
                    failedResetPassword: "Password could not be reset.",
                    fields: {
                        claimType: "Permission type",
                        devices: "Device",
                        emailConfirmed: "Email confirmed",
                        lastLogin: "Last login",
                        loginProviders: "Login via",
                    },
                    newGrant: "New permission",
                    noGrants: "No permission assigned",
                    onlyAnonymousUser: "Anonymous users only",
                    onlySignedUpUsers: "Registered users only",
                    passwordSet: "Password has been changed successfully.",
                    reallyRemoveGrant: "Really revoke the permission?",
                    removeGrant: "Revoke",
                    signedUp: "Registered",
                },
                voucher: {
                    alreadyUsedCannotBeDeleted: "The voucher was already used and it cannot be deleted.",
                    fields: {
                        created: "Created",
                        expiryDate: "Expiry date",
                        initialValue: "Initial value",
                        balance: "Balance",
                        code: "Voucher code",
                        internalNote: "Internal note",
                        isActive: "Enabled / Disabled",
                        cancellation: "Cancellation",
                    },
                    voucherCode: {
                        copiedClipboard: "Voucher code was copied to the clipboard.",
                    },
                },
                voucherDesign: {
                    addEmptyTextBox: "Add empty text box",
                    areYouSureYouWantToLeave: "You have unsaved changes. If you leave this tab, they will be lost. Do you want to continue?",
                    areYouSureYouWantToRemoveTemplate: "Are you sure you want to remove this voucher design template? This will restore the default template.",
                    backgroundColor: "Background color",
                    backgroundImage: "Background image",
                    clear: "Clear",
                    edit: "Edit",
                    emptyTextBox: "Empty text box",
                    errorRemovingTemplate: "An error occurred while removing the voucher design template.",
                    expirationDate: "Expiration date",
                    failedDeleteImage: "Failed to delete image. Please try again.",
                    imageLibrary: "Custom images",
                    invoiceAddress: "Invoice address",
                    loadingImages: "Loading images...",
                    locationAddress: "Location address",
                    locationName: "Location name",
                    logo: "Logo",
                    marginSize: "Margin size",
                    noImagesAvailable: "No images available",
                    pageSettings: "Page settings",
                    predefinedImages: "Images",
                    preview: "Preview",
                    qrCode: "QR Code",
                    reallyDeleteImage: 'Are you sure you want to delete "{{name}}"?',
                    toolbar: {
                        alignCenter: "Align center",
                        alignJustify: "Align justify",
                        alignLeft: "Align left",
                        alignRight: "Align right",
                        bold: "Bold",
                        bulletList: "Bullet list",
                        heading1: "Heading 1",
                        heading2: "Heading 2",
                        heading3: "Heading 3",
                        heading4: "Heading 4",
                        heading5: "Heading 5",
                        horizontalRule: "Horizontal rule",
                        italic: "Italic",
                        orderedList: "Ordered list",
                        paragraph: "Paragraph",
                        strike: "Strike",
                        textColor: "Text color",
                        textType: "Text type",
                        underline: "Underline",
                    },
                    upload: "Upload",
                    uploadedImage: "Uploaded image",
                    variables: "Text",
                    variablesNotPresent: "The following variables are not present in the document: {{variables}}",
                    voucherBalance: "Voucher balance",
                    voucherCode: "Voucher code",
                    voucherDesign: "Voucher design",
                },
            },
        },
        de: {
            translation: {
                activity: {
                    failedLoading: "Letzte Aktivitäten konnten nicht geladen werden.",
                    loadingActivities: "Letzte Aktivitäten werden geladen...",
                    noActivities: "Keine Aktivitäten verfügbar",
                },
                allocationHistory: {
                    allLocations: "Alle Standorte",
                    fields: {
                        additionalInfo: "Zusatzangabe",
                        allocated: "Besucht",
                        deallocated: "Verlassen",
                        isCovidComplete: "Covid valid",
                        isValid: "Gültig",
                        isSignedUp: "Registriert",
                        phone: "Telnr.",
                        zip: "Plz",
                    },
                },
                attribute: {
                    fields: {
                        displayAs: "Anzeigen als",
                        filter: "Filter",
                        icon: "Symbol",
                        isEnabled: "Aktiv",
                        type: "Typ",
                    },
                    types: {
                        standard: "Standard",
                        custom: "Benutzerdefiniert",
                    },
                    effectDescription: {
                        Include: "Wenn dieser Filter angewendet wird, werden nur Artikel mit diesem Attribut angezeigt.",
                        Exclude: "Wenn dieser Filter angewendet wird, werden nur Artikel ohne dieses Attribut angezeigt.",
                    },
                    standardFieldsLocked:
                        "Standardattribut: Name, Symbol und Filter sind für alle Standorte gleich und können nur zentral geändert werden.",
                    standardCannotBeDeleted:
                        "Ein Standardattribut steht allen Standorten zur Verfügung und kann nicht gelöscht werden. Deaktivieren Sie es stattdessen.",
                    cannotBeDisplayedAsFilter:
                        "Für dieses Standardattribut ist kein Filtereffekt definiert, daher kann es nicht als Filter angezeigt werden.",
                },
                receipt: {
                    receipt: "Quittung",
                    sendReceipt: "Quittung Schicken",
                    printReceipt: "Quittung Drucken",
                },
                apiVersion: {
                    fields: {
                        package: "Packet",
                        version: "Version",
                    },
                },
                print: {
                    orderReceiptPrinted: "Druckauftrag gesendet",
                    failedPrintReceipt: "Druckauftrag fehlgeschlagen",
                    noProductionSiteEnabledForRoom: "Diesem Tisch / Raum ist kein aktivierter Quittungsdrucker zugewiesen.",
                },
                cancellation: {
                    allModes: "Alle Modi",
                    allPositions: "Alle Positionen",
                    cancelPositions: "Einzelpositionen",
                    cancelWholePayment: "Gesamt zahlung",
                    fields: {
                        amount: "Betrag",
                        cancelled: "Storniert",
                        executedBy: "Ausgeführt von",
                        mode: "Modus",
                        positions: "Positionen",
                        reason: "Grund",
                        refund: "Rückerstattung",
                        refunded: "Erstattet",
                    },
                },
                dashboard: {
                    allocations: "Check-Ins",
                    signups: "Registrierungen",
                    turnover: "Umsatz",
                    selectLocation: "Bitte wählen Sie einen Standort aus, um Berichte anzusehen.",
                    salesChart: {
                        chartTitle: "Umsatz inkl. Trinkgeld",
                        orders: "Bestellungen",
                        payments: "Zahlungen",
                    },
                    salesByPaymentMethodChart: {
                        chartTitle: "Zahlungsmittel",
                        onlineBrowser: "Online - Browser",
                        onlinePaymentDevice: "Online - Zahlungsgerät",
                        offline: "Offline",
                        nre: "Nicht umsatzwirksam",
                    },
                    cancellationsChart: {
                        chartTitle: "Stornierungen",
                        noReason: "Kein Grund",
                    },
                    kpiSummary: {
                        tip: "Trinkgeld",
                        netSalesNetExclTip: "Nettoumsatz (exkl. Trinkgeld)",
                        grossSalesNetExclTip: "Umsatz (exkl. Trinkgeld)",
                        avgOrder: "Durchschnittsbestellung",
                        avgPayment: "Durchschnittszahlung",
                        avgBill: "Durchschnittsrechnung",
                        avgBillDurationMins: "Durchschnittliche Rechnungsdauer",
                    },
                },
                discount: {
                    fields: {
                        appliesTo: "Gilt für",
                        appliesToAll: "Alle",
                        name: "Bezeichnung",
                        order: "Reihenfolge",
                        status: "Status",
                        timesUsed: "Male verwendet",
                        totalDiscounted: "Gesamt rabattiert",
                        type: "Art",
                        value: "Wert",
                    },
                    discountCode: {
                        copiedClipboard: "Rabattcode wurde in die Zwischenablage kopiert.",
                    },
                    cancelDiscountPopupMessage: "Rabatt stornieren? Dies kann nicht rückgängig gemacht werden. Passen Sie Beginn / Ende an, wenn Sie ihn später wieder verwenden möchten.",
                },
                documents: {
                    allRooms: "Alle Räume",
                    failedLimitExceeded: "Die maximale Anzahl Dokumente wurde überschritten. Nehmen Sie mit unserem Verkauf Kontakt auf um Ihr Abonnement zu vergrössern.",
                    fields: {
                        dateFrom: "Datum",
                        file: "Datei",
                        isPublished: "Publiziert",
                        modified: "Datei geändert",
                        timeFrom: "Uhrzeit",
                        weekdays: "Wochentage",
                    },
                    newCondition: "Neue Planung",
                    unknownRoom: "Unbekannter Raum",
                },
                elements: {
                    articleOverview: {
                        collapseAll: "Alle Einklappen",
                        expandAll: "Alle Ausklappen",
                        failedLoading: "Artikel konnten nicht geladen werden.",
                        failedSort: "Reihenfolge konnte nicht verändert werden.",
                        loadingItems: "Artikel werden geladen...",
                        newCategory: "Neue Kategorie",
                        newItem: "Neuer Artikel",
                        noItemsAvailable: "Keine Artikel im Angebot verfügbar",
                        noItemsText: "Diesem Angebot sind noch keine Kategorien hinzugefügt, denen Artikel zugeteilt wurden.",
                        notAvailable: "Nicht verfügbar",
                        open: "Offen",
                    },
                    fileUpload: {
                        invalidMime: "Dateityp ist nicht erlaubt. Bitte laden Sie eine Datei in folgendem Format hoch: <b>{{allowed}}</b>",
                        invalidSize: "Datei zu gross. Maximale Grösse: <b>{{size}}</b>",
                        noFileSelected: "Keine Datei ausgewählt",
                        selectFile: "Datei auswählen",
                    },
                    imagePicker: {
                        invalidSize: "Datei zu gross. Maximale Grösse: <b>{{size}}</b>",
                        noImage: "Kein Bild",
                        pleaseSelectImage: "Bild auswählen",
                        uploadFailed: "Bild konnte nicht gespeichert werden.",
                    },
                    offerSchedulesEditor: {
                        autoAcceptUnassignedReservations: "Reservationen, die keinem Tisch zugewiesen werden können, können automatisch angenommen oder dem Betreiber zur Genehmigung unterbreitet werden",
                        capacityAdjustmentPercentage: "Puffer / Überbuchung (% aller Sitzplätze)",
                        expectedLostSeatRatio: "Erwarteter Sitzplatzverlust für nicht zugewiesene Reservierungen",
                        messageToUserAfterPendingOperatorReservation: "Message to user after pending (Operator) reservation",
                        operatorsCanBreakReservationRules: "Betreiber können die Regeln umgehen",
                        operatorsMustAcceptOrDeclineReservation: "Betreiber müssen annehmen / ablehnen (keine sofortige Rückmeldung – die berechnete Sitzplatzkapazität wird stets berücksichtigt)",
                        preOrders: "Vorbestellungen",
                        nodata: "Es wurde noch keine Schicht definiert...",
                        preOrdertime: "Mindestvorbestelldauer",
                        fulfilmentTimeInterval: "Erfüllungszeitintervall",
                        defaultCapacityPerFulfilmentTime: "Standardkapazität pro Erfüllungszeit",
                        orders: "Bestellungen",
                        operatorsMayEditOrders: "Betreiber können Bestellungen bearbeiten",
                        editOrderUpToFulfillmentTime: "bis … vor Erfüllungszeit",
                        endUsersMayCancelOrders: "Endbenutzer dürfen stornieren",
                        refundability: "Rückerstattungsfähigkeit",
                        tableReservations: "Tischreservierungen",
                        excludeTables: "Tische ausschliessen",
                    },
                    optionAllocator: {
                        canUpTo: "Optionen <b>können</b> gewählt werden.",
                        maxPerOption: "Max. Anzahl je Option",
                        maxSum: "Max. Summe",
                        mustTotalUpTo: "Optionen <b>müssen,</b> insg. bis zu",
                        noOptionsSelected: "Es wurden noch keine Optionen ausgewählt...",
                        preselection: "Vorauswahl",
                    },
                    productionSiteAllocator: {
                        noProductionSites: "Noch kein Produktionsort zugewiesen…",
                        subtitle: "Wird nicht verwendet, wenn Artikel als Option verwendet wird.",
                        printOrdersFrom: "Bestellungen drucken von",
                    },
                    optionGroupAllocator: {
                        noGroups: "Es wurden noch keine Optionsgruppe zugewiesen...",
                    },
                    passwordInput: {
                        minLength: "Mindestens {{count}} Zeichen",
                        minNumbers: "Mindestens {{count}} Zahl",
                        minUpperCase: "Mindestens {{count}} Grossbuchstabe",
                    },
                    select: {
                        pleaseSelect: "Auswählen",
                    },
                },
                enums: {
                    AttributeEffect: {
                        Include: "Einschliessen",
                        Exclude: "Ausschliessen",
                    },
                    AttributeDisplayType: {
                        Icon: "Symbol",
                        Flag: "Flag",
                        Filter: "Filter",
                    },
                    AttributeFlagDisplayTo: {
                        EndUsersAndOperators: "Endnutzer und Betreiber",
                        EndUsers: "Endnutzer",
                        Operators: "Betreiber",
                    },
                    OperatorPlaySoundMode: {
                        FulfillmentInPreparation: "In Vorbereitung / In Kürze bereit",
                        FulfillmentReady: "Bereit",
                        FulfillmentFulfilledNotPaid: "Erfüllt, nicht bezahlt",
                    },
                    VoucherState: {
                        Enabled: "Aktiviert",
                        Expired: "Verfallen",
                        Cancelled: "Storniert",
                        Redeemed: "Eingelöst",
                    },
                    PaymentMethodMode: {
                        Online: "Online",
                        Offline: "Offline",
                    },
                    JoinPrintingItemsMode: {
                        PerOrder: "Ein Ausdruck pro Bestellung",
                        PerItem: "Ein Ausdruck pro Artikel",
                        PerOrderAndPerItem: "Ein Ausdruck pro Bestellung und einer pro Artikel",
                    },
                    BuyerRequirement: {
                        EmailConfirmed: "E-Mail bestätigt",
                        None: "Keine",
                        SignedUp: "Mit E-Mail registriert",
                        Email: "E-Mail",
                    },
                    CancellationClaimValue: {
                        None: "Keine",
                        MakeCancellationsAndRefunds: "Stornierungen und Rückerstattungen vornehmen",
                    },
                    OperatorTransferClaimValue: {
                        CannotTransfer: "Kann nicht übertragen",
                        CanTransferOwn: "Kann eigene übertragen",
                        CanTransferAll: "Kann alle übertragen",
                    },
                    OperatorItemAvailabilityAndStockLevelClaimValue: {
                        CannotEdit: "Kann nicht bearbeiten",
                        CanEdit: "Kann bearbeiten",
                    },
                    CancellationMode: {
                        Amount: "Manueller Betrag",
                        Positions: "Einzelpositionen",
                        WholeOrder: "Gesamte Bestellung",
                    },
                    CancellationReason: {
                        IncorrectIncompleteItemInformation: "Falsche / unvollständige Artikelinformationen",
                        OrderedIncorrectlyEndUser: "Falsch bestellt (Endnutzer)",
                        OrderedIncorrectlyStaffMember: "Falsch bestellt (Mitarbeiter)",
                        EndUserChangedMind: "Endnutzer hat seine Meinung geändert",
                        ItemNotAvailable: "Artikel nicht verfügbar",
                        PriceWrong: "Preis falsch",
                        BusinessClosedAtFulfilmentTime: "Geschäft zur Erfüllungszeit geschlossen",
                        LossBreakageStaffMember: "Bruch / Verlust (Mitarbeiter)",
                        LateFulfilment: "Verspätete Erfüllung",
                        BadQualityPresentation: "Schlechte Qualität / Präsentation",
                        LossBreakageEndUser: "Bruch / Verlust (Endnutzer)",
                        CustomerDidNotPayWalkout: "Kunde hat nicht bezahlt (Zechprellerei)",
                        Other: "Anderer",
                    },
                    CancellationState: {
                        Cancelled: "Storniert",
                        PartiallyCancelled: "Teilstorniert",
                    },
                    ConsumptionSite: {
                        OffSite: "Ausser Haus",
                        OnSite: "Vor Ort",
                    },
                    ConsumptionSiteDisplayMode: {
                        DeliveryAddress: "Lieferadresse",
                        PickUpAddress: "Abholadresse",
                        LocationAddress: "Standortadresse",
                        None: "Nein",
                    },
                    Country: {
                        Austria: "Österreich",
                        France: "Frankreich",
                        Germany: "Deutschland",
                        Italy: "Italien",
                        Netherlands: "Niederlande",
                        Switzerland: "Schweiz",
                    },
                    DashboardStatsPeriod: {
                        Today: "Heute",
                        Date: "Datum",
                        Yesterday: "Gestern",
                        Past7Days: "Letzte 7 Tage",
                        Past8Days: "Letzte 8 Tage",
                        Past4Weeks: "Letzte 4 Wochen",
                        Past5Weeks: "Letzte 5 Wochen",
                        Past3Months: "Letzte 3 Monate",
                        Past12Months: "Letzte 12 Monate",
                        Past13Months: "Letzte 13 Monate",
                        CurrentWeek: "Aktuelle Woche",
                        LastWeek: "Letzte Woche",
                        CurrentMonth: "Aktueller Monat",
                        LastMonth: "Letzter Monat",
                        CurrentYear: "Aktuelles Jahr",
                        LastYear: "Letztes Jahr",
                        TwoYearsAgo: "{{year}}",
                        ThreeYearsAgo: "{{year}}",
                        FourYearsAgo: "{{year}}",
                    },
                    DataOrigin: {
                        Portal: "Portal",
                        Pos: "POS",
                    },
                    DiscountAccessMode: {
                        Automatically: "Automatisch",
                        Button: "Per Button",
                        Code: "Code erforderlich",
                        CodeOrButton: "Mit Code oder per Button",
                    },
                    DiscountStatus: {
                        Cancelled: "Storniert",
                        Enabled: "Aktiviert",
                        Expired: "Verfallen",
                        NotYetValid: "Noch nicht gültig",
                    },
                    DiscountType: {
                        Absolute: "Absolut",
                        Percentage: "Prozentsatz",
                    },
                    DocumentType: {
                        Pdf: "PDF",
                        Unknown: "Unbekannt",
                    },
                    VisibleEndUserProperties: {
                        None: "Keine",
                        FirstNameShortLastName: "Vorname, abgekürzter Nachname",
                        Email: "E-Mail Adresse",
                        PhoneNumber: "Telefonnummer",
                        FirstNameLastName: "Vorname, Nachname",
                    },
                    PrintWhenOrderHasStatus: {
                        None: "Keine",
                        Confirmed: "Bestätigt (Bestellen für: Jetzt) / Beginn der Produktionsdauer (Bestellen für: Jetzt oder später)",
                        Ready: "Bereit",
                    },
                    FulfillmentPositionDisplayMode: {
                        None: "Keine",
                        Duration: "Dauer",
                        Position: "Position",
                    },
                    FulfillmentHandling: {
                        None: "Keine",
                        OnlyOperator: "Betreiber-App",
                        OperatorAndApp: "Betreiber- und Mobile App",
                    },
                    FulfillmentTimeMode: {
                        DeliveryTime: "Lieferzeit",
                        None: "Nein",
                        PickupTime: "Abholzeit",
                        Time: "Zeit (Typ nicht spezifiziert)",
                    },
                    OneFulfillmentPerOrderMode: {
                        NotForced: "Nicht zwingend",
                        Forced: "Zwingend",
                        LetCustomerDecide: "Besteller entscheiden lassen",
                    },
                    FulfilmentTileSize: {
                        Large: "Gross",
                        Normal: "Normal",
                    },
                    IssueState: {
                        Closed: "Geschlossen",
                        InProgress: "In Bearbeitung",
                        Open: "Offen",
                    },
                    Language: {
                        English: "Englisch",
                        French: "Französisch",
                        German: "Deutsch",
                        Italian: "Italienisch",
                    },
                    LocationState: {
                        Active: "Aktiv",
                        Deleted: "Gelöscht",
                        Suspended: "Deaktiviert",
                    },
                    LogLevel: {
                        Error: "Fehler",
                        Info: "Info",
                        Warning: "Warnung",
                        Information: "Info",
                        Trace: "Trace",
                        Critical: "Kritisch",
                        Debug: "Debug",
                        None: "Keiner",
                    },
                    Month: {
                        April: "April",
                        August: "August",
                        December: "Dezember",
                        February: "Februar",
                        January: "Januar",
                        July: "Juli",
                        June: "Juni",
                        March: "März",
                        May: "Mai",
                        November: "November",
                        October: "Oktober",
                        September: "September",
                    },
                    NewOrdersViewMode: {
                        AtTheBottom: "Unten",
                        AtTheTop: "Oben",
                    },
                    OfferScheduleType: {
                        Closed: "Geschlossen-Zeit",
                        DifferentOffer: "Abweichende Planung",
                        Standard: "Standardplanung",
                    },
                    OperatorsCanBreakReservationRules: {
                        DoNotAllow: "Nicht erlauben",
                        AllowAndNotify: "Benachrichtigen und erlauben",
                    },
                    OperatorsMustAcceptOrDeclineReservation: {
                        Never: "Nie (höchste Automatisierung, höchstes Risiko)",
                        OverbookingAbove: "Überbuchung über %",
                        IfNoTableCanBeAssigned: "Wenn kein Tisch zugewiesen werden kann (schliesst alle Überbuchungen ein)",
                        Always: "Immer (keine Automatisierung, geringstes Risiko)",
                    },
                    OrderState: {
                        Canceled: "Storniert",
                        Closed: "Erledigt",
                        FullyPaid: "Vollständig bezahlt",
                        Open: "Offen",
                        TimedOut: "Abgebrochen",
                        NotPaid: "Nicht bezahlt",
                        ClosedNotPaid: "Erfüllt, nicht bezahlt",
                        PartiallyPaid: "Teilweise bezahlt",
                    },
                    OrderStateMode: {
                        All: "Alle",
                        NotFulfilled: "Nicht erfüllt",
                        Ready: "Bereit",
                        NotPaid: "Nicht bezahlt",
                    },
                    PaymentProvider: {
                        Stripe: "Stripe",
                        Wallee: "Wallee",
                        PayTec: "PayTec",
                        Worldline: "Worldline",
                        PostFinance: "PostFinance",
                    },
                    PostFinanceContract: {
                        BrowserAndDevicePayment: "Browser und Zahlungsgerät",
                        PaymentDeviceOnly: "Nur Zahlungsgerät",
                    },
                    PaymentClient: {
                        Browser: "Browser",
                        PaymentDevice: "Zahlungsgerät",
                    },
                    PaymentState: {
                        Confirmed: "Bestätigt",
                        Declined: "Abgelehnt",
                        Intented: "Angefordert",
                    },
                    PreOrderRefundabilityType: {
                        Refundable: "Erstattungsfähig",
                        NoRefundable: "Nicht erstattungsfähig",
                        RefundableWithFee: "Erstattungsfähig mit Gebühr",
                        RefundOptionalForOperators: "Rückerstattung optional für Betreiber",
                    },
                    PricingModel: {
                        Free: "Free",
                        Professional: "Premium",
                        Standard: "Standard",
                    },
                    PrintFontSize: {
                        Small: "Klein",
                        Medium: "Medium",
                        Large: "Large",
                    },
                    PrintJobState: {
                        Failed: "Fehlgeschlagen",
                        Pending: "Ausstehend",
                        Printed: "Fertig",
                        Unconfirmed: "Unbestätigt",
                    },
                    PrintLayout: {
                        OrderAndPay76Mm: "Order & Pay (76mm, z.B. TM-U220B)",
                        OrderAndPay80Mm: "Order & Pay (80mm klein, z.B. TM-M30)",
                        OrderAndPay80MmBig: "Order & Pay (80mm gross, z.B. TM-T88)",
                    },
                    PrinterProtocolType: {
                        EscPos: "ESC/POS",
                    },
                    PrinterState: {
                        ErrorState: "Fehler",
                        Offline: "Offline",
                        OpenTrail: "Papierfach offen",
                        OutOfPaper: "Kein Papier",
                        Ready: "Bereit",
                    },
                    ProductionTileViewMode: {
                        Detailed: "Detailed",
                        Overview: "Overview",
                    },
                    RatingValue: {
                        Bad: "Schlecht",
                        Good: "Gut",
                        Ok: "OK",
                        VeryBad: "Sehr schlecht",
                        VeryGood: "Sehr gut",
                    },
                    RefundMode: {
                        Offline: "Offline",
                        Online: "Online",
                    },
                    RefundType: {
                        OutsideTastier: "Ausserhalb von Tastier",
                        StripeRefund: "Stripe Rückerstattung",
                        WalleeRefund: "Wallee Rückerstattung",
                    },
                    RoomShape: {
                        Landscape: "Quer",
                        Portrait: "Hoch",
                        Square: "Quadratisch",
                    },
                    ReportClaimValue: {
                        DontHaveAccessInOperatorAndMobilePos: "Sieht keine",
                        ViewOnlyOwnSalesAndRevenue: "Sieht eigene",
                        ViewAllSalesAndRevenue: "Sieht alle",
                    },
                    SaleInquiryState: {
                        AutoEnroled: "Zugang automatisch erstellt",
                        Closed: "Geschlossen",
                        FirstContact: "Erstkontakt / Anfrage",
                        InProgress: "In Bearbeitung",
                    },
                    SalesReportViewType: {
                        Article: "Artikel",
                        Category: "Berichtskategorien",
                        Detail: "Details (Artikel mit Optionen)",
                    },
                    OfferCategoryHighlightType: {
                        Normal: "Normal",
                        FullWidth: "Volle Breite",
                    },
                    PermalinkMode: {
                        None: "Ohne Modus",
                        Kiosk: "Mit Kiosk-Modus",
                        Normal: "Mit normalem Modus",
                    },
                    ServiceType: {
                        Covid: "Covid-Check",
                        Documents: "Dokumente",
                        Order: "Bestellen",
                        Ticketing: "Tickets kaufen",
                        Website: "Link",
                        Offer: "Angebot",
                        Pay: "Bezahlen",
                        RoomPlan: "Raumplan",
                    },
                    ShortWeekDay: {
                        Friday: "Fr",
                        Monday: "Mo",
                        Saturday: "Sa",
                        Sunday: "So",
                        Thursday: "Do",
                        Tuesday: "Di",
                        Wednesday: "Mi",
                    },
                    TableShape: {
                        Rectangle: "Rechteck",
                        Round: "Kreis",
                    },
                    TaskExecutionState: {
                        Executing: "Wird ausgeführt",
                        Inactive: "Inaktiv",
                        Scheduled: "Geplant",
                    },
                    TaskSuccessState: {
                        Failed: "Fehlgeschlagen",
                        Success: "Erfolgreich",
                    },
                    Weekday: {
                        Friday: "Freitag",
                        Monday: "Montag",
                        Saturday: "Samstag",
                        Sunday: "Sonntag",
                        Thursday: "Donnerstag",
                        Tuesday: "Dienstag",
                        Wednesday: "Mittwoch",
                    },
                    Weekday3Letters: {
                        Friday: "Fre",
                        Monday: "Mon",
                        Saturday: "Sam",
                        Sunday: "Son",
                        Thursday: "Don",
                        Tuesday: "Die",
                        Wednesday: "Mit",
                    },
                    OrdererRequirement: {
                        NotRequired: "Nicht erforderlich",
                        Required: "Erforderlich",
                        Optional: "Optional",
                        ConfirmedBlockOrder: "Bestätigt (blockiert Bestellung)",
                        ConfirmedCancelOrder: "Bestätigt (storniert Bestellung nach 15 Min)",
                    },
                    CreateOrderBillWithName: {
                        OrderNumber: "Bestellnummer (falls aktiviert) / Bestellcode",
                        PartyName: "Gruppenname (falls verfügbar) / Gruppennummer",
                    },
                },
                feedback: {
                    allRatings: "Alle Bewertungen",
                    failedDelete: "Bewertung konnte nicht gelöscht werden.",
                    fields: {
                        comment: "Bemerkung",
                        created: "Abgegeben am",
                        rating: "Bewertung",
                    },
                    reallyDelete: "Soll diese Bewertung wirklich gelöscht werden?",
                },
                general: {
                    copy: "Kopieren",
                    activate: "Aktivieren",
                    all: "Alle",
                    alphabeticallyOrdered: "Alphabetisch",
                    andMore: "und {{qty}} weitere",
                    anonymousUser: "Anonymer Endnutzer",
                    attention: "Achtung",
                    back: "Zurück",
                    cancel: "Abbrechen",
                    change: "Ändern",
                    close: "Schliessen",
                    confirm: "Bestätigen",
                    day: "Tag",
                    deactivate: "Deaktivieren",
                    delete: "Löschen",
                    deletedLocation: "Gelöschter Standort",
                    deletedOrder: "Gelöschte Bestellung",
                    deletedUser: "Gelöschter Nutzer",
                    download: "Herunterladen",
                    entities: {
                        fulfillmentGroups: "Erfüllungsgruppen",
                        item: "Artikel",
                        location: "Standort",
                        locations: "Standorte",
                        offer: "Angebot",
                        offerSchedule: "Planung",
                        offers: "Angebote",
                        option: "Option",
                        optionGroup: "Optionsgruppe",
                        optionGroups: "Optionsgruppen",
                        options: "Optionen",
                        order: "Bestellung",
                        orders: "Bestellungen",
                        orderApplications: "Bestellanwendungen",
                        productionSite: "Produktionsort",
                        productionSites: "Produktionsorte",
                        room: "Raum",
                        rooms: "Räume",
                        shift: "Schicht",
                        shifts: "Schichten",
                        table: "Tisch",
                        user: "Nutzer",
                        cancellation: "Stornierung",
                    },
                    export: "Exportieren",
                    failed: "Fehlgeschlagen",
                    failedCreate: "Eintrag konnte nicht erstellt werden.",
                    failedLoad: "Eintrag konnte nicht geladen werden.",
                    failedLoadingData: "Daten konnten nicht geladen werden.",
                    failedRemove: "Eintrag konnte nicht gelöscht werden.",
                    failedUpdate: "Eintrag konnte nicht bearbeitet werden.",
                    fields: {
                        active: "Aktiv",
                        available: "Verfügbar",
                        birthday: "Geburtsdatum",
                        created: "Erstellt",
                        date: "Datum",
                        description: "Beschreibung",
                        designation: "Bezeichnung",
                        displayName: "Abweichende Bezeichnung",
                        email: "E-Mail",
                        firstName: "Vorname",
                        inactive: "Deaktiviert",
                        internalName: "Interne Bezeichnung",
                        internalNote: "Interne Notiz",
                        language: "Sprache",
                        lastName: "Nachname",
                        name: "Name",
                        notes: "Notizen",
                        oohPrice: "Ausser Haus Preis",
                        phone: "Telefon",
                        price: "Preis",
                        sort: "Reihenfolge",
                        sortOrder: "Reihenfolge",
                        state: "Status",
                        time: "Uhrzeit",
                        type: "Art",
                        open: "Offen",
                    },
                    forward: "Weiter",
                    loading: "Wird geladen...",
                    locationSwitch: {
                        lastLocations: "Letzte Standorte",
                        noLocationsFound: "Keine Standorte gefunden",
                        pleaseSelect: "Standort auswählen...",
                        searchResults: "Suchresultate",
                    },
                    month: "Monat",
                    no: "Nein",
                    noItemsFound: "Keine Einträge gefunden",
                    noSearchResults: "Keine Resultate gefunden",
                    none: "Keine",
                    of: "von",
                    pagination: "Einträge: {{from}} - {{until}}",
                    reallyRemove: "Sind Sie sicher, dass Sie diesen Eintrag endgültig löschen möchten?",
                    remove: "Löschen",
                    reset: "Zurücksetzen",
                    save: "Speichern",
                    search: "Suchen",
                    searchTerm: "Suchbegriff...",
                    searchingResults: "Suche Resultate...",
                    addNewValue: "„{{value}}“ hinzufügen",
                    send: "Senden",
                    successfullyCreated: "Eintrag erfolgreich gespeichert",
                    successfullyRemoved: "Eintrag erfolgreich gelöscht",
                    successfullyUpdated: "Eintrag erfolgreich bearbeitet.",
                    timeFormat: {
                        agoCount: "vor {{count}}",
                        always: "Immer",
                        daily: "Täglich",
                        daysWithCount_one: "{{count}} Tag",
                        daysWithCount_other: "{{count}} Tage",
                        end: "Ende",
                        from: "ab",
                        fromStart: "ab {{start}}",
                        hoursWithCount_one: "{{count}} Stunde",
                        hoursWithCount_other: "{{count}} Stunden",
                        inCount: "in {{count}}",
                        minutesWithCount_one: "{{count}} Minute",
                        minutesWithCount_other: "{{count}} Minuten",
                        never: "Nie",
                        notYet: "Noch nicht",
                        nowCurrentTime: "Jetzt / aktuelle Zeit",
                        range: "{{start}} bis {{end}}",
                        secondsWithCount_one: "{{count}} Sekunde",
                        secondsWithCount_other: "{{count}} Sekunden",
                        start: "Beginn",
                        until: "bis",
                        untilEnd: "bis {{end}}",
                        weekdays: "Wochentage",
                        wholeDay: "ganzer Tag",
                    },
                    today: "Heute",
                    unknown: "Unbekannt",
                    yes: "Ja",
                    enabled: "Aktiviert",
                    disabled: "Deaktiviert",
                },
                identicalEntry: {
                    title: "Identischer Text gefunden",
                    message: "Es existiert bereits ein anderer Eintrag mit genau diesem Text {{- texts}} in {{- languages}}. Bitte passen Sie den Text an, um ein Duplikat zu vermeiden.",
                    editText: "Text anpassen",
                    saveAnyway: "Trotzdem speichern",
                    languages: {
                        English: "Englisch",
                        German: "Deutsch",
                        French: "Französisch",
                        Italian: "Italienisch",
                    },
                },
                issue: {
                    allStates: "Alle Status",
                    fields: {
                        lastModified: "Letzte Bearbeitung",
                        message: "Nachricht",
                        received: "Eingegangen",
                    },
                },
                item: {
                    fields: {
                        categories: "Angebotskategorien",
                    },
                    insufficientStock: "Bestand zu gering. Bitte erhöhen, Mindestbestand reduzieren oder Bestandsfunktion deaktivieren.",
                    articleMinQuantityGreaterThanOptionGroupMaxPerOption: "Die Mindestanzahl von {{article}} ({{articleMinQuantity}}) darf nicht grösser sein als die Max. Anzahl je Option in der Optionsgruppe {{optionGroup}} ({{optionGroupMaxPerQuantity}}).",
                    noCategory: "Keine Kategorie",
                    noFulfillmentGroup: "Keine Erfüllungsgruppe",
                    itemCopiedAndEditingNow: "Artikel kopiert. Sie bearbeiten nun die kopierte Version des Artikels.",
                    itemDeletionFailed: "Artikel kann nicht gelöscht werden",
                    missingStandardServiceDurationForSeats: "Artikel mit der Ressource “Sitzplätze” müssen eine Erfüllungsgruppe mit Standarddienstleistungsdauer zugewiesen haben.",
                    openPriceAndPricePerMinuteExclusive: "Ein Artikel kann nicht gleichzeitig ein Minutenpreisartikel und ein Artikel mit offenem Preis sein.",
                    fulfillmentGroupCannotBeRemoved: "Diese Erfüllungsgruppe kann nicht gelöscht werden, da sie bereits in Bestellungen verwendet wurde.",
                },
                location: {
                    allStates: "Alle Status",
                    covidContactTracing: "Covid-Check",
                    failedToExport: "Standorte konnten nicht exportiert werden.",
                    translation: {
                        key: "Schlüssel",
                        newEntry: "Neuer Eintrag",
                    },
                    childLocations: {
                        internalNameOfAllChildLocationsMustBeUniqueError: "Die interne Bezeichnung aller untergeordneten Standorte muss eindeutig sein.",
                        internalNameAlreadyInUseByAnotherLocationError: "Die interne Bezeichnung wird bereits von einem anderen Standort mit demselben übergeordneten Standort verwendet.",
                        linkedLocationCircularRelationError: "Ein ausgewählter Standort ist ein übergeordneter Standort des Standortes, der gerade bearbeitet wird. Bitte entfernen Sie den Standort und versuchen Sie es erneut.",
                    },
                    psp: {
                        oneIconForAllStripePaymentMethods: "Ein Symbol für alle Stripe-Zahlungsmittel",
                        oneIconForAllWalleePaymentMethods: "Ein Symbol für alle Wallee-Zahlungsmittel",
                        missingDefaultPaymentMethodConfiguration: "Fehlende Standardkonfiguration für Zahlungsmethode: {{paymentMethodName}}",
                    },
                    twilio: {
                        accountSid: "Account SID",
                        create: "Konto erstellen",
                        created: "Twilio Konto wurde erfolgreich erstellt.",
                        currentConnected: "Verknüpftes Konto",
                        delete: "Löschen",
                        deleted: "Twilio Konto wurde gelöscht.",
                        failedCreate: "Twilio Konto konnte nicht verknüpft werden.",
                        failedDelete: "Twilio Konto konnte nicht gelöscht werden.",
                        reallyCreate: "Möchten Sie wirklich ein Konto in Twilio anlegen?",
                        reallyDelete: "Konto permanent löschen? Die Kostenaufstellung bleibt weiterhin ersichtlich.",
                        serviceSid: "Service SID",
                    },
                    locationSlugNotAvailable: "Diese Internetadresse ist bereits vergeben, bitte ändern Sie sie. Verfügbar: {{proposedSlugs}}",
                    locationHasOrdersOrPayments: "Dieser Standort kann aufgrund von getätigten Bestellungen und Zahlungen nicht gelöscht werden.",
                    copyFailed: "Der Standort wurde gespeichert, konnte aber nicht kopiert werden.",
                },
                login: {
                    backToLogin: "Zurück zum Login",
                    enterValidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                    enterValidPassword: "Bitte geben Sie ein gültiges Passwort ein.",
                    failedResetPw: "Leider konnte das Passwort nicht zurückgesetzt werden.",
                    featureNotImplemented: "Coming Soon - Firmenkunden im Gratismodell haben leider noch keinen Zugriff. Wir arbeiten daran und informieren Sie, sobald Sie sich einloggen können. Bei Fragen: marketing@tastier.ch",
                    login: "Login",
                    loginFailedBlocked: "Login aufgrund fehlender Berechtigung fehlgeschlagen. Bitte stellen Sie sicher, dass Sie Ihren Zugang aktiviert haben.",
                    loginFailedCredentials: "E-Mail oder Passwort ungültig",
                    passwordLost: "Passwort vergessen?",
                    resetPassword: "Passwort-Zurücksetzung",
                    resetPasswordBtn: "Zurücksetzen",
                    resetPwSuccess: "Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts geschickt, bitte überprüfen Sie Ihren Posteingang und ggf. Ihren Spam Ordner.",
                    signinBtn: "Einloggen",
                    emailAlreadyUsed: "Diese E-Mail ist bereits vergeben.",
                },
                modal: {
                    addOptionGroup: {
                        newGroupBtn: "Neue Optionsgruppe",
                        options: "Optionen",
                        saveItems: "Speichern ({{items}} Artikel)",
                        showsInItems: "Erscheint bei Artikeln",
                        title: "Optionsgruppe hinzufügen",
                    },
                    addOptionToGroup: {
                        categories: "Kategorien",
                        newItemBtn: "Neuer Artikel",
                        saveItems: "Speichern ({{items}} Artikel)",
                        title: "Option hinzufügen",
                    },
                    allocationHistoryExport: {
                        failedToExport: "Besuche konnten nicht exportiert werden.",
                        fromTo: "Datum von / bis",
                        selectLocation: "Standort auswählen...",
                        selectTable: "Tisch auswählen...",
                        settings: "Einstellungen",
                        title: "Besuche exportieren",
                    },
                    cancellation: {
                        cancellationFailed: "Bestellung konnte nicht storniert werden.",
                        cancellationNotAllowedForPayment: "Stornierung ist für diese Zahlung nicht erlaubt.",
                        canStockBeReused: "Kann der Bestand wiederverwendet werden?",
                        confirmMessage: "{{amt}} CHF wirklich stornieren? Dies kann nicht rückgängig gemacht werden.",
                        confirmTitle: "Stornierung ausführen?",
                        failedLoading: "Bestellung konnte nicht geladen werden.",
                        loading: "Bestellung wird geladen...",
                        notNow: "Nicht jetzt",
                        notPaid: "Nicht bezahlt",
                        offlineMode: "Offline Rückerstattung",
                        paid: "Bezahlt",
                        payment: "Zahlung",
                        paymentMethod: "Zahlungsmittel",
                        positionSectionTitle: "Welche Einheiten von <b>{{itemName}}</b> sollen storniert werden?",
                        positionsText: "Die zu stornierenden Positionen wählen:",
                        reason: "Grund",
                        quantity: "Anzahl",
                        status: "Status",
                        submitBtn: "Ja, stornieren",
                        title: "Stornierung",
                        user: "Nutzer",
                        wholeOrderText: "Die gesamte Bestellung wird storniert werden.",
                        singleCancellationFailed: "Stornierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
                        multipleCancellationsFailed: "Mindestens eine Stornierung ist fehlgeschlagen. Gewisse Zahlungen wurden möglicherweise nicht erstattet. Bitte versuchen Sie es erneut.",
                        multiplePdPaymentCancellationsNotSupported: "Diese Stornierung umfasst mehrere Zahlungen über ein Zahlungsgerät. Bitte beschränken Sie sie auf maximal eine Zahlungsgerät-Zahlung.",
                        twintOnlineRefundNotSupported: "Twint-Zahlungen, die auf Zahlungsgeräten getätigt wurden, können nicht zurückerstattet werden.",
                    },
                    documentCondition: {
                        allRooms: "Alle Räume",
                        failedToSave: "Planung konnte nicht bearbeitet werden.",
                        recurrence: "Schicht",
                        time: "Uhrzeit",
                        timeRange: "Datum",
                        titleCreate: "Planung erstellen",
                        titleEdit: "Planung",
                    },
                    documentSchedule: {
                        allRooms: "Alle Räume",
                        title: "Kalenderansicht",
                    },
                    locationAccess: {
                        editLocation: "Standortangaben",
                        failedGranting: "Berechtigung konnte nicht erteilt werden. Grund: {{reason}}",
                        grants: "Berechtigung",
                        title: "Neue Berechtigung erteilen",
                    },
                    locationExport: {
                        exportSetting: "Exporteinstellungen",
                        failedExport: "Standorte konnten nicht exportiert werden.",
                        title: "Standorte exportieren",
                        viewType: "Art",
                        withRooms: "Mit Räumen",
                        withoutRooms: "Normal",
                    },
                    locationSuspend: {
                        suspendBtn: "Deaktivieren",
                        suspendText: "Dieser Standort ist zur Zeit aktiv. Möchten Sie diesen Standort deaktivieren?",
                        title: "Standort deaktivieren",
                        unsuspendBtn: "Aktivieren",
                        unsuspendText: "Dieser Standort ist zur Zeit inaktiv. Möchten Sie diesen Standort wieder aktivieren?",
                        unsuspendTitle: "Standort aktivieren",
                    },
                    offerRoomActivation: {
                        failedActivation: "Angebot konnte nicht aktiviert werden.",
                        failedDeactivation: "Angebot konnte nicht deaktiviert werden.",
                        failedReset: "Zurücksetzen fehlgeschlagen",
                        reset: "Auf Planung zurücksetzen",
                        successfulActivation: "Angebot erfolgreich aktiviert. Dies gilt bis zur nächsten geplanten oder manuellen Deaktivierung.",
                        sucessfulDeactivation: "Angebot erfolgreich deaktiviert. Dies gilt bis zur nächsten geplanten oder manuellen Aktivierung.",
                        sucessfulReset: "Zurücksetzen erfolgreich",
                        title: "Angebot aktivieren / deaktivieren",
                    },
                    offerSchedule: {
                        title: "Kalenderansicht",
                        differentOffers: "Verschiedene Angebote",
                    },
                    orderExport: {
                        failedExport: "Bestellungen konnten nicht exportiert werden.",
                        invalidDateRangeForOrder: "Die Länge der Berichtsperiode darf 8 Tage nicht überschreiten, und das Startdatum muss innerhalb der letzten 90 Tage liegen.",
                        settings: "Umfang",
                        title: "Bestellungen Exportieren",
                    },
                    stockExport: {
                        failedExport: "Der Bestand konnte nicht exportiert werden.",
                    },
                    printOrderReceipt: {
                        title: "Quittung drucken",
                    },
                    reprintOrder: {
                        failedSending: "Druckauftrag konnte nicht gesendet werden.",
                        hint: "Drucken Sie diese Bestellung auf folgenden Produktionsorten erneut aus.",
                        printBtn: "Drucken",
                        settings: "Einstellungen",
                        success: "Druckauftrag erneut gesendet.",
                        title: "Bestellung erneut drucken",
                    },
                    salesReportExport: {
                        dailySummaryReport: "Tageszusammenfassungsbericht",
                        exportSetting: "Umfang",
                        failedExport: "Verkaufsbericht konnte nicht exportiert werden.",
                        invalidReportDateRangeException: "Der Berichtszeitraum darf 93 Tage nicht überschreiten. Für längere Zeiträume wenden Sie sich bitte an den Support.",
                        paymentMethodsReport: "Zahlungsmittelbericht",
                        title: "Verkaufsbericht",
                        useDetailedNames: "Detaillierte Darstellung",
                        specialReports: "Besondere Berichte",
                        levelOfDetail: "Detaillierungsgrad",
                        orderFulfillmentReport: "Bestellungserfüllungsbericht",
                    },
                    sendOrderReceipt: {
                        failedSending: "Quittung konnte nicht gesendet werden.",
                        receiver: "Empfänger",
                        sentTo: "Quittung wurde an {{receiver}} gesendet",
                        settings: "Einstellungen",
                        title: "Quittung Schicken",
                    },
                    transactionCompare: {
                        settings: "Einstellungen",
                        dateFromTo: "Datum von / bis",
                        compareTransactions: "Transaktionen vergleichen",
                        startComparison: "Vergleich starten",
                        totalCompared: "Total verglichen",
                        matches: "Übereinstimmungen",
                        differences: "Unterschiede",
                        comparingHasMade: "Vergleich wird erstellt...",
                        comparingTransactionDescription: "Dies kann einige Minuten in Anspruch nehmen. Bitte halten Sie dieses Fenster während des Vergleichs geöffnet.",
                        comparisonFailed: "Vergleich fehlgeschlagen",
                        pleaseTryAgain: "Bitte versuchen Sie es später erneut.",
                        transactionsCouldNotBeCompared: "Transaktionen können nicht verglichen werden.",
                        date: "Datum",
                        transaction: "Transaktion",
                        order: "Bestellung",
                        comment: "Kommentar",
                        link: "Link",
                    },
                    locationPaymentMethod: {
                        addTitle: "Standort Zahlungsmethode hinzufügen",
                        editTitle: "Bearbeiten Sie die Zahlungsmethode für den Standort",
                        locationPaymentMethod: "Zahlungsmethode Standort",
                        contract: "Vertrag",
                        name: "Name",
                        merchantId: "Händler-ID",
                        mode: "Modus",
                        displayIcon: "Symbol anzeigen",
                        logo: "Logo",
                        provider: "Anbieter",
                        additionalSettings: "Zusätzliche Einstellungen",
                        paymentMethodExternalId: "Zahlungsmittel-ID",
                        isCreditDebitCard: "Betrieben von einer Kartenzahlungsfirma (card scheme)",
                        paymentDevice: "Zahlungsgerät",
                        isEnabled: "Ermöglicht",
                        order: "Reihenfolge",
                        failedDelete: "Zahlungsmittel konnte nicht gelöscht werden.",
                        failedEdit: "Zahlungsmittel konnte nicht bearbeitet werden.",
                        deviceId: "Geräte-ID",
                        allowTipOnlyOnDevice: "Trinkgeldeingabe nur auf dem Gerät zulassen",
                        useTerminalApi: "Terminal-API verwenden",
                        apiToken: "API-Token",
                        integratorId: "Integrator-ID",
                        revenueEffective: "Umsatzwirksam",
                        pairingCode: "Pairing code",
                        pairConnect: "Koppeln und verbinden",
                        disconnect: "Trennen",
                        deviceDisconnected: "Das Gerät wurde erfolgreich getrennt.",
                        deviceConnected: "Das Gerät wurde erfolgreich verbunden.",
                        deviceConnectFailed:
                            "Die Verbindung zum PayTec-Terminal ist fehlgeschlagen. Überprüfen Sie den Kopplungscode oder das Zugriffstoken und stellen Sie sicher, dass das Terminal online ist.",
                        connect: "Verbinden",
                    },
                    service: {
                        addTitle: "Service hinzufügen",
                        editTitle: "Service bearbeiten",
                        failedDelete: "Service konnte nicht gelöscht werden.",
                        failedEdit: "Service konnte nicht bearbeitet werden.",
                        icon: "Icon",
                        customIcon: "Benutzerdefiniertes Symbol",
                        customDesignation: "Benutzerdefinierte Bezeichnung",
                        service: "Service",
                        settings: "Einstellungen",
                        image: "Bild",
                    },
                    sessionExpired: {
                        signinBtn: "Einloggen",
                        text: "Aufgrund längerer Inaktivität wurden Sie ausgeloggt. Bitte loggen Sie sich bitte wieder ein.",
                        title: "Sitzung abgelaufen",
                    },
                    supportIssue: {
                        editRequest: "Anfrage bearbeiten",
                        failedDelete: "Anfrage konnte nicht gelöscht werden.",
                        failedEdit: "Anfrage konnte nicht bearbeitet werden.",
                        title: "Supportanfrage bearbeiten",
                    },
                    voucherBulk: {
                        title: "Neuer Gutschein",
                        internalNote: "Interne Notiz",
                        isActive: "Aktiviert",
                        value: "Wert",
                        voucherQty: "Anzahl",
                        create: "Erstellen",
                    },
                    tableBulk: {
                        action: "Vorgang",
                        conventionPlaceholder: "z.B. Tisch [Number]",
                        conventionText: 'z.B. "Tisch" eingeben und "Nummer Einfügen" klicken',
                        createAtLeast: "Mindestens 1 Raum muss erstellt werden.",
                        deleteMultiple: "Mehrere Tische löschen",
                        editCreateMultipleTables: "Mehrere Tische erstellen / bearbeiten",
                        editPosId: "POS ID bearbeiten",
                        execute: "Ausführen",
                        failedEdit: "Tische konnten nicht bearbeitet werden.",
                        failedLimitExceeded: "Die maximale Anzahl Tische wurde überschritten. Nehmen Sie mit unserem Verkauf Kontakt auf um Ihr Abonnement anzupassen.",
                        failedNoAffected: "Durch den Vorgang wurden keine Tische verändert.",
                        failedNoSubscription: "Dieser Standort hat zurzeit kein aktives Abonnement.",
                        hidePosId: "POS ID ausblenden",
                        insertNumber: "Nummer einfügen",
                        posId: "POS ID",
                        previewNoneDelete: "Achtung: Es werden keine Tische gelöscht.",
                        previewPluralDelete: "Achtung: Es werden {{amount}} Tische gelöscht.",
                        previewPluralEdit: "Achtung: Es werden {{amount}} Tische überschrieben.",
                        previewSingularDelete: "Achtung: 1 Tisch wird gelöscht.",
                        previewSingularEdit: "Achtung: 1 Tisch wird überschrieben.",
                        seatCount: "Anzahl Plätze",
                        preferredMinimumOccupancy: "Bevorzugte Mindestbelegung",
                        selectRoom: "Raum auswählen...",
                        tableNrFromTo: "Tischnummer von / bis",
                        tableNrPlaceholder: "z.B. 10",
                        title: "Mehrere Tische",
                        whatToDo: "Was soll getan werden?",
                    },
                    transactionExport: {
                        allStates: "Alle Status",
                        dateFromTo: "Datum von / bis",
                        exportSetting: "Einstellungen",
                        failedExport: "Zahlungen konnten nicht exportiert werden",
                        selectLocation: "Standort auswählen...",
                        title: "Zahlungen exportieren",
                    },
                    translation: {
                        addTitle: "Eintrag erstellen",
                        editTitle: "Eintrag bearbeiten",
                        failedDelete: "Eintrag konnte nicht gelöscht werden.",
                        failedEdit: "Text konnte nicht bearbeitet werden.",
                        key: "Schlüssel",
                        systemText: "Systemtext",
                        text: "Text",
                    },
                    userAccess: {
                        editLocation: "Standort bearbeiten",
                        failedEdit: "Berechtigung konnte nicht erteilt werden. Grund: {{reason}}",
                        grants: "Berechtigung",
                        kind: "Art",
                        title: "Neue Berechtigung erteilen",
                    },
                },
                offer: {
                    activate: "Aktivieren",
                    activateDeactivate: "Aktivieren / Deaktivieren",
                    activated: "Angebot {{offer}} wurde aktiviert.",
                    deactivate: "Deaktivieren",
                    deactivated: "Angebot {{offer}} wurde deaktiviert.",
                    failedActivate: "Angebot konnte nicht aktiviert werden.",
                    failedDeactivate: "Angebot konnte nicht deaktiviert werden.",
                    offerCopiedAndEditingNow: "Angebot kopiert. Sie bearbeiten nun die kopierte Version des Angebots.",
                    orderApplications: "Bestellanwendungen",
                },
                offerSchedule: {
                    allOffers: "Alle Angebote",
                    allOrderApplications: "All applications",
                    allRooms: "Alle Räume",
                    allTypes: "Alle Typen",
                    failedIntersection: "Überschneidung mit {{link}}",
                    fields: {
                        currentActive: "Jetzt aktiv",
                        currentSchedule: "Aktuelle Planung",
                        weekdayAndTime: "Wochentage & Uhrzeit",
                    },
                    offerScheduleCopiedAndEditingNow: "Planung kopiert. Sie bearbeiten nun die kopierte Version der Planung.",
                    failedPlanningOverlapsOtherPlanning: "Diese Planung überschneidet sich mit einer anderen Planung",
                },
                optionGroup: {
                    fields: {
                        appearsInItems: "Erscheint bei Artikeln",
                    },
                    optionGroupCopiedAndEditingNow: "Optionsgruppe kopiert. Sie bearbeiten nun die kopierte Version.",
                },
                offerCategory: {
                    imagesNotCopied: "Die Bilder der Quellkategorie konnten nicht kopiert werden. Bitte fügen Sie sie manuell hinzu.",
                    offerCategoryCopiedAndEditingNow: "Angebotskategorie kopiert. Sie bearbeiten nun die kopierte Version.",
                },
                order: {
                    allStates: "Alle Status",
                    deletedTable: "Gelöschter Tisch",
                    consumptionInclVat: "Konsumation (inkl. {{vat}}% MWST)",
                    fields: {
                        cancellation: "Stornierung",
                        consumption: "Konsumation",
                        discount: "Rabatt",
                        dailyOrderIncrement: "Bestellnummer",
                        fulfillDate: "Datum",
                        orderNumber: "Bestellcode",
                        tip: "Trinkgeld",
                        useCase: "Anwendung",
                        totalIncTip: "Total inkl. Trinkgeld",
                        total: "Total",
                        fulfilmentTime: "Erfüllungszeit",
                        scheduled: "Geplant",
                    },
                },
                productionSite: {
                    cancelJob: "Druckauftrag abbrechen",
                    changeProtocolHint: "Das Ändern des Protokolls oder des Formats löscht alle noch nicht ausgeführten Druckaufträge.",
                    failedCancelJob: "Druckauftrag konnte nicht abgebrochen werden.",
                    failedDeleteJob: "Druckauftrag konnte nicht gelöscht werden.",
                    failedToSendTestPrint: "Testdruck konnte nicht an Drucker gesendet werden.",
                    usedAsBackup: "Dieser Produktionsort kann nicht gelöscht werden, da er als Backup eingestellt ist in: {{forwardingProductionSites}}. Entfernen Sie ihn dort zuerst.",
                    fields: {
                        backupPrint: "Weitergeleiteter Druck",
                        backupSite: "Weiterleitung",
                        forwarded: "Weitergeleitet",
                        isActive: "Aktiviert",
                        lastCommunication: "Letzte Kommunikation",
                        layout: "Format",
                        protocol: "Protokoll",
                    },
                    noJobs: "Keine Druckaufträge vorhanden",
                    reallyCancel: "Soll dieser Druckauftrag wirklich abgebrochen werden?",
                    selectProductionSite: "Produktionsort auswählen...",
                    testPrintSent: "Testdruck wurde an Drucker gesendet",
                },
                room: {
                    activateService: "Bitte aktivieren Sie einen Service",
                    addService: "Service hinzufügen",
                    failedChangingOrder: "Reihenfolge konnte nicht geändert werden. Bitte laden Sie das Browserfenster neu.",
                    failedLimitExceeded: "Die maximale Anzahl Räume wurde überschritten. Nehmen Sie mit unserem Verkauf Kontakt auf um Ihr Abonnement zu vergrössern.",
                    failedLoadingServices: "Services konnten nicht geladen werden.",
                    failedTableReferences: "Raum kann nicht gelöscht werden, da diesem Tische zugewiesen sind.",
                    fields: {
                        deallocationDelay: "Autom. Checkout Dauer",
                        services: "Services",
                        endUserServices: "Endnutzer-Services",
                        operatorServices: "Betreiber-Services",
                    },
                },
                saleInquiry: {
                    allStates: "Alle Status",
                    fields: {
                        company: "Betrieb",
                        lastModified: "Letzte Bearbeitung",
                        location: "Ort",
                        person: "Nutzer",
                        priceModel: "Modell",
                        received: "Eingegangen",
                    },
                },
                signup: {
                    accessCreated: "Zugang erstellt. Zum Aktivieren Ihres Zugangs haben wir Ihnen eine E-Mail an <b>{{email}}</b> geschickt, bitte überprüfen Sie Ihren Posteingang und ggf. den Spam Ordner.",
                    failed: "Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
                    fields: {
                        password: "Passwort",
                    },
                    success: "Sie haben sich bereits erfolgreich registriert und Ihren Zugang zum Portal für Firmenkunden aktiviert.",
                },
                stock: {
                    disableWarning: "Bestand erhöhen und Artikel verfügbar setzen, um ihn zu verkaufen",
                    failedSave: "Artikelbestand konnte nicht bearbeitet werden.",
                    fields: {
                        safetyStock: "Mindestbestand",
                        stock: "Aktueller Bestand",
                    },
                },
                subscription: {
                    allLocations: "Alle Standorte",
                    customForCustomer: "Kundenspezifisch",
                    fields: {
                        covid: "Covid-Check",
                        documents: "Dokumente",
                        pay: "Bezahlen",
                        preset: "Modell",
                        validUntil: "Gültig bis",
                    },
                    unrestricted: "Unbegrenzt",
                },
                system: {
                    fields: {
                        level: "Level",
                        message: "Meldung",
                        time: "Zeit",
                        title: "Titel",
                    },
                },
                table: {
                    allDataOrigins: "Alle Datenquellen",
                    allRooms: "Alle Räume",
                    allUsersDeallocated: "Alle Nutzer wurden vom Tisch entfernt.",
                    downloadAllQr: "Alle QR-Codes Herunterladen",
                    downloadAllQrText: "Hiermit laden Sie alle QR-Codes als zip-Datei herunter. Kopieren Sie die png-Dateien aus der zip-Datei in ein Textverarbeitungs- oder Grafikprogramm. Fügen Sie Besucher-Hinweise hinzu und gestalten Sie Ihre Ausdrucke (Empfehlungen beachten). Alternativ bietet Tastier diesen Service.",
                    downloadBtn: "Herunterladen",
                    editPosId: "POS ID bearbeiten",
                    failedDeallocating: "Nutzer konnten nicht vom Tisch entfernt werden.",
                    failedReset: "Tisch konnte nicht zurückgesetzt werden.",
                    fields: {
                        requireInfo: "Freitexteingabe",
                        seats: "Anzahl Plätze",
                        tableNumber: "Tischnummer",
                    },
                    hidePosId: "POS ID ausblenden",
                    permalink: {
                        copiedClipboard: "URL wurde in die Zwischenablage kopiert.",
                        create: "Direktlink erstellen",
                        failedCreate: "Direktlink konnte nicht erstellt werden.",
                        failedDelete: "Direktlink konnte nicht gelöscht werden.",
                        reallyDelete: "Soll dieser Direktlink permanent gelöscht werden?",
                        mode: "Modus",
                    },
                    successReset: "Tisch wurde erfolgreich zurückgesetzt.",
                    tableNumerInUse: "Tischnummer oder POS ID bereits in Verwendung",
                    table: "Tisch",
                },
                task: {
                    failedStart: "Aufgabenausführung konnte nicht gestartet werden.",
                    fields: {
                        duration: "Dauer",
                        interval: "Interval",
                        nextExecution: "Nächste Ausführung",
                        result: "Resultat",
                        started: "Gestartet",
                    },
                    started: "Aufgabe wurde gestartet.",
                },
                transaction: {
                    allLocations: "Alle Standorte",
                    allStates: "Alle Status",
                    fields: {
                        amount: "Betrag",
                        fees: "Gebühr",
                        paymentMethod: "Zahlungsmittel",
                        paymentMethodButton: "Zahlungsmittel-Button",
                        provider: "PSP",
                        client: "Client",
                    },
                },
                useCase: {
                    preorderRoomsWithoutPlanningException: "Dieser Bestellen für: Jetzt oder später Bestellanwendung fehlt eine Planung für: {{roomNames}}. Bitte fügen Sie eine Planung hinzu oder ergänzen Sie eine.",
                    orderApplicationCopiedAndEditingNow: "Bestellanwendung kopiert. Sie bearbeiten nun die kopierte Version der Bestellanwendung.",
                    failedDelete: "Anwendung konnte nicht entfernt werden, weil sie vom Service {{dependingName}} genutzt wird.",
                    tooManyQuickPaymentMethodsEnabled: "Es können bis zu {{maxEnabledPaymentMethodsCount}} Schnellzahlungsmittel aktiviert werden.",
                    atLeastOneDeliveryAreaRequiredError: "Es ist mindestens ein Liefergebiet erforderlich",
                    minimumTotalUnitsPerOrderGreaterThanMaximumError: "Die minimale Gesamtanzahl Einheiten pro Bestellung darf nicht grösser sein als die maximale.",
                    minimumTotalUnitsPerOrderInvalidError: "Die minimale Gesamtanzahl Einheiten pro Bestellung muss mindestens 1 sein.",
                    maximumTotalUnitsPerOrderInvalidError: "Die maximale Gesamtanzahl Einheiten pro Bestellung muss mindestens 1 sein.",
                    fields: {
                        buyerRequirement: "Besteller Anforderung",
                        consumptionSite: "Konsumort",
                        fulfillmentPositionDisplayMode: "Erfüllung anzeigen",
                        fulfillmentHandling: "Wo?",
                        fulfillmentTimeMode: "Erfüllungszeit anzeigen",
                        tip: "Trinkgeld",
                        usePayment: "Zahlung",
                        usePreorder: "Bestellen für",
                        maxPreorderPeriod: "Maximale Vorbestelldauer",
                    },
                    guest: "Gast",
                    payment: {
                        offline: "Offline-Zahlungsmittel",
                        online: "Online-Zahlungsmittel",
                        other: "Andere",
                        paymentDevices: "Zahlungsgeräte",
                    },
                    preorderOff: "Jetzt",
                    preorderOn: "Jetzt oder später",
                    waiter: "Kellner",
                    operators: "Betreiber",
                    endUsers: "Endnutzer",
                    quickButton: "Schnellzahlungsmittel",
                    defaultMessageToUserBeforeOrder: "Hallo, wir freuen uns auf deine Bestellung.",
                    defaultOrderReminderPushNotificationMessage: "Deine Bestellung ist für Abholung in 1 h geplant",
                    defaultOrderReminderPushNotificationTitle: "Abholung geplant",
                    pickupOrderPushNotificationTitle: "Bestellung abholen",
                    pickupOrderPushNotificationMessage: "Deine Bestellung ist abholbereit",
                    notRevenueEffective: "Nicht umsatzwirksam",
                    permission: "Berechtigung",
                },
                notification: {
                    notifiedWhenOrderReadyWithDuration: "Du wirst benachrichtigt, wenn deine Bestellung abholbereit ist. Voraussichtliche Wartezeit (Richtwert, kann sich jederzeit ändern):",
                    notifiedWhenOrderReadyWithPosition: "Du wirst benachrichtigt, wenn deine Bestellung abholbereit ist. Aktuelle Position auf der Warteliste:",
                },
                user: {
                    allRoles: "Alle Rollen",
                    allUsers: "Alle Nutzer",
                    anonymous: "Anonym",
                    anonymousUser: "Anonymer Endnutzer",
                    failedResetPassword: "Passwort konnte nicht zurückgesetzt werden.",
                    fields: {
                        claimType: "Berechtigungsart",
                        devices: "Gerät",
                        emailConfirmed: "E-Mail bestätigt",
                        lastLogin: "Letzter Login",
                        loginProviders: "Login mit",
                    },
                    newGrant: "Neue Berechtigung",
                    noGrants: "Keine Berechtigung zugeteilt",
                    onlyAnonymousUser: "Nur anonyme Nutzer",
                    onlySignedUpUsers: "Nur registrierte Nutzer",
                    passwordSet: "Passwort wurde erfolgreich geändert.",
                    reallyRemoveGrant: "Berechtigung wirklich zurückziehen?",
                    removeGrant: "Zurückziehen",
                    signedUp: "Registriert",
                },
                voucher: {
                    alreadyUsedCannotBeDeleted: "Der Gutschein wurde bereits verwendet und kann nicht gelöscht werden.",
                    fields: {
                        created: "Erstellt",
                        expiryDate: "Ablaufdatum",
                        initialValue: "Anfangswert",
                        balance: "Guthaben",
                        code: "Gutscheincode",
                        internalNote: "Interne Notiz",
                        isActive: "Aktiviert / Deaktiviert",
                        cancellation: "Stornierung",
                    },
                    voucherCode: {
                        copiedClipboard: "Gutscheincode wurde in die Zwischenablage kopiert.",
                    },
                },
                voucherDesign: {
                    addEmptyTextBox: "Leeres Textfeld hinzufügen",
                    areYouSureYouWantToLeave: "Sie haben ungespeicherte Änderungen. Wenn Sie diesen Tab verlassen, gehen diese verloren. Möchten Sie fortfahren?",
                    areYouSureYouWantToRemoveTemplate: "Möchten Sie diese Voucher-Designvorlage wirklich entfernen? Dadurch wird die Standardvorlage wiederhergestellt.",
                    backgroundColor: "Hintergrundfarbe",
                    backgroundImage: "Hintergrundbild",
                    clear: "Löschen",
                    edit: "Bearbeiten",
                    emptyTextBox: "Leeres Textfeld",
                    errorRemovingTemplate: "Beim Entfernen der Vorlage für das Voucher-Design ist ein Fehler aufgetreten.",
                    expirationDate: "Ablaufdatum",
                    failedDeleteImage: "Bild konnte nicht gelöscht werden. Bitte versuche es erneut.",
                    imageLibrary: "Benutzerdefinierte Bilder",
                    invoiceAddress: "Rechnungsadresse",
                    loadingImages: "Bilder werden geladen...",
                    locationAddress: "Standortadresse",
                    locationName: "Standortname",
                    logo: "Logo",
                    marginSize: "Randgröße",
                    noImagesAvailable: "Keine Bilder verfügbar",
                    pageSettings: "Seiteneinstellungen",
                    predefinedImages: "Bilder",
                    preview: "Vorschau",
                    qrCode: "QR-Code",
                    reallyDeleteImage: 'Möchten Sie "{{name}}" wirklich löschen?',
                    toolbar: {
                        alignCenter: "Zentriert ausrichten",
                        alignJustify: "Blocksatz",
                        alignLeft: "Linksbündig",
                        alignRight: "Rechtsbündig",
                        bold: "Fett",
                        bulletList: "Aufzählungsliste",
                        heading1: "Überschrift 1",
                        heading2: "Überschrift 2",
                        heading3: "Überschrift 3",
                        heading4: "Überschrift 4",
                        heading5: "Überschrift 5",
                        horizontalRule: "Horizontale Linie",
                        italic: "Kursiv",
                        orderedList: "Nummerierte Liste",
                        paragraph: "Absatz",
                        strike: "Durchgestrichen",
                        textColor: "Textfarbe",
                        textType: "Texttyp",
                        underline: "Unterstreichen",
                    },
                    upload: "Hochladen",
                    uploadedImage: "Hochgeladenes Bild",
                    variables: "Variablen",
                    variablesNotPresent: "Die folgenden Variablen sind im Dokument nicht vorhanden: {{variables}}",
                    voucherBalance: "Gutscheinguthaben",
                    voucherCode: "Gutscheincode",
                    voucherDesign: "Gutschein-Design",
                },
            },
        },
        fr: {
            translation: {
                activity: {
                    failedLoading: "Les activités récentes n'ont pas pu être chargées.",
                    loadingActivities: "Les dernières activités sont en cours de chargement...",
                    noActivities: "Aucune activité disponible",
                },
                allocationHistory: {
                    allLocations: "Tous les sites",
                    fields: {
                        additionalInfo: "Information supplémentaire",
                        allocated: "Visité",
                        deallocated: "Quitté",
                        isCovidComplete: "Covid valide",
                        isValid: "Valable",
                        isSignedUp: "Inscrit",
                        phone: "Tél.",
                        zip: "Code postal",
                    },
                },
                attribute: {
                    fields: {
                        displayAs: "Afficher comme",
                        filter: "Filtre",
                        icon: "Icône",
                        isEnabled: "Activé",
                        type: "Type",
                    },
                    types: {
                        standard: "Standard",
                        custom: "Personnalisé",
                    },
                    effectDescription: {
                        Include: "Si ce filtre est appliqué, seuls les articles possédant cet attribut sont affichés.",
                        Exclude: "Si ce filtre est appliqué, seuls les articles ne possédant pas cet attribut sont affichés.",
                    },
                    standardFieldsLocked:
                        "Attribut standard : le nom, l'icône et le filtre sont identiques pour tous les établissements et ne peuvent être modifiés que de manière centralisée.",
                    standardCannotBeDeleted:
                        "Un attribut standard est disponible pour tous les établissements et ne peut pas être supprimé. Désactivez-le à la place.",
                    cannotBeDisplayedAsFilter:
                        "Aucun effet de filtre n'est défini pour cet attribut standard, il ne peut donc pas être affiché comme filtre.",
                },
                receipt: {
                    receipt: "Reçu",
                    sendReceipt: "Envoyer le Reçu",
                    printReceipt: "Imprimer le Reçu",
                },
                apiVersion: {
                    fields: {
                        package: "Packet",
                        version: "Version",
                    },
                },
                print: {
                    orderReceiptPrinted: "Travail d'impression envoyé",
                    failedPrintReceipt: "Travail d'impression échoué",
                    noProductionSiteEnabledForRoom: "Aucune imprimante de reçus activée n'est attribuée à cette table / salle.",
                },
                cancellation: {
                    allModes: "Tous les modes",
                    allPositions: "Toutes les poste",
                    cancelPositions: "Postes individuels",
                    cancelWholePayment: "Paiement entière",
                    fields: {
                        amount: "Montant",
                        cancelled: "Annulée",
                        executedBy: "Effectuée par",
                        mode: "Mode",
                        positions: "Postes",
                        reason: "Raison",
                        refund: "Remboursement",
                        refunded: "Remboursé",
                    },
                },
                dashboard: {
                    allocations: "Check-Ins",
                    signups: "Inscriptions",
                    turnover: "Ventes",
                    selectLocation: "Veuillez sélectionner un site pour afficher les rapports.",
                    salesChart: {
                        chartTitle: "Chiffre d’affaires incl. pourboire",
                        orders: "commandes",
                        payments: "paiements",
                    },
                    salesByPaymentMethodChart: {
                        chartTitle: "Moyens de paiement",
                        onlineBrowser: "En ligne - Navigateur",
                        onlinePaymentDevice: "En ligne - Appareil de paiement",
                        offline: "Hors ligne",
                        nre: "Non impactant sur le chiffre d'affaires",
                    },
                    cancellationsChart: {
                        chartTitle: "Annulations",
                        noReason: "Aucune raison",
                    },
                    kpiSummary: {
                        tip: "Pourboire",
                        netSalesNetExclTip: "Chiffre d'affaires net (hors pourboire)",
                        grossSalesNetExclTip: "Chiffre d’affaires (hors pourboire)",
                        avgOrder: "Commande moyenne",
                        avgPayment: "Paiement moyen",
                        avgBill: "Note moyenne",
                        avgBillDurationMins: "Durée moyenne d'une note",
                    },
                },
                discount: {
                    fields: {
                        appliesTo: "S'applique à",
                        appliesToAll: "Tous",
                        name: "Dénomination",
                        order: "Ordre",
                        status: "Statut",
                        timesUsed: "Fois utilisé",
                        totalDiscounted: "Total remisé",
                        type: "Type",
                        value: "Valeur",
                    },
                    discountCode: {
                        copiedClipboard: "Code de remise a été copié dans le presse-papiers.",
                    },
                    cancelDiscountPopupMessage: "Annuler cette remise ? Cette action est irréversible. Ajustez Début / Fin si vous souhaitez l’utiliser à nouveau plus tard.",
                },
                documents: {
                    allRooms: "Toutes les salles",
                    failedLimitExceeded: "Le nombre maximum de documents a été dépassé. Prenez contact avec notre service des ventes pour augmenter votre abonnement.",
                    fields: {
                        dateFrom: "Date",
                        file: "Fichier",
                        isPublished: "Publié",
                        modified: "Fichier modifié",
                        timeFrom: "Heure",
                        weekdays: "Jours de la semaine",
                    },
                    newCondition: "Nouvelle planification",
                    unknownRoom: "Salle inconnue",
                },
                elements: {
                    articleOverview: {
                        collapseAll: "Replier tous",
                        expandAll: "Déplier tous",
                        failedLoading: "Les articles n'ont pas pu être chargés.",
                        failedSort: "L'ordre n'a pas pu être modifié.",
                        loadingItems: "Les articles sont en cours de chargement...",
                        newCategory: "Nouvelle catégorie",
                        newItem: "Nouvel article",
                        noItemsAvailable: "Pas d'articles disponibles dans l'offre",
                        noItemsText: "Aucune catégorie à laquelle des articles ont été attribués n'a encore été ajoutée à cette offre.",
                        notAvailable: "Non disponible",
                        open: "Libre",
                    },
                    fileUpload: {
                        invalidMime: "Le type de fichier n'est pas autorisé. Veuillez télécharger un fichier dans le format suivant : <b>{{allowed}}</b>",
                        invalidSize: "Fichier trop volumineux. Taille maximale : <b>{{size}}</b>",
                        noFileSelected: "Aucun fichier sélectionné",
                        selectFile: "Sélectionner un fichier",
                    },
                    imagePicker: {
                        invalidSize: "Fichier trop volumineux. Taille maximale : <b>{{size}}</b>",
                        noImage: "Aucune image",
                        pleaseSelectImage: "Sélectionner une image",
                        uploadFailed: "L'image n'a pas pu être enregistrée.",
                    },
                    offerSchedulesEditor: {
                        autoAcceptUnassignedReservations: "Les réservations qui ne peuvent pas être attribuées à une table peuvent être acceptées automatiquement ou présentées à l’opérateur pour approbation",
                        capacityAdjustmentPercentage: "Tampon / Surbooking (% de tous les places)",
                        expectedLostSeatRatio: "Places perdues prévues pour les réservations non attribuées",
                        messageToUserAfterPendingOperatorReservation: "Message to user after pending (Operator) reservation",
                        operatorsCanBreakReservationRules: "Les opérateurs peuvent contourner les règles",
                        operatorsMustAcceptOrDeclineReservation: "Les opérateurs doivent accepter / refuser (aucune réponse immédiate – la capacité de places calculée est toujours respectée)",
                        preOrders: "Précommandes",
                        nodata: "Aucun horaire n'a encore été défini",
                        preOrdertime: "Durée minimale de précommande",
                        fulfilmentTimeInterval: "Intervalle d'heure d'exécution",
                        defaultCapacityPerFulfilmentTime: "Capacité standard par heure d'exécution",
                        orders: "commandes",
                        operatorsMayEditOrders: "Les opérateurs peuvent modifier les commandes",
                        editOrderUpToFulfillmentTime: "jusqu’à … avant l’heure d’exécution",
                        endUsersMayCancelOrders: "Les utilisateurs finaux peuvent annuler",
                        refundability: "Remboursabilité",
                        tableReservations: "Réservations de tables",
                        excludeTables: "Exclure des tables",
                    },
                    optionAllocator: {
                        canUpTo: "options <b>peuvent être sélectionnées</b>.",
                        maxPerOption: "Quantité max. par option",
                        maxSum: "Somme max.",
                        mustTotalUpTo: "options <b>doivent,</b> au total jusqu'à",
                        noOptionsSelected: "Aucune option n'a encore été sélectionnée...",
                        preselection: "Présélection",
                    },
                    productionSiteAllocator: {
                        noProductionSites: "Pas encore de Lieu de production attribué...",
                        subtitle: "N'est pas utilisé si l'article est utilisé comme option.",
                        printOrdersFrom: "Imprimer les commandes de",
                    },
                    optionGroupAllocator: {
                        noGroups: "Aucun groupe d'options n'a encore été attribué...",
                    },
                    passwordInput: {
                        minLength: "Au moins {{count}} caractères",
                        minNumbers: "Au moins {{count}} nombre",
                        minUpperCase: "Au moins {{count}} lettre majuscule",
                    },
                    select: {
                        pleaseSelect: "Sélectionner",
                    },
                },
                enums: {
                    AttributeEffect: {
                        Include: "Inclure",
                        Exclude: "Exclure",
                    },
                    AttributeDisplayType: {
                        Icon: "Icône",
                        Flag: "Drapeau",
                        Filter: "Filtre",
                    },
                    AttributeFlagDisplayTo: {
                        EndUsersAndOperators: "Utilisateurs finaux et opérateurs",
                        EndUsers: "Utilisateurs finaux",
                        Operators: "Opérateurs",
                    },
                    OperatorPlaySoundMode: {
                        FulfillmentInPreparation: "En préparation / Prêt sous peu",
                        FulfillmentReady: "Prêt",
                        FulfillmentFulfilledNotPaid: "Exécuté, non payé",
                    },
                    VoucherState: {
                        Enabled: "Activé",
                        Expired: "Expiré",
                        Cancelled: "Annulée",
                        Redeemed: "Utilisé",
                    },
                    PaymentMethodMode: {
                        Online: "En ligne",
                        Offline: "Hors ligne",
                    },
                    JoinPrintingItemsMode: {
                        PerOrder: "Une impression par commande",
                        PerItem: "Une impression par article",
                        PerOrderAndPerItem: "Une impression par commande et une par article",
                    },
                    BuyerRequirement: {
                        EmailConfirmed: "E-mail confirmé",
                        None: "Aucune",
                        SignedUp: "Enregistré avec un e-mail",
                        Email: "E-mail",
                    },
                    CancellationClaimValue: {
                        None: "Aucune",
                        MakeCancellationsAndRefunds: "Effectuer des annulations et des remboursements",
                    },
                    OperatorTransferClaimValue: {
                        CannotTransfer: "Ne peut pas transférer",
                        CanTransferOwn: "Peut transférer ses propres",
                        CanTransferAll: "Peut transférer tous",
                    },
                    OperatorItemAvailabilityAndStockLevelClaimValue: {
                        CannotEdit: "Ne peut pas modifier",
                        CanEdit: "Peut modifier",
                    },
                    CancellationMode: {
                        Amount: "Montant manuel",
                        Positions: "Postes individuels",
                        WholeOrder: "Commande entière",
                    },
                    CancellationReason: {
                        IncorrectIncompleteItemInformation: "Informations incorrectes ou incomplètes sur l'article",
                        OrderedIncorrectlyEndUser: "Commandé de manière incorrecte (utilisateur final)",
                        OrderedIncorrectlyStaffMember: "Commandé de manière incorrecte (membre du personnel)",
                        EndUserChangedMind: "L'utilisateur final a changé d'avis",
                        ItemNotAvailable: "Article non disponible",
                        PriceWrong: "Prix erroné",
                        BusinessClosedAtFulfilmentTime: "Entreprise fermée au moment de l'exécution",
                        LossBreakageStaffMember: "Casse / Perte (membre du personnel)",
                        LateFulfilment: "Exécution tardive",
                        BadQualityPresentation: "Mauvaise qualité / présentation",
                        LossBreakageEndUser: "Casse / Perte (utilisateur final)",
                        CustomerDidNotPayWalkout: "Le client n'a pas payé (Délit de fuite)",
                        Other: "Autre",
                    },
                    CancellationState: {
                        Cancelled: "Annulée",
                        PartiallyCancelled: "Partiellement annulée",
                    },
                    ConsumptionSite: {
                        OffSite: "Hors domicile",
                        OnSite: "Sur place",
                    },
                    ConsumptionSiteDisplayMode: {
                        DeliveryAddress: "Adresse de livraison",
                        PickUpAddress: "Adresse de ramassage",
                        LocationAddress: "Adresse du site",
                        None: "Non",
                    },
                    Country: {
                        Austria: "Autriche",
                        France: "France",
                        Germany: "Allemagne",
                        Italy: "Italie",
                        Netherlands: "Pays-Bas",
                        Switzerland: "Suisse",
                    },
                    DashboardStatsPeriod: {
                        Today: "Aujourd'hui",
                        Date: "Date",
                        Yesterday: "Hier",
                        Past7Days: "7 derniers jours",
                        Past8Days: "8 derniers jours",
                        Past4Weeks: "4 dernières semaines",
                        Past5Weeks: "5 dernières semaines",
                        Past3Months: "3 derniers mois",
                        Past12Months: "12 derniers mois",
                        Past13Months: "13 derniers mois",
                        CurrentWeek: "Semaine en cours",
                        LastWeek: "Semaine dernière",
                        CurrentMonth: "Mois en cours",
                        LastMonth: "Mois dernier",
                        CurrentYear: "Année en cours",
                        LastYear: "L'année dernière",
                        TwoYearsAgo: "{{year}}",
                        ThreeYearsAgo: "{{year}}",
                        FourYearsAgo: "{{year}}",
                    },
                    DataOrigin: {
                        Portal: "Portail",
                        Pos: "POS",
                    },
                    DiscountAccessMode: {
                        Automatically: "Automatiquement",
                        Button: "Par bouton",
                        Code: "Code requis",
                        CodeOrButton: "Avec code ou par bouton",
                    },
                    DiscountStatus: {
                        Cancelled: "Annulée",
                        Enabled: "Activé",
                        Expired: "Expiré",
                        NotYetValid: "Pas encore valide",
                    },
                    DiscountType: {
                        Absolute: "Absolu",
                        Percentage: "Pourcentage",
                    },
                    DocumentType: {
                        Pdf: "PDF",
                        Unknown: "Inconnu",
                    },
                    VisibleEndUserProperties: {
                        None: "Aucun",
                        FirstNameShortLastName: "Prénom, nom de famille abrégé",
                        Email: "Adresse e-mail",
                        PhoneNumber: "Numéro de téléphone",
                        FirstNameLastName: "Prénom, nom",
                    },
                    PrintWhenOrderHasStatus: {
                        None: "Aucun",
                        Confirmed: "Confirmé (Commander pour : Maintenant) / Début de la durée de production (Commander pour : Maintenant ou plus tard)",
                        Ready: "Prêt",
                    },
                    FulfillmentPositionDisplayMode: {
                        None: "Aucune",
                        Duration: "Durée",
                        Position: "Position",
                    },
                    FulfillmentHandling: {
                        None: "Aucun",
                        OnlyOperator: "App Opérateur",
                        OperatorAndApp: "App Opérateur et Mobile",
                    },
                    FulfillmentTimeMode: {
                        DeliveryTime: "Heure de livraison",
                        None: "Non",
                        PickupTime: "Heure de retrait",
                        Time: "Temps (type non spécifié)",
                    },
                    OneFulfillmentPerOrderMode: {
                        NotForced: "Pas obligatoire",
                        Forced: "Obligatoire",
                        LetCustomerDecide: "Laisser l'ordonnateur décider",
                    },
                    FulfilmentTileSize: {
                        Large: "Grande",
                        Normal: "Normale",
                    },
                    IssueState: {
                        Closed: "Fermé",
                        InProgress: "En cours",
                        Open: "Ouvert",
                    },
                    Language: {
                        English: "Anglais",
                        French: "Français",
                        German: "Allemand",
                        Italian: "Italien",
                    },
                    LocationState: {
                        Active: "Actif",
                        Deleted: "Supprimé",
                        Suspended: "Désactivé",
                    },
                    LogLevel: {
                        Error: "Erreur",
                        Info: "Info",
                        Warning: "Avertissement",
                        Information: "Info",
                        Trace: "Trace",
                        Critical: "Critique",
                        Debug: "Debug",
                        None: "Aucune",
                    },
                    Month: {
                        April: "Avril",
                        August: "Août",
                        December: "Décembre",
                        February: "Février",
                        January: "Janvier",
                        July: "Juillet",
                        June: "Juin",
                        March: "Mars",
                        May: "Mai",
                        November: "Novembre",
                        October: "Octobre",
                        September: "Septembre",
                    },
                    NewOrdersViewMode: {
                        AtTheBottom: "En bas",
                        AtTheTop: "En haut",
                    },
                    OfferScheduleType: {
                        Closed: "Heure de fermeture",
                        DifferentOffer: "Planification divergente",
                        Standard: "Planification standard",
                    },
                    OperatorsCanBreakReservationRules: {
                        DoNotAllow: "Ne pas autoriser",
                        AllowAndNotify: "Notifier et autoriser",
                    },
                    OperatorsMustAcceptOrDeclineReservation: {
                        Never: "Jamais (automatisation maximale, risque maximal)",
                        OverbookingAbove: "Surbooking au-dessus de %",
                        IfNoTableCanBeAssigned: "Si aucune table ne peut être attribuée (y compris tous les surbookings)",
                        Always: "Toujours (aucune automatisation, risque minimal)",
                    },
                    OrderState: {
                        Canceled: "Annulé",
                        Closed: "Fait",
                        FullyPaid: "Entièrement payé",
                        Open: "Ouvert",
                        TimedOut: "Abandonné",
                        NotPaid: "Non payé",
                        ClosedNotPaid: "Exécuté, non payé",
                        PartiallyPaid: "Partiellement payé",
                    },
                    OrderStateMode: {
                        All: "Tous",
                        NotFulfilled: "Non exécuté",
                        Ready: "Prêt",
                        NotPaid: "Non payé",
                    },
                    PaymentProvider: {
                        Stripe: "Stripe",
                        Wallee: "Wallee",
                        PayTec: "PayTec",
                        Worldline: "Worldline",
                        PostFinance: "PostFinance",
                    },
                    PostFinanceContract: {
                        BrowserAndDevicePayment: "Navigateur et moyen de paiement",
                        PaymentDeviceOnly: "Uniquement appareil de paiement",
                    },
                    PaymentClient: {
                        Browser: "Navigateur",
                        PaymentDevice: "Appareil de paiement",
                    },
                    PaymentState: {
                        Confirmed: "Confirmé",
                        Declined: "Refusé",
                        Intented: "Demandé",
                    },
                    PreOrderRefundabilityType: {
                        Refundable: "Remboursable",
                        NoRefundable: "Non rimborsabile",
                        RefundableWithFee: "Remboursable avec frais",
                        RefundOptionalForOperators: "Remboursement facultatif pour les opérateurs",
                    },
                    PricingModel: {
                        Free: "Free",
                        Professional: "Premium",
                        Standard: "Standard",
                    },
                    PrintFontSize: {
                        Small: "Petit",
                        Medium: "Moyen",
                        Large: "Grand",
                    },
                    PrintJobState: {
                        Failed: "Échoué",
                        Pending: "En attente",
                        Printed: "Fini",
                        Unconfirmed: "Non confirmé",
                    },
                    PrintLayout: {
                        OrderAndPay76Mm: "Order & Pay (76mm, p. ex. TM-U220B)",
                        OrderAndPay80Mm: "Order & Pay (80mm petit, p. ex. TM-M30)",
                        OrderAndPay80MmBig: "Order & Pay (80mm grand, p. ex. TM-T88)",
                    },
                    PrinterProtocolType: {
                        EscPos: "ESC/POS",
                    },
                    PrinterState: {
                        ErrorState: "Erreur",
                        Offline: "Hors ligne",
                        OpenTrail: "Bac à papier ouvert",
                        OutOfPaper: "Pas de papier",
                        Ready: "Prêt",
                    },
                    ProductionTileViewMode: {
                        Detailed: "Detailed",
                        Overview: "Overview",
                    },
                    RatingValue: {
                        Bad: "Mauvaise",
                        Good: "Bon",
                        Ok: "OK",
                        VeryBad: "Très mauvais",
                        VeryGood: "Très bon",
                    },
                    RefundMode: {
                        Offline: "Hors ligne",
                        Online: "En ligne",
                    },
                    RefundType: {
                        OutsideTastier: "En dehors de Tastier",
                        StripeRefund: "Stripe remboursement",
                        WalleeRefund: "Wallee remboursement",
                    },
                    RoomShape: {
                        Landscape: "Paysage",
                        Portrait: "Vertical",
                        Square: "Carré",
                    },
                    ReportClaimValue: {
                        DontHaveAccessInOperatorAndMobilePos: "Ne voit pas",
                        ViewOnlyOwnSalesAndRevenue: "Voit ses propres",
                        ViewAllSalesAndRevenue: "Voit tous les",
                    },
                    SaleInquiryState: {
                        AutoEnroled: "Accès créé automatiquement",
                        Closed: "Fermé",
                        FirstContact: "Premier contact / demande",
                        InProgress: "En cours",
                    },
                    SalesReportViewType: {
                        Article: "Articles",
                        Category: "Catégories de rapports",
                        Detail: "Détails (articles avec options)",
                    },
                    OfferCategoryHighlightType: {
                        Normal: "Normal",
                        FullWidth: "Pleine largeur",
                    },
                    PermalinkMode: {
                        None: "Sans mode",
                        Kiosk: "Avec le mode kiosque",
                        Normal: "Avec le mode normal",
                    },
                    ServiceType: {
                        Covid: "Contrôle Covid",
                        Documents: "Documents",
                        Order: "Commander",
                        Ticketing: "Acheter des billets",
                        Website: "Lien",
                        Offer: "Offre",
                        Pay: "Payer",
                        RoomPlan: "Plan de salle",
                    },
                    ShortWeekDay: {
                        Friday: "Ve",
                        Monday: "Lu",
                        Saturday: "Sa",
                        Sunday: "Di",
                        Thursday: "Je",
                        Tuesday: "Ma",
                        Wednesday: "Me",
                    },
                    TableShape: {
                        Rectangle: "Rectangle",
                        Round: "Cercle",
                    },
                    TaskExecutionState: {
                        Executing: "En cours d'exécution",
                        Inactive: "Inactif",
                        Scheduled: "Programmé",
                    },
                    TaskSuccessState: {
                        Failed: "Échoué",
                        Success: "Réussi",
                    },
                    Weekday: {
                        Friday: "Vendredi",
                        Monday: "Lundi",
                        Saturday: "Samedi",
                        Sunday: "Dimanche",
                        Thursday: "Jeudi",
                        Tuesday: "Mardi",
                        Wednesday: "Mercredi",
                    },
                    Weekday3Letters: {
                        Friday: "ven",
                        Monday: "lun",
                        Saturday: "sam",
                        Sunday: "dim",
                        Thursday: "jeu",
                        Tuesday: "mar",
                        Wednesday: "mer",
                    },
                    OrdererRequirement: {
                        NotRequired: "Non requis",
                        Required: "Requis",
                        Optional: "Optionnel",
                        ConfirmedBlockOrder: "Confirmé (bloque la commande)",
                        ConfirmedCancelOrder: "Confirmé (annule la commande après 15 min)",
                    },
                    CreateOrderBillWithName: {
                        OrderNumber: "Numéro de commande (si activé) / Code de commande",
                        PartyName: "Nom du groupe (si disponible) / Numéro du groupe",
                    },
                },
                feedback: {
                    allRatings: "Toutes les évaluations",
                    failedDelete: "L'évaluation n'a pas pu être supprimée.",
                    fields: {
                        comment: "Remarque",
                        created: "Donné le",
                        rating: "Évaluation",
                    },
                    reallyDelete: "Faut-il vraiment supprimer cette évaluation ?",
                },
                general: {
                    copy: "Copier",
                    activate: "Activer",
                    all: "Tous/tes les",
                    alphabeticallyOrdered: "Alphabétique",
                    andMore: "et {{qty}} autres",
                    anonymousUser: "Utilisateur final anonyme",
                    attention: "Attention",
                    back: "Retour",
                    cancel: "Annuler",
                    change: "Modifier",
                    close: "Fermer",
                    confirm: "Bestätigen",
                    day: "Jour",
                    deactivate: "Désactiver",
                    delete: "Supprimer",
                    deletedLocation: "Site supprimé",
                    deletedOrder: "Commande supprimée",
                    deletedUser: "Utilisateur supprimé",
                    download: "Télécharger",
                    entities: {
                        fulfillmentGroups: "Groupes d'exécution",
                        item: "Article",
                        location: "Site",
                        locations: "Sites",
                        offer: "Offre",
                        offerSchedule: "Planification",
                        offers: "Offres",
                        option: "Option",
                        optionGroup: "Groupe d'options",
                        optionGroups: "Groupes d'options",
                        options: "Options",
                        order: "Commande",
                        orders: "Commandes",
                        orderApplications: "Applications de Commande",
                        productionSite: "Lieu de production",
                        productionSites: "Lieux de production",
                        room: "Salle",
                        rooms: "Salles",
                        shift: "Horaire",
                        shifts: "Horaires",
                        table: "Table",
                        user: "Utilisateur",
                        cancellation: "Annullamento",
                    },
                    export: "Exporter",
                    failed: "Échoué",
                    failedCreate: "L'entrée n'a pas pu être créée.",
                    failedLoad: "L'entrée n'a pas pu être chargée.",
                    failedLoadingData: "Les données n'ont pas pu être chargées.",
                    failedRemove: "L'entrée n'a pas pu être supprimée.",
                    failedUpdate: "L'entrée n'a pas pu être modifiée.",
                    fields: {
                        active: "Actif",
                        available: "Disponible",
                        birthday: "Date de naissance",
                        created: "Créé",
                        date: "Date",
                        description: "Description",
                        designation: "Désignation",
                        displayName: "Désignation différente",
                        email: "E-mail",
                        firstName: "Prénom",
                        inactive: "Désactivé",
                        internalName: "Désignation interne",
                        internalNote: "Note interne",
                        language: "Langue",
                        lastName: "Nom",
                        name: "Nom",
                        notes: "Notes",
                        oohPrice: "Prix hors domicile",
                        phone: "Téléphone",
                        price: "Prix",
                        sort: "Ordre",
                        sortOrder: "Ordre",
                        state: "Statut",
                        time: "Heure",
                        type: "Mode",
                        open: "Libre",
                    },
                    forward: "Continuer",
                    loading: "En cours de chargement...",
                    locationSwitch: {
                        lastLocations: "Derniers sites",
                        noLocationsFound: "Aucun site trouvé",
                        pleaseSelect: "Sélectionner un site...",
                        searchResults: "Résultats de recherche",
                    },
                    month: "Mois",
                    no: "Non",
                    noItemsFound: "Aucune entrée trouvée",
                    noSearchResults: "Aucun résultat trouvé",
                    none: "Rien",
                    of: "sur",
                    pagination: "Enregistrements: {{from}} - {{until}}",
                    reallyRemove: "Êtes-vous sûr de vouloir supprimer définitivement cette entrée ?",
                    remove: "Supprimer",
                    reset: "Réinitialiser",
                    save: "Sauvegarder",
                    search: "Rechercher",
                    searchTerm: "Terme de recherche...",
                    searchingResults: "En cherchant les résultats...",
                    addNewValue: "Ajouter « {{value}} »",
                    send: "Envoyer",
                    successfullyCreated: "Entrée sauvegardée avec succès",
                    successfullyRemoved: "Entrée supprimée avec succès",
                    successfullyUpdated: "Entrée modifiée avec succès",
                    timeFormat: {
                        agoCount: "il y a {{count}}",
                        always: "Toujours",
                        daily: "Tous les jours",
                        daysWithCount_one: "{{count}} jour",
                        daysWithCount_other: "{{count}} jours",
                        end: "Fin",
                        from: "à partir de",
                        fromStart: "à partir de {{start}}",
                        hoursWithCount_one: "{{count}} heure",
                        hoursWithCount_other: "{{count}} heures",
                        inCount: "dans {{count}}",
                        minutesWithCount_one: "{{count}} minute",
                        minutesWithCount_other: "{{count}} minutes",
                        never: "Jamais",
                        notYet: "Pas encore",
                        nowCurrentTime: "Maintenant / heure actuelle",
                        range: "{{start}} jusq'au {{end}}",
                        secondsWithCount_one: "{{count}} seconde",
                        secondsWithCount_other: "{{count}} secondes",
                        start: "Début",
                        until: "jusq'au",
                        untilEnd: "jusq'au {{end}}",
                        weekdays: "Jours de la semaine",
                        wholeDay: "toute la journée",
                    },
                    today: "Aujourd'hui",
                    unknown: "Inconnu",
                    yes: "Oui",
                    enabled: "Activé",
                    disabled: "Désactivé",
                },
                identicalEntry: {
                    title: "Texte identique trouvé",
                    message: "Un autre élément existe déjà avec exactement le même texte {{- texts}} en {{- languages}}. Veuillez modifier le texte afin d'éviter un doublon.",
                    editText: "Modifier le texte",
                    saveAnyway: "Enregistrer quand même",
                    languages: {
                        English: "anglais",
                        German: "allemand",
                        French: "français",
                        Italian: "italien",
                    },
                },
                issue: {
                    allStates: "Tous les statuts",
                    fields: {
                        lastModified: "Dernière modification",
                        message: "Message",
                        received: "Reçu",
                    },
                },
                item: {
                    fields: {
                        categories: "Catégories d'offre",
                    },
                    insufficientStock: "Stock trop faible. Veuillez l'augmenter, réduire le stock minimum ou désactiver la fonction de stock.",
                    articleMinQuantityGreaterThanOptionGroupMaxPerOption: "La quantité minimale de {{article}} ({{articleMinQuantity}}) ne peut être supérieure à la Quantité max. par option dans le Groupe d'options {{optionGroup}} ({{optionGroupMaxPerQuantity}}).",
                    noCategory: "Aucune catégorie",
                    noFulfillmentGroup: "Aucun Groupe d'Exécution",
                    itemCopiedAndEditingNow: "Article copié. Vous modifiez maintenant la version copiée de l'article",
                    itemDeletionFailed: "L'article ne peut pas être supprimé",
                    missingStandardServiceDurationForSeats: "Les articles avec la ressource “Places assises” doivent avoir un Groupe d’exécution avec une Durée de service standard attribué.",
                    openPriceAndPricePerMinuteExclusive: "Un article ne peut pas être à la fois un article à prix par minute et un article à prix libre.",
                    fulfillmentGroupCannotBeRemoved: "Ce Groupe d’exécution ne peut pas être supprimé, car il a déjà été utilisé dans des commandes.",
                },
                location: {
                    allStates: "Tous les statuts",
                    covidContactTracing: "Contrôle Covid",
                    failedToExport: "Les sites n'ont pas pu être exportés.",
                    translation: {
                        key: "Clé",
                        newEntry: "Nouvelle entrée",
                    },
                    childLocations: {
                        internalNameOfAllChildLocationsMustBeUniqueError: "La dénomination interne de tous les sites enfants doit être unique.",
                        internalNameAlreadyInUseByAnotherLocationError: "La dénomination interne est déjà utilisée par un autre site associé au même site parent.",
                        linkedLocationCircularRelationError: "Un site sélectionné est un site parent du site en cours de modification. Veuillez supprimer le site et réessayer.",
                    },
                    psp: {
                        oneIconForAllStripePaymentMethods: "Une icône pour tous les moyens de paiement Stripe",
                        oneIconForAllWalleePaymentMethods: "Une icône pour tous les moyens de paiement Wallee",
                        missingDefaultPaymentMethodConfiguration: "Configuration par défaut manquante pour le mode de paiement: {{paymentMethodName}}",
                    },
                    twilio: {
                        accountSid: "Account SID",
                        create: "Créer un compte",
                        created: "Le compte Twilio a été créé avec succès.",
                        currentConnected: "Compte lié",
                        delete: "Supprimer",
                        deleted: "Le compte Twilio a été supprimé.",
                        failedCreate: "Impossible de lier le compte Twilio.",
                        failedDelete: "Le compte Twilio n'a pas pu être supprimé.",
                        reallyCreate: "Vous voulez vraiment créer un compte dans Twilio ?",
                        reallyDelete: "Supprimer le compte de manière permanente ? Le relevé de frais reste visible.",
                        serviceSid: "Service SID",
                    },
                    locationSlugNotAvailable: "Cette adresse internet est déjà prise, veuillez la modifier. Disponible: {{proposedSlugs}}",
                    locationHasOrdersOrPayments: "Ce site ne peut pas être supprimé en raison des commandes et des paiements effectués.",
                    copyFailed: "Le site a été enregistré, mais il n'a pas pu être copié.",
                },
                login: {
                    backToLogin: "Retour à la connexion",
                    enterValidEmail: "Veuillez saisir une adresse e-mail valide.",
                    enterValidPassword: "Veuillez saisir un mot de passe valide.",
                    failedResetPw: "Malheureusement, le mot de passe n'a pas pu être réinitialisé.",
                    featureNotImplemented: "Coming Soon - Les entreprises clientes du modèle gratuit n'ont malheureusement pas encore accès. Nous y travaillons et vous informerons dès que vous pourrez vous connecter. Pour toute question : marketing@tastier.ch",
                    login: "Connexion",
                    loginFailedBlocked: "Echec de la connexion en raison d'un manque de permissions. Veuillez vous assurer que vous avez bien activé votre compte.",
                    loginFailedCredentials: "E-mail ou mot de passe non valide",
                    passwordLost: "Mot de passe oublié ?",
                    resetPassword: "Réinitialisation du mot de passe",
                    resetPasswordBtn: "Réinitialiser",
                    resetPwSuccess: "Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe. Veuillez vérifier votre boîte de réception et, le cas échéant, votre dossier de courrier indésirable.",
                    signinBtn: "Se Connecter",
                    emailAlreadyUsed: "Cet e-mail est déjà utilisé.",
                },
                modal: {
                    addOptionGroup: {
                        newGroupBtn: "Nouveau groupe d'options",
                        options: "Options",
                        saveItems: "Sauvegarder ({{items}} articles)",
                        showsInItems: "Apparaît dans les articles",
                        title: "Ajouter un groupe d'options",
                    },
                    addOptionToGroup: {
                        categories: "Catégories",
                        newItemBtn: "Nouvel article",
                        saveItems: "Sauvegarder ({{items}} articles)",
                        title: "Ajouter une option",
                    },
                    allocationHistoryExport: {
                        failedToExport: "Les visites n'ont pas pu être exportées.",
                        fromTo: "Date du / jusqu'au",
                        selectLocation: "Sélectionner le site...",
                        selectTable: "Choisir une table...",
                        settings: "Paramètres",
                        title: "Exporter les visites",
                    },
                    cancellation: {
                        cancellationFailed: "La commande n'a pas pu être annulée.",
                        cancellationNotAllowedForPayment: "L’annulation n’est pas autorisée pour ce paiement.",
                        canStockBeReused: "Le stock peut-il être réutilisé?",
                        confirmMessage: "{{amt}} CHF vraiment annuler ? Cela ne peut pas être annulé.",
                        confirmTitle: "Effectuer l'annulation ?",
                        failedLoading: "La commande n'a pas pu être chargée.",
                        loading: "Commande en cours de chargement...",
                        notNow: "Pas maintenant",
                        notPaid: "Non payé",
                        offlineMode: "Remboursement hors ligne",
                        paid: "Payé",
                        payment: "Paiement",
                        paymentMethod: "Moyen de paiement",
                        positionSectionTitle: "Quelles unités de <b>{{itemName}}</b> doivent être annulées ?",
                        positionsText: "Sélectionner les postes à annuler :",
                        reason: "Raison",
                        quantity: "Quantité",
                        status: "Statut",
                        submitBtn: "Oui, annuler",
                        title: "Annulation",
                        user: "Utilisateur",
                        wholeOrderText: "La commande entière sera annulée.",
                        singleCancellationFailed: "L'annulation a échoué. Veuillez réessayer.",
                        multipleCancellationsFailed: "Au moins une annulation a échoué. Certains paiements n’ont peut-être pas été remboursés. Veuillez réessayer.",
                        multiplePdPaymentCancellationsNotSupported: "Cette annulation comprend plusieurs paiements via un appareil de paiement. Veuillez la limiter à un seul paiement via appareil de paiement.",
                        twintOnlineRefundNotSupported: "Les paiements Twint effectués sur des appareils de paiement ne peuvent pas être remboursés.",
                    },
                    documentCondition: {
                        allRooms: "Toutes les salles",
                        failedToSave: "La planification ne pouvait pas être modifiée.",
                        recurrence: "Horaire",
                        time: "Heure",
                        timeRange: "Date",
                        titleCreate: "Créer une planification",
                        titleEdit: "Planification",
                    },
                    documentSchedule: {
                        allRooms: "Toutes les salles",
                        title: "Vue calendrier",
                    },
                    locationAccess: {
                        editLocation: "Détails du site",
                        failedGranting: "La permission n'a pas pu être accordée. Raison : {{reason}}",
                        grants: "Permission",
                        title: "Accorder une nouvelle permission",
                    },
                    locationExport: {
                        exportSetting: "Paramètres d'exportation",
                        failedExport: "Les sites n'ont pas pu être exportés.",
                        title: "Exporter les sites",
                        viewType: "Mode",
                        withRooms: "Avec des salles",
                        withoutRooms: "Normal",
                    },
                    locationSuspend: {
                        suspendBtn: "Désactiver",
                        suspendText: "Ce site est actuellement actif. Souhaitez-vous désactiver ce site ?",
                        title: "Désactiver le site",
                        unsuspendBtn: "Activer",
                        unsuspendText: "Ce site est actuellement inactif. Souhaitez-vous réactiver ce site ?",
                        unsuspendTitle: "Activer le site",
                    },
                    offerRoomActivation: {
                        failedActivation: "L'offre n'a pas pu être activée.",
                        failedDeactivation: "L'offre n'a pas pu être désactivée.",
                        failedReset: "Échec de la réinitialisation",
                        reset: "Réinitialiser à la planification",
                        successfulActivation: "Offre activée avec succès. Ceci est valable jusqu'à la prochaine désactivation planifiée ou manuelle.",
                        sucessfulDeactivation: "Offre désactivée avec succès. Ceci est valable jusqu'à la prochaine activation planifiée ou manuelle.",
                        sucessfulReset: "Réinitialisation réussie",
                        title: "Activer / désactiver l'offre",
                    },
                    offerSchedule: {
                        title: "Vue calendrier",
                        differentOffers: "Différentes offres",
                    },
                    orderExport: {
                        failedExport: "Les commandes n'ont pas pu être exportées.",
                        invalidDateRangeForOrder: "La durée de la période de rapport ne peut pas dépasser 8 jours, et la date de début doit être dans les 90 derniers jours.",
                        settings: "Étendue",
                        title: "Exporter des commandes",
                    },
                    stockExport: {
                        failedExport: "Le stock n'a pas pu être exporté.",
                    },
                    printOrderReceipt: {
                        title: "Imprimer le Reçu",
                    },
                    reprintOrder: {
                        failedSending: "Le travail d'impression n'a pas pu être envoyé.",
                        hint: "Réimprimez cette commande sur les lieux de production suivants.",
                        printBtn: "Imprimer",
                        settings: "Paramètres",
                        success: "Le travail d'impression est à nouveau envoyé.",
                        title: "Réimprimer la commande",
                    },
                    salesReportExport: {
                        dailySummaryReport: "Rapport de synthèse journalier",
                        exportSetting: "Étendue",
                        failedExport: "Le rapport des ventes n'a pas pu être exporté.",
                        invalidReportDateRangeException: "La période de déclaration ne doit pas dépasser 93 jours. Pour des périodes plus longues, veuillez contacter le service d'assistance.",
                        paymentMethodsReport: "Rapport sur les moyens de paiement",
                        title: "Rapport des ventes",
                        useDetailedNames: "Présentation détaillée",
                        specialReports: "Rapports spéciaux",
                        levelOfDetail: "Niveau de détail",
                        orderFulfillmentReport: "Rapport d'exécution des commandes",
                    },
                    sendOrderReceipt: {
                        failedSending: "Le reçu n'a pas pu être envoyé.",
                        receiver: "Destinataire",
                        sentTo: "Le reçu a été envoyé à {{receiver}}",
                        settings: "Paramètres",
                        title: "Envoyer le Reçu",
                    },
                    transactionCompare: {
                        settings: "Paramètres",
                        dateFromTo: "Date du / au",
                        compareTransactions: "Comparer les transactions",
                        startComparison: "Démarrer la comparaison",
                        totalCompared: "Total comparé",
                        matches: "Correspondances",
                        differences: "Différences",
                        comparingHasMade: "La comparaison est en cours...",
                        comparingTransactionDescription: "Cela peut prendre quelques minutes. Veuillez garder cette fenêtre ouverte pendant la comparaison.",
                        comparisonFailed: "Échec de la comparaison",
                        pleaseTryAgain: "Veuillez réessayer plus tard.",
                        transactionsCouldNotBeCompared: "Les transactions ne peuvent pas être comparées.",
                        date: "Date",
                        transaction: "Transaction",
                        order: "Commande",
                        comment: "Commentaire",
                        link: "Lien",
                    },
                    locationPaymentMethod: {
                        addTitle: "Ajouter un mode de paiement de localisation",
                        editTitle: "Modifier le mode de paiement de l'emplacement",
                        locationPaymentMethod: "Mode de paiement de localisation",
                        contract: "Contrat",
                        name: "Nom",
                        merchantId: "ID du commerçant",
                        mode: "Mode",
                        displayIcon: "Afficher l'icône",
                        logo: "Logo",
                        provider: "Fournisseur",
                        additionalSettings: "Paramètres additionnels",
                        paymentMethodExternalId: "ID du moyen de paiement",
                        isCreditDebitCard: "Exploité par une société de paiement par carte (card scheme)",
                        paymentDevice: "Appareil de paiement",
                        isEnabled: "Activé",
                        order: "Ordre",
                        failedDelete: "Le moyen de paiement n'a pas pu être supprimé.",
                        failedEdit: "Le moyen de paiement de l'emplacement n'a pas pu être modifié.",
                        deviceId: "ID de l'appareil",
                        allowTipOnlyOnDevice: "Autoriser la saisie des pourboires uniquement sur l'appareil",
                        useTerminalApi: "Utiliser l'API du terminal",
                        apiToken: "Jeton API",
                        integratorId: "ID de l'intégrateur",
                        revenueEffective: "Génératrice de chiffre d’affaires",
                        pairingCode: "Pairing code",
                        pairConnect: "Jumeler et connecter",
                        disconnect: "Déconnecter",
                        deviceDisconnected: "L’appareil a été déconnecté avec succès.",
                        deviceConnected: "L’appareil a été connecté avec succès.",
                        deviceConnectFailed:
                            "La connexion au terminal PayTec a échoué. Vérifiez le code de jumelage ou le jeton d’accès et assurez-vous que le terminal est en ligne.",
                        connect: "Connecter",
                    },
                    service: {
                        addTitle: "Ajouter un service",
                        editTitle: "Modifier le service",
                        failedDelete: "Le service n'a pas pu être supprimé.",
                        failedEdit: "Le service n'a pas pu être modifié.",
                        icon: "Icône",
                        customIcon: "Icône personnalisée",
                        customDesignation: "Désignation personnalisée",
                        service: "Service",
                        settings: "Paramètres",
                        image: "Image",
                    },
                    sessionExpired: {
                        signinBtn: "Se Connecter",
                        text: "Vous avez été déconnecté en raison d'une inactivité prolongée. Veuillez vous reconnecter.",
                        title: "Session expirée",
                    },
                    supportIssue: {
                        editRequest: "Modifier la demande",
                        failedDelete: "La demande n'a pas pu être supprimée.",
                        failedEdit: "La demande n'a pas pu être modifiée.",
                        title: "Modifier la demande d'assistance",
                    },
                    voucherBulk: {
                        title: "Nouveau bon",
                        internalNote: "Note interne",
                        isActive: "Activé",
                        value: "Value",
                        voucherQty: "Nombre",
                        create: "Créer",
                    },
                    tableBulk: {
                        action: "Opération",
                        conventionPlaceholder: "p. ex. Table [Number]",
                        conventionText: 'p. ex. entrer "Table" et cliquer sur "Insérer numéro".',
                        createAtLeast: "Au moins 1 salle doit être créée.",
                        deleteMultiple: "Supprimer plusieurs tables",
                        editCreateMultipleTables: "Créer / modifier plusieurs tables",
                        editPosId: "Modifier l'ID POS",
                        execute: "Exécuter",
                        failedEdit: "Les tables n'ont pas pu être modifiées.",
                        failedLimitExceeded: "Le nombre maximum de tables a été dépassé. Prenez contact avec notre service des ventes pour adapter votre abonnement.",
                        failedNoAffected: "Aucune table n'a été modifiée par l'opération.",
                        failedNoSubscription: "Ce site n'a actuellement pas d'abonnement actif.",
                        hidePosId: "Masquer l'ID POS",
                        insertNumber: "Insérer le numéro",
                        posId: "ID POS",
                        previewNoneDelete: "Attention : aucune table ne sera supprimée.",
                        previewPluralDelete: "Attention : {{amount}}  tables seront supprimées.",
                        previewPluralEdit: "Attention : {{amount}}  tables seront écrasées.",
                        previewSingularDelete: "Attention : 1 table sera supprimée.",
                        previewSingularEdit: "Attention : 1 table sera écrasée.",
                        seatCount: "Nombre de places",
                        preferredMinimumOccupancy: "Occupation minimale préférée",
                        selectRoom: "Sélectionner une salle...",
                        tableNrFromTo: "Numéro de table de / à",
                        tableNrPlaceholder: "p. ex. 10",
                        title: "Plusieurs tables",
                        whatToDo: "Que faut-il faire ?",
                    },
                    transactionExport: {
                        allStates: "Tous les statuts",
                        dateFromTo: "Date du / au",
                        exportSetting: "Paramètres",
                        failedExport: "Les paiements n'ont pas pu être exportés",
                        selectLocation: "Sélectionner le site...",
                        title: "Exporter des paiements",
                    },
                    translation: {
                        addTitle: "Créer une entrée",
                        editTitle: "Modifier l'entrée",
                        failedDelete: "L'entrée n'a pas pu être supprimée.",
                        failedEdit: "Le texte n'a pas pu être édité.",
                        key: "Clé",
                        systemText: "Texte du système",
                        text: "Texte",
                    },
                    userAccess: {
                        editLocation: "Modifier le site",
                        failedEdit: "La permission n'a pas pu être accordée. Raison : {{reason}}",
                        grants: "Permission",
                        kind: "Mode",
                        title: "Accorder une nouvelle permission",
                    },
                },
                offer: {
                    activate: "Activer",
                    activateDeactivate: "Activer / Désactiver",
                    activated: "L'offre {{offer}} a été activée.",
                    deactivate: "Désactiver",
                    deactivated: "L'offre {{offer}} a été désactivée.",
                    failedActivate: "L'offre n'a pas pu être activée.",
                    failedDeactivate: "L'offre n'a pas pu être désactivée.",
                    offerCopiedAndEditingNow: "Offre copiée. Vous modifiez maintenant la version copiée de l’offre.",
                    orderApplications: "Applications de Commande",
                },
                offerSchedule: {
                    allOffers: "Toutes les offres",
                    allOrderApplications: "All applications",
                    allRooms: "Toutes les salles",
                    allTypes: "Tous les types",
                    failedIntersection: "Chevauchement avec {{lien}}",
                    fields: {
                        currentActive: "Actif maintenant",
                        currentSchedule: "Planification actuelle",
                        weekdayAndTime: "Jours de la semaine & heure",
                    },
                    offerScheduleCopiedAndEditingNow: "Planification copiée. Vous modifiez maintenant la version copiée de la planification.",
                    failedPlanningOverlapsOtherPlanning: "Cette planification se chevauche avec une autre planification",
                },
                optionGroup: {
                    fields: {
                        appearsInItems: "Apparaît dans les articles",
                    },
                    optionGroupCopiedAndEditingNow: "Groupe d’options copié. Vous modifiez maintenant la version copiée.",
                },
                offerCategory: {
                    imagesNotCopied: "Les images de la catégorie source n’ont pas pu être copiées. Veuillez les ajouter manuellement.",
                    offerCategoryCopiedAndEditingNow: "Categorie d’offre copiée. Vous modifiez maintenant la version copiée.",
                },
                order: {
                    allStates: "Tous les statuts",
                    deletedTable: "Table supprimée",
                    consumptionInclVat: "Consommation (incl. {{vat}}% TVA)",
                    fields: {
                        cancellation: "Annulation",
                        consumption: "Consommation",
                        discount: "Remise",
                        dailyOrderIncrement: "Numéro de commande",
                        fulfillDate: "Date",
                        orderNumber: "Code de commande",
                        tip: "Pourboire",
                        useCase: "Application",
                        totalIncTip: "Total (y compris le pourboire)",
                        total: "Total",
                        fulfilmentTime: "Heure d'exécution",
                        scheduled: "Programmé",
                    },
                },
                productionSite: {
                    cancelJob: "Annuler le travail d'impression",
                    changeProtocolHint: "La modification du protocole ou du format supprime tous les travaux d'impression non encore exécutés.",
                    failedCancelJob: "Le travail d'impression n'a pas pu être annulé.",
                    failedDeleteJob: "Le travail d'impression n'a pas pu être supprimé.",
                    failedToSendTestPrint: "Test d’impression n'a pas pu être envoyée à l'imprimante.",
                    usedAsBackup: "Ce lieu de production ne peut pas être supprimé, car il est défini comme lieu de secours dans : {{forwardingProductionSites}}. Retirez-le d'abord à cet endroit.",
                    fields: {
                        backupPrint: "Impression transférée",
                        backupSite: "Transfert",
                        forwarded: "Transféré",
                        isActive: "Activé",
                        lastCommunication: "Dernière communication",
                        layout: "Format",
                        protocol: "Protocole",
                    },
                    noJobs: "Aucun travail d'impression disponible",
                    reallyCancel: "Faut-il vraiment annuler ce travail d'impression ?",
                    selectProductionSite: "Choisir le lieu de production...",
                    testPrintSent: "Test d’impression envoyée à l'imprimante",
                },
                room: {
                    activateService: "Veuillez activer un service",
                    addService: "Ajouter un service",
                    failedChangingOrder: "L'ordre ne pouvait pas être modifié. Veuillez recharger la fenêtre du navigateur.",
                    failedLimitExceeded: "Le nombre maximum de salles a été dépassé. Prenez contact avec notre service des ventes pour augmenter votre abonnement.",
                    failedLoadingServices: "Les services n'ont pas pu être chargés.",
                    failedTableReferences: "La salle ne peut pas être supprimée, car des tables lui sont attribuées.",
                    fields: {
                        deallocationDelay: "Durée de checkout autom.",
                        services: "Services",
                        endUserServices: "Services à l'utilisateur final",
                        operatorServices: "Services à l'opérateur",
                    },
                },
                saleInquiry: {
                    allStates: "Tous les statuts",
                    fields: {
                        company: "Commerce",
                        lastModified: "Dernière modification",
                        location: "Ville",
                        person: "Utilisateur",
                        priceModel: "Modèle",
                        received: "Reçu",
                    },
                },
                signup: {
                    accessCreated: "Compte créé. Pour activer votre compte, nous vous avons envoyé un e-mail à <b>{{email}}</b>, veuillez vérifier votre boîte de réception et, le cas échéant, votre dossier spam.",
                    failed: "L'enregistrement n'a pas pu être terminé. Veuillez réessayer.",
                    fields: {
                        password: "Mot de passe",
                    },
                    success: "Vous vous êtes déjà inscrit avec succès et avez activé votre accès au portail pour les entreprises.",
                },
                stock: {
                    disableWarning: "Augmenter le stock et mettre l'article disponible afin de le vendre",
                    failedSave: "Le stock d'articles n'a pas pu être traité.",
                    fields: {
                        safetyStock: "Stock minimum",
                        stock: "Stock actuel",
                    },
                },
                subscription: {
                    allLocations: "Tous les sites",
                    customForCustomer: "Personnalisé",
                    fields: {
                        covid: "Contrôle Covid",
                        documents: "Documents",
                        pay: "Payer",
                        preset: "Modèle",
                        validUntil: "Valable jusqu'au",
                    },
                    unrestricted: "Illimité",
                },
                system: {
                    fields: {
                        level: "Level",
                        message: "Message",
                        time: "Heure",
                        title: "Titre",
                    },
                },
                table: {
                    allDataOrigins: "Toutes les sources de données",
                    allRooms: "Toutes les salles",
                    allUsersDeallocated: "Tous les utilisateurs ont été retirés de la table.",
                    downloadAllQr: "Télécharger Tous les QR Codes",
                    downloadAllQrText: "Téléchargez ici tous les QR codes sous forme de fichier zip. Copiez les fichiers png du fichier zip dans un traitement de texte ou un programme graphique. Ajoutez des informations pour les visiteurs et créez vos impressions (suivez les recommandations). Alternativement, Tastier propose ce service.",
                    downloadBtn: "Télécharger",
                    editPosId: "Modifier l'ID POS",
                    failedDeallocating: "Les utilisateurs ne pouvaient pas être retirés de la table.",
                    failedReset: "La table n'a pas pu être réinitialisée.",
                    fields: {
                        requireInfo: "Saisie de texte libre",
                        seats: "Nombre de places",
                        tableNumber: "Numéro de table",
                    },
                    hidePosId: "Masquer l'ID POS",
                    permalink: {
                        copiedClipboard: "L'URL a été copiée dans le presse-papiers.",
                        create: "Créer un lien direct",
                        failedCreate: "Le lien direct n'a pas pu être créé.",
                        failedDelete: "Le lien direct n'a pas pu être supprimé.",
                        reallyDelete: "Ce lien direct doit-il être supprimé de manière permanente ?",
                        mode: "Mode",
                    },
                    successReset: "La table a été réinitialisée avec succès.",
                    tableNumerInUse: "Numéro de table ou POS ID déjà utilisé",
                    table: "Table",
                },
                task: {
                    failedStart: "L'exécution de la tâche n'a pas pu être lancée.",
                    fields: {
                        duration: "Durée",
                        interval: "Intervalle",
                        nextExecution: "Prochaine exécution",
                        result: "Résultat",
                        started: "Lancé",
                    },
                    started: "La tâche a été lancée.",
                },
                transaction: {
                    allLocations: "Tous les sites",
                    allStates: "Tous les statuts",
                    fields: {
                        amount: "Montant",
                        fees: "Frais",
                        paymentMethod: "Moyen de paiement",
                        paymentMethodButton: "Bouton de moyen de paiement",
                        provider: "PSP",
                        client: "Client",
                    },
                },
                useCase: {
                    preorderRoomsWithoutPlanningException: "Il manque une Planification pour : {{roomNames}} pour cette Application de Commande avec le paramètre “Commander pour: Maintenant ou plus tard”. ",
                    orderApplicationCopiedAndEditingNow: "Application de commande copiée. Vous modifiez maintenant la version copiée de l'application de commande.",
                    failedDelete: "L'application n'a pas pu être supprimée car elle est utilisée par le service {{dependingName}}.",
                    tooManyQuickPaymentMethodsEnabled: "Il est possible d'activer jusqu'à {{maxEnabledPaymentMethodsCount}} moyens de paiement rapide.",
                    atLeastOneDeliveryAreaRequiredError: "Au moins une zone de livraison est requise",
                    minimumTotalUnitsPerOrderGreaterThanMaximumError: "Le nombre total minimum d’unités par commande ne peut pas être supérieur au maximum.",
                    minimumTotalUnitsPerOrderInvalidError: "Le nombre total minimum d’unités par commande doit être d’au moins 1.",
                    maximumTotalUnitsPerOrderInvalidError: "Le nombre total maximum d’unités par commande doit être d’au moins 1.",
                    fields: {
                        buyerRequirement: "Exigence de l'acheteur",
                        consumptionSite: "Lieu de consommation",
                        fulfillmentPositionDisplayMode: "Afficher l'exécution",
                        fulfillmentHandling: "Où?",
                        fulfillmentTimeMode: "Afficher l’heure d'exécution",
                        tip: "Pourboire",
                        usePayment: "Paiement",
                        usePreorder: "Commander pour",
                        maxPreorderPeriod: "Durée maximale de précommande",
                    },
                    guest: "Invité",
                    payment: {
                        offline: "Moyens de paiement hors ligne",
                        online: "Moyens de paiement en ligne",
                        other: "Autres",
                        paymentDevices: "Appareils de paiement",
                    },
                    preorderOff: "Maintenant",
                    preorderOn: "Maintenant ou plus tard",
                    waiter: "Serveurs",
                    operators: "Opérateurs",
                    endUsers: "Utilisateurs finaux",
                    quickButton: "Moyen de paiement rapide",
                    defaultMessageToUserBeforeOrder: "Salut, nous sommes impatients de recevoir ta commande.",
                    defaultOrderReminderPushNotificationMessage: "Ta commande est prévue pour être retirée dans 1 h",
                    defaultOrderReminderPushNotificationTitle: "Retrait prévu",
                    pickupOrderPushNotificationTitle: "Retirer la commande",
                    pickupOrderPushNotificationMessage: "Ta commande est prête à être retirée",
                    notRevenueEffective: "Non impactant sur le chiffre d'affaires",
                    permission: "Autorisation",
                },
                notification: {
                    notifiedWhenOrderReadyWithDuration: "Tu seras prévenu lorsque ta commande sera prête à être récupérée. Temps d'attente prévu (indicatif, peut changer à tout moment):",
                    notifiedWhenOrderReadyWithPosition: "Tu seras prévenu lorsque ta commande sera prête à être récupérée. Position actuelle sur la liste d'attente:",
                },
                user: {
                    allRoles: "Tous les rôles",
                    allUsers: "Tous les utilisateurs",
                    anonymous: "Anonyme",
                    anonymousUser: "Utilisateur final anonyme",
                    failedResetPassword: "Le mot de passe n'a pas pu être réinitialisé.",
                    fields: {
                        claimType: "Type de permission",
                        devices: "Appareil",
                        emailConfirmed: "E-mail confirmé",
                        lastLogin: "Dernière connexion",
                        loginProviders: "Connexion via",
                    },
                    newGrant: "Nouvelle permission",
                    noGrants: "Pas de permission attribuée",
                    onlyAnonymousUser: "Utilisateurs anonymes uniquement",
                    onlySignedUpUsers: "Utilisateurs inscrits uniquement",
                    passwordSet: "Le mot de passe a été modifié avec succès.",
                    reallyRemoveGrant: "Révoquer vraiment la permission ?",
                    removeGrant: "Révoquer",
                    signedUp: "Inscrit",
                },
                voucher: {
                    alreadyUsedCannotBeDeleted: "Le bon a déjà été utilisé et ne peut pas être supprimé.",
                    fields: {
                        created: "Créé",
                        expiryDate: "Date d’expiration",
                        initialValue: "Valeur initiale",
                        balance: "Solde",
                        code: "Code du bon",
                        internalNote: "Note interne",
                        isActive: "Activé / Désactivé",
                        cancellation: "Annulation",
                    },
                    voucherCode: {
                        copiedClipboard: "Code du bon a été copiée dans le presse-papiers.",
                    },
                },
                voucherDesign: {
                    addEmptyTextBox: "Ajouter une zone de texte vide",
                    areYouSureYouWantToLeave: "Vous avez des modifications non enregistrées. Si vous quittez cet onglet, elles seront perdues. Voulez-vous continuer ?",
                    areYouSureYouWantToRemoveTemplate: "Voulez-vous vraiment supprimer ce modèle de conception de bon ? Cela rétablira le modèle par défaut.",
                    backgroundColor: "Couleur d’arrière-plan",
                    backgroundImage: "Image d’arrière-plan",
                    clear: "Effacer",
                    edit: "Modifier",
                    emptyTextBox: "Zone de texte vide",
                    errorRemovingTemplate: "Une erreur est survenue lors de la suppression du modèle de conception de bon.",
                    expirationDate: "Date d’expiration",
                    failedDeleteImage: "Échec de la suppression de l’image. Veuillez réessayer.",
                    imageLibrary: "Images personnalisées",
                    invoiceAddress: "Adresse de facturation",
                    loadingImages: "Chargement des images...",
                    locationAddress: "Adresse de l’établissement",
                    locationName: "Nom de l’établissement",
                    logo: "Logo",
                    marginSize: "Marge",
                    noImagesAvailable: "Aucune image disponible",
                    pageSettings: "Paramètres de page",
                    predefinedImages: "Images",
                    preview: "Aperçu",
                    qrCode: "Code QR",
                    reallyDeleteImage: "Voulez-vous vraiment supprimer « {{name}} » ?",
                    toolbar: {
                        alignCenter: "Centrer",
                        alignJustify: "Justifier",
                        alignLeft: "Aligner à gauche",
                        alignRight: "Aligner à droite",
                        bold: "Gras",
                        bulletList: "Liste à puces",
                        heading1: "Titre 1",
                        heading2: "Titre 2",
                        heading3: "Titre 3",
                        heading4: "Titre 4",
                        heading5: "Titre 5",
                        horizontalRule: "Ligne horizontale",
                        italic: "Italique",
                        orderedList: "Liste ordonnée",
                        paragraph: "Paragraphe",
                        strike: "Barré",
                        textColor: "Couleur du texte",
                        textType: "Type de texte",
                        underline: "Souligner",
                    },
                    upload: "Téléverser",
                    uploadedImage: "Image téléversée",
                    variables: "Texte",
                    variablesNotPresent: "Les variables suivantes ne sont pas présentes dans le document : {{variables}}",
                    voucherBalance: "Solde du bon",
                    voucherCode: "Code du bon",
                    voucherDesign: "Design du bon",
                },
            },
        },
        it: {
            translation: {
                activity: {
                    failedLoading: "Le ultime attività non possono essere caricate.",
                    loadingActivities: "Le ultime attività vengono caricate...",
                    noActivities: "Nessuna attività disponibile",
                },
                allocationHistory: {
                    allLocations: "Tutte le ubicazioni",
                    fields: {
                        additionalInfo: "Informazioni aggiuntive",
                        allocated: "Visitato",
                        deallocated: "Partenza",
                        isCovidComplete: "Covid valido",
                        isValid: "Valido",
                        isSignedUp: "Registrato",
                        phone: "Tel. no.",
                        zip: "Codice postale",
                    },
                },
                attribute: {
                    fields: {
                        displayAs: "Visualizza come",
                        filter: "Filtro",
                        icon: "Icona",
                        isEnabled: "Attivo",
                        type: "Tipo",
                    },
                    types: {
                        standard: "Standard",
                        custom: "Personalizzato",
                    },
                    effectDescription: {
                        Include: "Se questo filtro è applicato, vengono visualizzati solo gli articoli con questo attributo.",
                        Exclude: "Se questo filtro è applicato, vengono visualizzati solo gli articoli senza questo attributo.",
                    },
                    standardFieldsLocked:
                        "Attributo standard: nome, icona e filtro sono uguali per tutte le sedi e possono essere modificati solo a livello centrale.",
                    standardCannotBeDeleted:
                        "Un attributo standard è disponibile per tutte le sedi e non può essere eliminato. Disattivalo invece.",
                    cannotBeDisplayedAsFilter:
                        "Per questo attributo standard non è definito alcun effetto di filtro, quindi non può essere visualizzato come filtro.",
                },
                receipt: {
                    receipt: "Ricevuta",
                    sendReceipt: "Inviare la Ricevuta",
                    printReceipt: "Stampa ricevuta",
                },
                apiVersion: {
                    fields: {
                        package: "Packet",
                        version: "Versione",
                    },
                },
                print: {
                    orderReceiptPrinted: "Lavoro di stampa inviato",
                    failedPrintReceipt: "Lavoro di stampa fallito",
                    noProductionSiteEnabledForRoom: "A questo tavolo / stanza non è assegnata alcuna stampante per ricevute attiva.",
                },
                cancellation: {
                    allModes: "Tutte le modalità",
                    allPositions: "Tutte le voci",
                    cancelPositions: "Singole voci",
                    cancelWholePayment: "Intero pagamento",
                    fields: {
                        amount: "Importo",
                        cancelled: "Annullato",
                        executedBy: "Effettuato da",
                        mode: "Modalità",
                        positions: "Voci",
                        reason: "Motivo",
                        refund: "Rimborso",
                        refunded: "Rimborsato",
                    },
                },
                dashboard: {
                    allocations: "Check-Ins",
                    signups: "Registrazioni",
                    turnover: "Vendite",
                    selectLocation: "Selezionate una ubicazione per visualizzare i rapporti.",
                    salesChart: {
                        chartTitle: "Fatturato incl. mancia",
                        orders: "ordini",
                        payments: "pagamenti",
                    },
                    salesByPaymentMethodChart: {
                        chartTitle: "Mezzi di pagamento",
                        onlineBrowser: "Online - Browser",
                        onlinePaymentDevice: "Online - Dispositivo di pagamento",
                        offline: "Offline",
                        nre: "Non rilevante per il fatturato",
                    },
                    cancellationsChart: {
                        chartTitle: "Cancellazioni",
                        noReason: "Nessun motivo",
                    },
                    kpiSummary: {
                        tip: "Mancia",
                        netSalesNetExclTip: "Fatturato netto (escl. mancia)",
                        grossSalesNetExclTip: "Fatturato (escl. mancia)",
                        avgOrder: "Ordine medio",
                        avgPayment: "Pagamento medio",
                        avgBill: "Conto medio",
                        avgBillDurationMins: "Durata media del conto",
                    },
                },
                discount: {
                    fields: {
                        appliesTo: "Si applica a",
                        appliesToAll: "Tutti",
                        name: "Denominazione",
                        order: "Ordina",
                        status: "Stato",
                        timesUsed: "Volte usato",
                        totalDiscounted: "Totale scontato",
                        type: "Tipo",
                        value: "Valore",
                    },
                    discountCode: {
                        copiedClipboard: "Codice sconto è stato copiato negli appunti.",
                    },
                    cancelDiscountPopupMessage: "Annullare questo sconto? Questa azione non può essere annullata. Modifica Inizio / Fine se vuoi usarlo di nuovo in futuro.",
                },
                documents: {
                    allRooms: "Tutte le stanze",
                    failedLimitExceeded: "Il numero massimo di documenti è stato superato. Contatta il nostro ufficio vendite per aumentare il tuo abbonamento.",
                    fields: {
                        dateFrom: "Data",
                        file: "File",
                        isPublished: "Pubblicato",
                        modified: "File modificato",
                        timeFrom: "Tempo",
                        weekdays: "Giorni della settimana",
                    },
                    newCondition: "Nuova pianificazione",
                    unknownRoom: "Stanza sconosciuta",
                },
                elements: {
                    articleOverview: {
                        collapseAll: "Piegare tutti",
                        expandAll: "Svolgere tutti",
                        failedLoading: "Gli articoli non possono essere caricati.",
                        failedSort: "L'ordine non può essere cambiato.",
                        loadingItems: "Gli articoli vengono caricati...",
                        newCategory: "Nuova categoria",
                        newItem: "Nuovo articolo",
                        noItemsAvailable: "Nessun articolo disponibile nell'offerta",
                        noItemsText: "Non sono ancora state aggiunte categorie a questa offerta, a cui sono stati assegnati gli articoli.",
                        notAvailable: "Non disponibile",
                        open: "Libero",
                    },
                    fileUpload: {
                        invalidMime: "Il tipo di file non è consentito. Si prega di caricare un file nel seguente formato: <b>{[allowed}}</b>",
                        invalidSize: "File troppo grande. Dimensione massima: <b>{{size}}</b>",
                        noFileSelected: "Nessun file selezionato",
                        selectFile: "Selezionare un file",
                    },
                    imagePicker: {
                        invalidSize: "File troppo grande. Dimensione massima: <b>{{size}}</b>",
                        noImage: "Nessuna immagine",
                        pleaseSelectImage: "Selezionare l'immagine",
                        uploadFailed: "Impossibile salvare l'immagine.",
                    },
                    offerSchedulesEditor: {
                        autoAcceptUnassignedReservations: "Le prenotazioni che non possono essere assegnate a un tavolo possono essere accettate automaticamente oppure presentate all’operatore per l’approvazione",
                        capacityAdjustmentPercentage: "Cuscinetto / Overbooking (% di tutti i posti)",
                        expectedLostSeatRatio: "Posti persi previsti per prenotazioni non assegnate",
                        messageToUserAfterPendingOperatorReservation: "Message to user after pending (Operator) reservation",
                        operatorsCanBreakReservationRules: "Gli operatori possono aggirare le regole",
                        operatorsMustAcceptOrDeclineReservation: "Gli operatori devono accettare o rifiutare (nessuna risposta immediata – la capacità di posti calcolata è sempre rispettata)",
                        preOrders: "Preordini",
                        nodata: "Nessun turno è stato ancora definito...",
                        preOrdertime: "Periodo minimo di pre-ordine",
                        fulfilmentTimeInterval: "Intervallo di tempo di adempimento",
                        defaultCapacityPerFulfilmentTime: "Capacità standard per tempo di adempimento",
                        orders: "ordini",
                        operatorsMayEditOrders: "Gli operatori possono modificare gli ordini",
                        editOrderUpToFulfillmentTime: "fino … a prima dell’orario di evasione",
                        endUsersMayCancelOrders: "Gli utenti finali possono annullare",
                        refundability: " Rimborsabilità",
                        tableReservations: "Prenotazioni tavoli",
                        excludeTables: "Escludere tavoli",
                    },
                    optionAllocator: {
                        canUpTo: "opzioni <b>possono</b> essere selezionate.",
                        maxPerOption: "Quantità max. per opzione",
                        maxSum: "Somma max.",
                        mustTotalUpTo: "opzioni <b>devono,</b> in totale fino a",
                        noOptionsSelected: "Nessuna opzione è stata ancora selezionata...",
                        preselection: "Preselezione",
                    },
                    productionSiteAllocator: {
                        noProductionSites: "Non è ancora stato assegnato un Sito di produzione...",
                        subtitle: "Non usato se l'articolo è usato come opzione.",
                        printOrdersFrom: "Stampare ordini da",
                    },
                    optionGroupAllocator: {
                        noGroups: "Nessun gruppo di opzioni è stato ancora assegnato...",
                    },
                    passwordInput: {
                        minLength: "Almeno {{count}} caratteri",
                        minNumbers: "Almeno {{count}} numero",
                        minUpperCase: "Almeno {{count}} lettera maiuscola",
                    },
                    select: {
                        pleaseSelect: "Selezionare",
                    },
                },
                enums: {
                    AttributeEffect: {
                        Include: "Includere",
                        Exclude: "Escludere",
                    },
                    AttributeDisplayType: {
                        Icon: "Icona",
                        Flag: "Bandiera",
                        Filter: "Filtro",
                    },
                    AttributeFlagDisplayTo: {
                        EndUsersAndOperators: "Utente finali e operatori",
                        EndUsers: "Utente finali",
                        Operators: "Operatori",
                    },
                    OperatorPlaySoundMode: {
                        FulfillmentInPreparation: "In preparazione / Pronto a breve",
                        FulfillmentReady: "Pronto",
                        FulfillmentFulfilledNotPaid: "Adempiuto, non pagato",
                    },
                    VoucherState: {
                        Enabled: "Abilitato",
                        Expired: "Scaduto",
                        Cancelled: "Annullato",
                        Redeemed: "Utilizzato",
                    },
                    PaymentMethodMode: {
                        Online: "Online",
                        Offline: "Offline",
                    },
                    JoinPrintingItemsMode: {
                        PerOrder: "Una stampa per ordine",
                        PerItem: "Una stampa per articolo",
                        PerOrderAndPerItem: "Una stampa per ordine e una per articolo",
                    },
                    BuyerRequirement: {
                        EmailConfirmed: "E-mail confermata",
                        None: "Nessun",
                        SignedUp: "Registrato con e-mail",
                        Email: "E-mail",
                    },
                    CancellationClaimValue: {
                        None: "Nessun",
                        MakeCancellationsAndRefunds: "Effettuare cancellazioni e rimborsi",
                    },
                    OperatorTransferClaimValue: {
                        CannotTransfer: "Non può trasferire",
                        CanTransferOwn: "Può trasferire i propri",
                        CanTransferAll: "Può trasferire tutti",
                    },
                    OperatorItemAvailabilityAndStockLevelClaimValue: {
                        CannotEdit: "Non può modificare",
                        CanEdit: "Può modificare",
                    },
                    CancellationMode: {
                        Amount: "Importo manuale",
                        Positions: "Singole voci",
                        WholeOrder: "Ordine intero",
                    },
                    CancellationReason: {
                        IncorrectIncompleteItemInformation: "Informazioni errate / incomplete sull'articolo",
                        OrderedIncorrectlyEndUser: "Ordinato in modo errato (utente finale)",
                        OrderedIncorrectlyStaffMember: "Ordinato in modo errato (membro del personale)",
                        EndUserChangedMind: "L'utente finale ha cambiato idea",
                        ItemNotAvailable: "Articolo non disponibile",
                        PriceWrong: "Prezzo sbagliato",
                        BusinessClosedAtFulfilmentTime: "Attività chiusa al momento dell'adempimento",
                        LossBreakageStaffMember: "Rottura / Perdita (membro del personale)",
                        LateFulfilment: "Adempimento tardivo",
                        BadQualityPresentation: "Pessima qualità / presentazione",
                        LossBreakageEndUser: "Rottura / Perdita (utente finale)",
                        CustomerDidNotPayWalkout: "Il cliente non ha pagato (Fuga)",
                        Other: "Altro",
                    },
                    CancellationState: {
                        Cancelled: "Annullato",
                        PartiallyCancelled: "Parzialmente annullato",
                    },
                    ConsumptionSite: {
                        OffSite: "Fuori sede",
                        OnSite: "In loco",
                    },
                    ConsumptionSiteDisplayMode: {
                        DeliveryAddress: "Indirizzo di consegna",
                        PickUpAddress: "Indirizzo di ritiro",
                        LocationAddress: "Indirizzo di ubicazione",
                        None: "No",
                    },
                    Country: {
                        Austria: "Austria",
                        France: "Francia",
                        Germany: "Germania",
                        Italy: "Italia",
                        Netherlands: "Paesi Bassi",
                        Switzerland: "Svizzera",
                    },
                    DashboardStatsPeriod: {
                        Today: "Oggi",
                        Date: "Data",
                        Yesterday: "Ieri",
                        Past7Days: "Ultimi 7 giorni",
                        Past8Days: "Ultimi 8 giorni",
                        Past4Weeks: "Ultime 4 settimane",
                        Past5Weeks: "Ultime 5 settimane",
                        Past3Months: "Ultimi 3 mesi",
                        Past12Months: "Ultimi 12 mesi",
                        Past13Months: "Ultimi 13 mesi",
                        CurrentWeek: "Settimana corrente",
                        LastWeek: "Settimana scorsa",
                        CurrentMonth: "Mese corrente",
                        LastMonth: "Mese scorso",
                        CurrentYear: "Anno corrente",
                        LastYear: "L'anno scorso",
                        TwoYearsAgo: "{{year}}",
                        ThreeYearsAgo: "{{year}}",
                        FourYearsAgo: "{{year}}",
                    },
                    DataOrigin: {
                        Portal: "Portale",
                        Pos: "POS",
                    },
                    DiscountAccessMode: {
                        Automatically: "Automaticamente",
                        Button: "Tramite pulsante",
                        Code: "Codice richiesto",
                        CodeOrButton: "Con codice o tramite pulsante",
                    },
                    DiscountStatus: {
                        Cancelled: "Annullato",
                        Enabled: "Abilitato",
                        Expired: "Scaduto",
                        NotYetValid: "Non ancora valido",
                    },
                    DiscountType: {
                        Absolute: "Assoluto",
                        Percentage: "Percentuale",
                    },
                    DocumentType: {
                        Pdf: "PDF",
                        Unknown: "Sconosciuto",
                    },
                    FulfillmentPositionDisplayMode: {
                        None: "Nessun",
                        Duration: "Durata",
                        Position: "Posizione",
                    },
                    FulfillmentHandling: {
                        None: "Nessun",
                        OnlyOperator: "App Operatore",
                        OperatorAndApp: "App Operatore e Mobile",
                    },
                    FulfillmentTimeMode: {
                        DeliveryTime: "Orario di consegna",
                        None: "No",
                        PickupTime: "Orario di ritiro",
                        Time: "Tempo (tipo non specificato)",
                    },
                    OneFulfillmentPerOrderMode: {
                        NotForced: "Non obbligatorio",
                        Forced: "Obbligatorio",
                        LetCustomerDecide: "Lasciare che sia l'ordinante a decidere",
                    },
                    FulfilmentTileSize: {
                        Large: "Grande",
                        Normal: "Normale",
                    },
                    IssueState: {
                        Closed: "Chiuso",
                        InProgress: "In corso",
                        Open: "Aperta",
                    },
                    Language: {
                        English: "Inglese",
                        French: "Francese",
                        German: "Tedesco",
                        Italian: "Italiano",
                    },
                    LocationState: {
                        Active: "Attivo",
                        Deleted: "Cancellato",
                        Suspended: "Disattivato",
                    },
                    LogLevel: {
                        Error: "Errore",
                        Info: "Info",
                        Warning: "Avviso",
                        Information: "Info",
                        Trace: "Trace",
                        Critical: "Critica",
                        Debug: "Debug",
                        None: "Nessuno",
                    },
                    Month: {
                        April: "Aprile",
                        August: "Agosto",
                        December: "Dicembre",
                        February: "Febbraio",
                        January: "Gennaio",
                        July: "Luglio",
                        June: "Giugno",
                        March: "Marzo",
                        May: "Maggio",
                        November: "Novembre",
                        October: "Ottobre",
                        September: "Settembre",
                    },
                    NewOrdersViewMode: {
                        AtTheBottom: "In fondo",
                        AtTheTop: "In alto",
                    },
                    OfferScheduleType: {
                        Closed: "Tempo chiuso",
                        DifferentOffer: "Pianificazione divergente",
                        Standard: "Pianificazione standard",
                    },
                    OperatorsCanBreakReservationRules: {
                        DoNotAllow: "Non consentire",
                        AllowAndNotify: "Notificare e consentire",
                    },
                    OperatorsMustAcceptOrDeclineReservation: {
                        Never: "Mai (automazione massima, rischio massimo)",
                        OverbookingAbove: "Overbooking superiore a %",
                        IfNoTableCanBeAssigned: "Se non è possibile assegnare un tavolo (inclusi tutti gli overbooking)",
                        Always: "Sempre (nessuna automazione, rischio minimo)",
                    },
                    OrderState: {
                        Canceled: "Stornato",
                        Closed: "Fatto",
                        FullyPaid: "Pagato per intero",
                        Open: "Aperto",
                        TimedOut: "Cancellato",
                        NotPaid: "Non pagato",
                        ClosedNotPaid: "Adempiuto, non pagato",
                        PartiallyPaid: "Parzialmente pagato",
                    },
                    OrderStateMode: {
                        All: "Tutti",
                        NotFulfilled: "Non adempiuto",
                        Ready: "Pronto",
                        NotPaid: "Non pagato",
                    },
                    PaymentProvider: {
                        Stripe: "Stripe",
                        Wallee: "Wallee",
                        PayTec: "PayTec",
                        Worldline: "Worldline",
                        PostFinance: "PostFinance",
                    },
                    PostFinanceContract: {
                        BrowserAndDevicePayment: "Browser e dispositivo di pagamento",
                        PaymentDeviceOnly: "Solo dispositivo di pagamento",
                    },
                    PaymentClient: {
                        Browser: "Browser",
                        PaymentDevice: "Dispositivo di pagamento",
                    },
                    PaymentState: {
                        Confirmed: "Confermato",
                        Declined: "Rifiutato",
                        Intented: "Richiesto",
                    },
                    PreOrderRefundabilityType: {
                        Refundable: "Rimborsabile",
                        NoRefundable: "Non rimborsabile",
                        RefundableWithFee: "Rimborsabile con commissione",
                        RefundOptionalForOperators: "Rimborso facoltativo per gli operatori",
                    },
                    PricingModel: {
                        Free: "Free",
                        Professional: "Premium",
                        Standard: "Standard",
                    },
                    PrintFontSize: {
                        Small: "Piccolo",
                        Medium: "Medio",
                        Large: "Grande",
                    },
                    PrintJobState: {
                        Failed: "Fallito",
                        Pending: "In attesa",
                        Printed: "Finito",
                        Unconfirmed: "Non confermato",
                    },
                    PrintLayout: {
                        OrderAndPay76Mm: "Order & Pay (76mm, ad es. TM-U220B)",
                        OrderAndPay80Mm: "Order & Pay (80mm piccolo, ad es. TM-M30)",
                        OrderAndPay80MmBig: "Order & Pay (80mm grande, ad es. TM-T88)",
                    },
                    PrinterProtocolType: {
                        EscPos: "ESC/POS",
                    },
                    PrinterState: {
                        ErrorState: "Errore",
                        Offline: "Offline",
                        OpenTrail: "Vassoio carta aperto",
                        OutOfPaper: "Nessuna carta",
                        Ready: "Pronto",
                    },
                    ProductionTileViewMode: {
                        Detailed: "Detailed",
                        Overview: "Overview",
                    },
                    RatingValue: {
                        Bad: "Cattivo",
                        Good: "Buono",
                        Ok: "OK",
                        VeryBad: "Molto male",
                        VeryGood: "Molto buono",
                    },
                    RefundMode: {
                        Offline: "Non in linea",
                        Online: "In linea",
                    },
                    RefundType: {
                        OutsideTastier: "Fuori da Tastier",
                        StripeRefund: "Stripe rimborso",
                        WalleeRefund: "Wallee rimborso",
                    },
                    RoomShape: {
                        Landscape: "Orizzontale",
                        Portrait: "Verticale",
                        Square: "Quadrato",
                    },
                    ReportClaimValue: {
                        DontHaveAccessInOperatorAndMobilePos: "Visualizzare alcun",
                        ViewOnlyOwnSalesAndRevenue: "Visualizzare i propri",
                        ViewAllSalesAndRevenue: "Visualizzare tutti",
                    },
                    SaleInquiryState: {
                        AutoEnroled: "Accesso creato automaticamente",
                        Closed: "Chiuso",
                        FirstContact: "Primo contatto / richiesta",
                        InProgress: "In corso",
                    },
                    SalesReportViewType: {
                        Article: "Articoli",
                        Category: "Categorie di rapporti",
                        Detail: "Dettagli (articoli con opzioni)",
                    },
                    OfferCategoryHighlightType: {
                        Normal: "Normal",
                        FullWidth: "Larghezza piena",
                    },
                    PermalinkMode: {
                        None: "Senza modalità",
                        Kiosk: "Con modalità kiosk",
                        Normal: "Con modalità normale",
                    },
                    ServiceType: {
                        Covid: "Controllo Covid",
                        Documents: "Documenti",
                        Order: "Ordinare",
                        Ticketing: "Comprare i biglietti",
                        Website: "Link",
                        Offer: "Offerta",
                        Pay: "Pagare",
                        RoomPlan: "Piano di sala",
                    },
                    ShortWeekDay: {
                        Friday: "Ve",
                        Monday: "Lu",
                        Saturday: "Sa",
                        Sunday: "Do",
                        Thursday: "Gi",
                        Tuesday: "Ma",
                        Wednesday: "Me",
                    },
                    TableShape: {
                        Rectangle: "Rettangolo",
                        Round: "Cerchio",
                    },
                    TaskExecutionState: {
                        Executing: "In corso di esecuzione",
                        Inactive: "Inattivo",
                        Scheduled: "Programmato",
                    },
                    TaskSuccessState: {
                        Failed: "Fallito",
                        Success: "Riuscito",
                    },
                    VisibleEndUserProperties: {
                        None: "Nessuno",
                        FirstNameShortLastName: "Nome, cognome abbreviato",
                        Email: "Indirizzo e-mail",
                        PhoneNumber: "Numero di telefono",
                        FirstNameLastName: "Nome, Cognome",
                    },
                    PrintWhenOrderHasStatus: {
                        None: "Nessuno",
                        Confirmed: "Confermato (Ordinare per: Adesso) / Inizio della durata della produzione (Ordinare per: Adesso o più tardi)",
                        Ready: "Pronto",
                    },
                    Weekday: {
                        Friday: "Venerdì",
                        Monday: "Lunedì",
                        Saturday: "Sabato",
                        Sunday: "Domenica",
                        Thursday: "Giovedì",
                        Tuesday: "Martedì",
                        Wednesday: "Mercoledì",
                    },
                    Weekday3Letters: {
                        Friday: "ven",
                        Monday: "lun",
                        Saturday: "sab",
                        Sunday: "dom",
                        Thursday: "gio",
                        Tuesday: "mar",
                        Wednesday: "mer",
                    },
                    OrdererRequirement: {
                        NotRequired: "Non richiesto",
                        Required: "Richiesto",
                        Optional: "Facoltativo",
                        ConfirmedBlockOrder: "Confermato (blocca l’ordine)",
                        ConfirmedCancelOrder: "Nome del gruppo (se disponibile) / Numero del gruppo",
                    },
                    CreateOrderBillWithName: {
                        OrderNumber: "Numero d’ordine (se attivato) / Codice d’ordine",
                        PartyName: "Nom du groupe (si disponible) / Numéro du groupe",
                    },
                },
                feedback: {
                    allRatings: "Tutte le valutazioni",
                    failedDelete: "La valutazione non può essere cancellata.",
                    fields: {
                        comment: "Commento",
                        created: "Presentata il",
                        rating: "Valutazione",
                    },
                    reallyDelete: "Questa valutazione dovrebbe davvero essere cancellata?",
                },
                general: {
                    copy: "Copiare",
                    activate: "Attivare",
                    all: "Tutti/e",
                    alphabeticallyOrdered: "Alfabetico",
                    andMore: "e {{qty}} altri",
                    anonymousUser: "Utente finale anonimo",
                    attention: "Attenzione",
                    back: "Ritorno",
                    cancel: "Cancellare",
                    change: "Cambiare",
                    close: "Confirmare",
                    confirm: "Confirmer",
                    day: "Giorno",
                    deactivate: "Disattivare",
                    delete: "Cancellare",
                    deletedLocation: "Ubicazione cancellata",
                    deletedOrder: "Ordine cancellato",
                    deletedUser: "Utente cancellato",
                    download: "Scaricare",
                    entities: {
                        fulfillmentGroups: "Gruppi di adempimento",
                        item: "Articolo",
                        location: "Ubicazione",
                        locations: "Ubicazioni",
                        offer: "Offerta",
                        offerSchedule: "Pianificazione",
                        offers: "Offerte",
                        option: "Opzione",
                        optionGroup: "Gruppo di opzioni",
                        optionGroups: "Gruppi di opzioni",
                        options: "Opzioni",
                        order: "Ordina",
                        orders: "Ordini",
                        orderApplications: "Applicazioni di Ordine",
                        productionSite: "Sito di produzione",
                        productionSites: "Siti di produzione",
                        room: "Stanza",
                        rooms: "Stanze",
                        shift: "Turno",
                        shifts: "Turni",
                        table: "Tavolo",
                        user: "Utente",
                        cancellation: "Annulation",
                    },
                    export: "Esportare",
                    failed: "Fallito",
                    failedCreate: "La voce non può essere creata.",
                    failedLoad: "La voce non può essere caricata.",
                    failedLoadingData: "I dati non possono essere caricati.",
                    failedRemove: "La voce non può essere cancellata.",
                    failedUpdate: "La voce non può essere modificata.",
                    fields: {
                        active: "Attivo",
                        available: "Disponibile",
                        birthday: "Data di nascita",
                        created: "Creato",
                        date: "Data",
                        description: "Descrizione",
                        designation: "Designazione",
                        displayName: "Designazione divergente",
                        email: "E-mail",
                        firstName: "Nome",
                        inactive: "Disattivato",
                        internalName: "Denominazione interna",
                        internalNote: "Nota interna",
                        language: "Lingua",
                        lastName: "Cognome",
                        name: "Nome",
                        notes: "Note",
                        oohPrice: "Prezzo fuori sede",
                        phone: "Telefono",
                        price: "Prezzo",
                        sort: "Ordine",
                        sortOrder: "Ordina",
                        state: "Stato",
                        time: "Tempo",
                        type: "Tipo",
                        open: "Libero",
                    },
                    forward: "Continuare",
                    loading: "Sta caricando...",
                    locationSwitch: {
                        lastLocations: "Ultime ubicazioni",
                        noLocationsFound: "Nessuna ubicazione trovata",
                        pleaseSelect: "Selezionare una ubicazione...",
                        searchResults: "Risultati di ricerca",
                    },
                    month: "Mese",
                    no: "No",
                    noItemsFound: "Nessuna voce trovata",
                    noSearchResults: "Nessun risultato trovato",
                    none: "Nessuno",
                    of: "su",
                    pagination: "Record: {{from}} - {{until}}",
                    reallyRemove: "Sei sicuro di voler cancellare questa voce in modo permanente?",
                    remove: "Cancellare",
                    reset: "Reset",
                    save: "Salvare",
                    search: "Cercare",
                    searchTerm: "Termine di ricerca...",
                    searchingResults: "Cercando i risultati...",
                    addNewValue: "Aggiungi «{{value}}»",
                    send: "Inviare",
                    successfullyCreated: "Voce salvata con successo",
                    successfullyRemoved: "Voce cancellata con successo",
                    successfullyUpdated: "Voce modificata con successo",
                    timeFormat: {
                        agoCount: "{{count}} fa",
                        always: "Sempre",
                        daily: "Quotidiano",
                        daysWithCount_one: "{{count}} giorno",
                        daysWithCount_other: "{{count}} giorni",
                        end: "Fine",
                        from: "da",
                        fromStart: "da {{start}}",
                        hoursWithCount_one: "{{count}} ora",
                        hoursWithCount_other: "{{count}} ore",
                        inCount: "in {{count}}",
                        minutesWithCount_one: "{{count}} minuta",
                        minutesWithCount_other: "{{count}} minuti",
                        never: "Mai",
                        notYet: "Non ancora",
                        nowCurrentTime: "Ora / ora corrente",
                        range: "{{start}} fino al {{end}}",
                        secondsWithCount_one: "{{count}} seconda",
                        secondsWithCount_other: "{{count}} secondi",
                        start: "Inizio",
                        until: "fino al",
                        untilEnd: "fino al {{end}}",
                        weekdays: "Giorni feriali",
                        wholeDay: "giornata intera",
                    },
                    today: "Oggi",
                    unknown: "Sconosciuto",
                    yes: "Sì",
                    enabled: "Abilitato",
                    disabled: "Disabilitato",
                },
                identicalEntry: {
                    title: "Testo identico trovato",
                    message: "Esiste già un'altra voce con lo stesso identico testo {{- texts}} in {{- languages}}. La preghiamo di modificare il testo per evitare un duplicato.",
                    editText: "Modificare testo",
                    saveAnyway: "Salvare comunque",
                    languages: {
                        English: "inglese",
                        German: "tedesco",
                        French: "francese",
                        Italian: "italiano",
                    },
                },
                issue: {
                    allStates: "Tutti gli stati",
                    fields: {
                        lastModified: "Ultima modifica",
                        message: "Messaggio",
                        received: "Ricevuto",
                    },
                },
                item: {
                    fields: {
                        categories: "Categorie di offerta",
                    },
                    insufficientStock: "Scorte troppo basse. Si prega di aumentarlo, di ridurre la scorta minima o di disattivare la funzione di scorta.",
                    articleMinQuantityGreaterThanOptionGroupMaxPerOption: "La quantità minima di {{article}} ({{articleMinQuantity}}) non può essere superiore alla Quantità max. per opzione nel Gruppo di opzioni {{optionGroup}} ({{optionGroupMaxPerQuantity}}).",
                    noCategory: "Nessuna categoria",
                    noFulfillmentGroup: "Nessun Gruppo di Adempimento",
                    itemCopiedAndEditingNow: "Articolo copiato. Ora state modificando la versione copiata dell'articolo.",
                    itemDeletionFailed: "L'articolo non può essere eliminato",
                    missingStandardServiceDurationForSeats: "Gli articoli con la risorsa “Posti a sedere” devono avere assegnato un Gruppo di evasione con Durata di servizio standard.",
                    openPriceAndPricePerMinuteExclusive: "Un articolo non può essere contemporaneamente un articolo a prezzo al minuto e un articolo a prezzo libero.",
                    fulfillmentGroupCannotBeRemoved: "Questo Gruppo di evasione non può essere eliminato perché è già stato utilizzato negli ordini.",
                },
                location: {
                    allStates: "Tutti gli stati",
                    covidContactTracing: "Controllo Covid",
                    failedToExport: "Le ubicazioni non possono essere esportate.",
                    translation: {
                        key: "Chiave",
                        newEntry: "Nuova voce",
                    },
                    childLocations: {
                        internalNameOfAllChildLocationsMustBeUniqueError: "La denominazione interna di tutte le ubicazioni subordinate deve essere univoca.",
                        internalNameAlreadyInUseByAnotherLocationError: "La denominazione interna è già utilizzata da un'altra ubicazione assegnata alla stessa ubicazione principale.",
                        linkedLocationCircularRelationError: "Una ubicazione selezionata è un'ubicazione principale dell'ubicazione attualmente in fase di modifica. Rimuovere la ubicazione e riprovare.",
                    },
                    psp: {
                        oneIconForAllStripePaymentMethods: "Un'icona per tutti i mezzi di pagamento Stripe",
                        oneIconForAllWalleePaymentMethods: "Un'icona per tutti i mezzi di pagamento Wallee",
                        missingDefaultPaymentMethodConfiguration: "Configurazione predefinita mancante per il metodo di pagamento: {{paymentMethodName}}",
                    },
                    twilio: {
                        accountSid: "Account SID",
                        create: "Creare un account",
                        created: "L'account Twilio è stato creato con successo.",
                        currentConnected: "Account collegato",
                        delete: "Cancellare",
                        deleted: "L'account Twilio è stato cancellato.",
                        failedCreate: "L'account Twilio non può essere collegato.",
                        failedDelete: "L'account Twilio non può essere cancellato.",
                        reallyCreate: "Vuoi davvero creare un account in Twilio?",
                        reallyDelete: "Cancellare l'account in modo permanente? La ripartizione dei costi rimane visibile.",
                        serviceSid: "Service SID",
                    },
                    locationSlugNotAvailable: "Questo indirizzo internet è già occupato, si prega di modificarlo. Disponibile: {{proposedSlugs}}",
                    locationHasOrdersOrPayments: "Questa ubicazione non può essere cancellata a causa degli ordini e dei pagamenti effettuati.",
                    copyFailed: "L'ubicazione è stata salvata, ma non è stato possibile copiarla.",
                },
                login: {
                    backToLogin: "Torna al login",
                    enterValidEmail: "Inserisci un indirizzo e-mail valido.",
                    enterValidPassword: "Inserisci una password valida.",
                    failedResetPw: "Purtroppo non è stato possibile reimpostare la password.",
                    featureNotImplemented: "Prossimamente - I clienti aziendali nel modello gratuito purtroppo non hanno ancora accesso. Ci stiamo lavorando e vi informeremo non appena potrete accedere. Per domande: marketing@tastier.ch",
                    login: "Accesso",
                    loginFailedBlocked: "Accesso fallito a causa di permesso mancante. Assicurati di aver attivato il tuo accesso.",
                    loginFailedCredentials: "E-mail o password non valida",
                    passwordLost: "Password dimenticata?",
                    resetPassword: "Reimpostazione della password",
                    resetPasswordBtn: "Reimpostare",
                    resetPwSuccess: "Ti abbiamo inviato un'email per reimpostare la tua password, per favore controlla la tua casella di posta e la cartella spam se necessario.",
                    signinBtn: "Log In",
                    emailAlreadyUsed: "Questa e-mail è già presa.",
                },
                modal: {
                    addOptionGroup: {
                        newGroupBtn: "Nuovo gruppo di opzioni",
                        options: "Opzioni",
                        saveItems: "Salvare ({{items}} articoli)",
                        showsInItems: "Appare negli articoli",
                        title: "Aggiungere gruppo di opzioni",
                    },
                    addOptionToGroup: {
                        categories: "Categorie",
                        newItemBtn: "Nuovo articolo",
                        saveItems: "Salvare ({{items}} articoli)",
                        title: "Aggiungere un'opzione",
                    },
                    allocationHistoryExport: {
                        failedToExport: "Le visite non possono essere esportate.",
                        fromTo: "Data da / fino a",
                        selectLocation: "Selezionare la ubicazione...",
                        selectTable: "Selezionare il tavolo...",
                        settings: "Impostazioni",
                        title: "Esportare le visite",
                    },
                    cancellation: {
                        cancellationFailed: "Non è stato possibile annullare l'ordine.",
                        cancellationNotAllowedForPayment: "L'annullamento non è consentito per questo pagamento.",
                        canStockBeReused: "Lo stock può essere riutilizzato?",
                        confirmMessage: "{{amt}} CHF si annullano davvero? Questo non può essere invertito.",
                        confirmTitle: "Effettuare la cancellazione?",
                        failedLoading: "L'ordine non può essere caricato.",
                        loading: "L'ordine è in fase di caricamento...",
                        notNow: "Non adesso",
                        notPaid: "Non pagato",
                        offlineMode: "Rimborso offline",
                        paid: "Pagato",
                        payment: "Pagamento",
                        paymentMethod: "Mezzo di pagamento",
                        positionSectionTitle: "Quali unità di <b>{{itemName}}</b> devono essere cancellate?",
                        positionsText: "Selezionare le voci da cancellare:",
                        reason: "Motivo",
                        quantity: "Quantità",
                        status: "Stato",
                        submitBtn: "Si, annullare",
                        title: "Annullamento",
                        user: "Utente",
                        wholeOrderText: "L'intero ordine verrà annullato.",
                        singleCancellationFailed: "La cancellazione è fallita. Si prega di riprovare.",
                        multipleCancellationsFailed: "Almeno una cancellazione è fallita. Alcuni pagamenti potrebbero non essere stati rimborsati. Si prega di riprovare.",
                        multiplePdPaymentCancellationsNotSupported: "Questa cancellazione include più pagamenti via un dispositivo di pagamento. Si prega di limitarla a un massimo di un pagamento via dispositivo di pagamento.",
                        twintOnlineRefundNotSupported: "I pagamenti Twint effettuati su dispositivi di pagamento non possono essere rimborsati.",
                    },
                    documentCondition: {
                        allRooms: "Tutte le stanze",
                        failedToSave: "La pianificazione non può essere modificata.",
                        recurrence: "Turno",
                        time: "Tempo",
                        timeRange: "Data",
                        titleCreate: "Creare una pianificazione",
                        titleEdit: "Pianificazione",
                    },
                    documentSchedule: {
                        allRooms: "Tutte le stanze",
                        title: "Vista calendario",
                    },
                    locationAccess: {
                        editLocation: "Dettagli dell'ubicazione",
                        failedGranting: "Non è stato possibile concedere il permesso. Motivo: {{reason}}",
                        grants: "Permesso",
                        title: "Concedere nuovo permesso",
                    },
                    locationExport: {
                        exportSetting: "Impostazioni di esportazione",
                        failedExport: "Non è stato possibile esportare le ubicazioni.",
                        title: "Esportare i ubicazioni",
                        viewType: "Tipo",
                        withRooms: "Con stanze",
                        withoutRooms: "Normale",
                    },
                    locationSuspend: {
                        suspendBtn: "Disattivare",
                        suspendText: "Questa ubicazione è attualmente attiva. Vuoi disattivare questa ubicazione?",
                        title: "Disattivare la ubicazione",
                        unsuspendBtn: "Attivare",
                        unsuspendText: "Questa ubicazione è attualmente inattiva. Vuoi riattivare questa ubicazione?",
                        unsuspendTitle: "Attivare la ubicazione",
                    },
                    offerRoomActivation: {
                        failedActivation: "L'offerta non può essere attivata.",
                        failedDeactivation: "L'offerta non può essere disattivata.",
                        failedReset: "Ripristino fallito",
                        reset: "Ripristinare alla pianificazione",
                        successfulActivation: "Offerta attivata con successo. Questo si applica fino alla prossima disattivazione pianificata o manuale.",
                        sucessfulDeactivation: "Offerta disattivata con successo. Questo si applica fino alla prossima attivazione pianificata o manuale.",
                        sucessfulReset: "Ripristino riuscito",
                        title: "Attivare / disattivare l'offerta",
                    },
                    offerSchedule: {
                        title: "Vista calendario",
                        differentOffers: "Offerte diverse",
                    },
                    orderExport: {
                        failedExport: "Gli ordini non possono essere esportati.",
                        invalidDateRangeForOrder: "La durata del periodo di rendicontazione non può superare 8 giorni e la data di inizio deve rientrare negli ultimi 90 giorni.",
                        settings: "Portata",
                        title: "Esportare gli ordini",
                    },
                    stockExport: {
                        failedExport: "Non è stato possibile esportare le scorte.",
                    },
                    printOrderReceipt: {
                        title: "Stampare la ricevuta",
                    },
                    reprintOrder: {
                        failedSending: "Il lavoro di stampa non può essere inviato.",
                        hint: "Ristampa questo ordine sui seguenti siti di produzione.",
                        printBtn: "Stampare",
                        settings: "Impostazioni",
                        success: "Lavoro di stampa rispedito.",
                        title: "Ristampare l'ordine",
                    },
                    salesReportExport: {
                        dailySummaryReport: "Rapporto di sintesi giornaliero",
                        exportSetting: "Portata",
                        failedExport: "Il rapporto sulle vendite non può essere esportato.",
                        invalidReportDateRangeException: "Il periodo di rendicontazione non deve superare i 93 giorni. Per periodi più lunghi, contattare l'assistenza.",
                        paymentMethodsReport: "Rapporto sui mezzi di pagamento",
                        title: "Rapporto sulle vendite",
                        useDetailedNames: "Rappresentazione dettagliata",
                        specialReports: "Rapporti speciali",
                        levelOfDetail: "Livello di dettaglio",
                        orderFulfillmentReport: "Rapporto di adempimento degli ordini",
                    },
                    sendOrderReceipt: {
                        failedSending: "Non è stato possibile inviare la ricevuta.",
                        receiver: "Destinatario",
                        sentTo: "La ricevuta è stata inviata a {{ricevente}}",
                        settings: "Impostazioni",
                        title: "Inviare la Ricevuta",
                    },
                    transactionCompare: {
                        settings: "Impostazioni",
                        dateFromTo: "Data da / fino a",
                        compareTransactions: "Confrontare le transazioni",
                        startComparison: "Iniziare il confronto",
                        totalCompared: "Totale confrontato",
                        matches: "Abbinamenti",
                        differences: "Differenze",
                        comparingHasMade: "Il confronto viene fatto...",
                        comparingTransactionDescription: "Questo può richiedere alcuni minuti. Si prega di tenere aperta questa finestra durante il confronto.",
                        comparisonFailed: "Confronto fallito",
                        pleaseTryAgain: "Per favore riprova più tardi.",
                        transactionsCouldNotBeCompared: "Le transazioni non possono essere confrontate.",
                        date: "Data",
                        transaction: "Transazione",
                        order: "Ordine",
                        comment: "Commento",
                        link: "Link",
                    },
                    locationPaymentMethod: {
                        addTitle: "Aggiungi metodo di pagamento posizione",
                        editTitle: "Modifica metodo di pagamento posizione",
                        locationPaymentMethod: "Metodo di pagamento per posizione",
                        contract: "Contratto",
                        name: "Nome",
                        merchantId: "ID commerciante",
                        mode: "Modalità",
                        displayIcon: "Visualizzare l'icona",
                        logo: "Logo",
                        provider: "Fornitore",
                        additionalSettings: "Impostazioni aggiuntive",
                        paymentMethodExternalId: "ID metodo di pagamento",
                        isCreditDebitCard: "Gestito da una società di pagamento con carta (card scheme)",
                        paymentDevice: "Dispositivo di pagamento",
                        isEnabled: "Abilitato",
                        order: "Ordine",
                        failedDelete: "Il mezzo di pagamento non poteva essere annullato.",
                        failedEdit: "Il mezzo di pagamento non poteva essere modificato.",
                        deviceId: "ID del dispositivo",
                        allowTipOnlyOnDevice: "Consenti l'inserimento della mancia solo sul dispositivo",
                        useTerminalApi: "Usa l'API del terminale",
                        apiToken: "Token API",
                        integratorId: "ID integratore",
                        revenueEffective: "Generatore di fatturato",
                        pairingCode: "Pairing code",
                        pairConnect: "Accoppiare e connettere",
                        disconnect: "Disconnettere",
                        deviceDisconnected: "Il dispositivo è stato disconnesso con successo.",
                        deviceConnected: "Il dispositivo è stato collegato con successo.",
                        deviceConnectFailed:
                            "La connessione al terminale PayTec non è riuscita. Controlla il codice di accoppiamento o il token di accesso e assicurati che il terminale sia online.",
                        connect: "Collegare",
                    },
                    service: {
                        addTitle: "Aggiungere un servizio",
                        editTitle: "Modificare il servizio",
                        failedDelete: "Il servizio non può essere cancellato.",
                        failedEdit: "Il servizio non può essere modificato.",
                        icon: "Icona",
                        customIcon: "Icona personalizzata",
                        customDesignation: "Designazione personalizzata",
                        service: "Servizio",
                        settings: "Impostazioni",
                        image: "Immagine",
                    },
                    sessionExpired: {
                        signinBtn: "Log In",
                        text: "Sei stato disconnesso per inattività prolungata. Per favore, accedi di nuovo.",
                        title: "Sessione scaduta",
                    },
                    supportIssue: {
                        editRequest: "Modificare la richiesta",
                        failedDelete: "La richiesta non può essere cancellata.",
                        failedEdit: "La richiesta non può essere modificata.",
                        title: "Modificare la richiesta di supporto",
                    },
                    voucherBulk: {
                        title: "Nuovo voucher",
                        internalNote: "Nota interna",
                        isActive: "Abilitato",
                        value: "Valore",
                        voucherQty: "Quantità",
                        create: "Creare",
                    },
                    tableBulk: {
                        action: "Operazione",
                        conventionPlaceholder: "ad es., Tavolo [Number]",
                        conventionText: 'Ad es., inserire "Tavolo" e cliccare su "Inserire numero".',
                        createAtLeast: "Deve essere creata almeno 1 stanza.",
                        deleteMultiple: "Cancellare più tavoli",
                        editCreateMultipleTables: "Creare / modificare più tavoli",
                        editPosId: "Modificare ID POS",
                        execute: "Eseguire",
                        failedEdit: "Le tavoli non possono essere modificati.",
                        failedLimitExceeded: "Il numero massimo di tavoli è stato superato. Contatta il nostro ufficio vendite per modificare il tuo abbonamento.",
                        failedNoAffected: "L'operazione non ha modificato nessuna tavolo.",
                        failedNoSubscription: "Questa ubicazione attualmente non ha un abbonamento attivo.",
                        hidePosId: "Nascondere l'ID del POS",
                        insertNumber: "Inserire il numero",
                        posId: "ID POS",
                        previewNoneDelete: "Attenzione: nessun tavolo sarà cancellato.",
                        previewPluralDelete: "Attenzione: {{amount}} tavoli saranno cancellati.",
                        previewPluralEdit: "Attenzione: {{amount}} tavoli saranno sovrascritte.",
                        previewSingularDelete: "Attenzione: 1 tavolo sarà cancellato.",
                        previewSingularEdit: "Attenzione: 1 tavolo sarà sovrascritto.",
                        seatCount: "Numero di posti a sedere",
                        preferredMinimumOccupancy: "Occupazione minima preferita",
                        selectRoom: "Selezionare una stanza...",
                        tableNrFromTo: "Numero di tavolo da / a",
                        tableNrPlaceholder: "ad es. 10",
                        title: "Diversi tavoli",
                        whatToDo: "Cosa si deve fare?",
                    },
                    transactionExport: {
                        allStates: "Tutti gli stati",
                        dateFromTo: "Data da / fino a",
                        exportSetting: "Impostazioni",
                        failedExport: "Non è stato possibile esportare i pagamenti",
                        selectLocation: "Selezionare la ubicazione...",
                        title: "Esportare i pagamenti",
                    },
                    translation: {
                        addTitle: "Creare una voce",
                        editTitle: "Modificare la voce",
                        failedDelete: "La voce non può essere cancellata.",
                        failedEdit: "Il testo non può essere modificato.",
                        key: "Chiave",
                        systemText: "Testo del sistema",
                        text: "Testo",
                    },
                    userAccess: {
                        editLocation: "Modificare l'ubicazione",
                        failedEdit: "Non è stato possibile concedere il permesso. Motivo: {{reason}}",
                        grants: "Permesso",
                        kind: "Tipo",
                        title: "Concedere un nuovo permesso",
                    },
                },
                offer: {
                    activate: "Attivare",
                    activateDeactivate: "Attivare / Disattivare",
                    activated: "L'offerta {{offer}} è stata attivata.",
                    deactivate: "Disattivare",
                    deactivated: "L'offerta {{offer}} è stata disattivata.",
                    failedActivate: "L'offerta non può essere attivata.",
                    failedDeactivate: "L'offerta non può essere disattivata.",
                    offerCopiedAndEditingNow: "Offerta copiata. Ora state modificando la versione copiata dell'offerta.",
                    orderApplications: "Applicazioni di Ordine",
                },
                offerSchedule: {
                    allOffers: "Tutte le offerte",
                    allOrderApplications: "All applications",
                    allRooms: "Tutte le stanze",
                    allTypes: "Tutti i tipi",
                    failedIntersection: "Sovrapposizione con {{link}}",
                    fields: {
                        currentActive: "Attivo ora",
                        currentSchedule: "Pianificazione attuale",
                        weekdayAndTime: "Giorni della settimana e orari",
                    },
                    offerScheduleCopiedAndEditingNow: "Pianificazione copiata. Ora stai modificando la versione copiata della pianificazione.",
                    failedPlanningOverlapsOtherPlanning: "Questa pianificazione si sovrappone a un'altra pianificazione",
                },
                optionGroup: {
                    fields: {
                        appearsInItems: "Appare negli articoli",
                    },
                    optionGroupCopiedAndEditingNow: "Gruppo di opzioni copiato. Ora state modificando la versione copiata.",
                },
                offerCategory: {
                    imagesNotCopied: "Non è stato possibile copiare le immagini della categoria di origine. Aggiungetele manualmente.",
                    offerCategoryCopiedAndEditingNow: "Categoria di offerta copiata. Ora state modificando la versione copiata.",
                },
                order: {
                    allStates: "Tutti gli stati",
                    deletedTable: "Tavolo cancellato",
                    consumptionInclVat: "Consumo (incl. {{vat}}% IVA)",
                    fields: {
                        cancellation: "Annullamento",
                        consumption: "Consumo",
                        discount: "Sconto",
                        dailyOrderIncrement: "Numero d'ordine",
                        fulfillDate: "Data",
                        orderNumber: "Codice d'ordine",
                        tip: "Mancia",
                        useCase: "Applicazione",
                        totalIncTip: "Totale (mancia inclusa)",
                        total: "Totale",
                        fulfilmentTime: "Tempo di adempimento",
                        scheduled: "Programmato",
                    },
                },
                productionSite: {
                    cancelJob: "Annullare il lavoro di stampa",
                    changeProtocolHint: "Cambiando il protocollo o il formato si cancellano tutti i lavori di stampa che non sono ancora stati eseguiti.",
                    failedCancelJob: "Il lavoro di stampa non può essere annullato.",
                    failedDeleteJob: "Il lavoro di stampa non può essere cancellato.",
                    failedToSendTestPrint: "Stampa di prova non può essere inviata alla stampante.",
                    usedAsBackup: "Questo sito di produzione non può essere eliminato perché è impostato come backup in: {{forwardingProductionSites}}. Rimuovilo prima da lì.",
                    fields: {
                        backupPrint: "Stampa inoltrata",
                        backupSite: "Inoltro",
                        forwarded: "Inoltrato",
                        isActive: "Attiva",
                        lastCommunication: "Ultima comunicazione",
                        layout: "Formato",
                        protocol: "Protocollo",
                    },
                    noJobs: "Nessun lavoro di stampa disponibile",
                    reallyCancel: "Questo lavoro di stampa deve davvero essere cancellato?",
                    selectProductionSite: "Selezionare il sito di produzione...",
                    testPrintSent: "Stampa di prova è stata inviata alla stampante",
                },
                room: {
                    activateService: "Per favore, attiva un servizio",
                    addService: "Aggiungere un servizio",
                    failedChangingOrder: "L'ordine non può essere cambiato. Si prega di ricaricare la finestra del browser.",
                    failedLimitExceeded: "Il numero massimo di stanze è stato superato. Contatta il nostro ufficio vendite per aumentare il tuo abbonamento.",
                    failedLoadingServices: "I servizi non possono essere caricati.",
                    failedTableReferences: "La stanza non può essere cancellata perché le tavoli sono assegnate ad essa.",
                    fields: {
                        deallocationDelay: "Durata del checkout autom.",
                        services: "Servizi",
                        endUserServices: "Servizi per l'utente finale",
                        operatorServices: "Servizi per l'operatore",
                    },
                },
                saleInquiry: {
                    allStates: "Tutti gli stati",
                    fields: {
                        company: "Azienda",
                        lastModified: "Ultima modifica",
                        location: "Città",
                        person: "Utente",
                        priceModel: "Modello",
                        received: "Ricevuto",
                    },
                },
                signup: {
                    accessCreated: "Account creato. Per attivare il tuo account ti abbiamo inviato una email a <b>{{email}}</b>, per favore controlla la tua casella di posta e la cartella spam se necessario.",
                    failed: "La registrazione non può essere completata. Si prega di riprovare.",
                    fields: {
                        password: "Password",
                    },
                    success: "Ti sei già registrato con successo e hai attivato il tuo accesso al portale per i clienti aziendali.",
                },
                stock: {
                    disableWarning: "Aumentare le scorte e rendere disponibile l'articolo per venderlo",
                    failedSave: "Non è stato possibile modificare le scorte dell'articolo.",
                    fields: {
                        safetyStock: "Scorte minime",
                        stock: "Scorte attuali",
                    },
                },
                subscription: {
                    allLocations: "Tutte le ubicazioni",
                    customForCustomer: "Personalizzato",
                    fields: {
                        covid: "Controllo Covid",
                        documents: "Documenti",
                        pay: "Pagare",
                        preset: "Modello",
                        validUntil: "Valido fino a",
                    },
                    unrestricted: "Illimitato",
                },
                system: {
                    fields: {
                        level: "Level",
                        message: "Messaggio",
                        time: "Tempo",
                        title: "Titolo",
                    },
                },
                table: {
                    allDataOrigins: "Tutte le fonti di dati",
                    allRooms: "Tutte le stanze",
                    allUsersDeallocated: "Tutti gli utenti sono stati rimossi dal tavolo.",
                    downloadAllQr: "Scaricare Tutti i Codici QR",
                    downloadAllQrText: "Qui si scaricano tutti i codici QR come file zip. Copia i file png dal file zip in un programma di elaborazione testi o di grafica. Aggiungi le note dei visitatori e disegna le tue stampe (segui le raccomandazioni). In alternativa, Tastier offre questo servizio.",
                    downloadBtn: "Scaricare",
                    editPosId: "Modificare l'ID POS",
                    failedDeallocating: "Gli utenti non possono essere rimossi dal tavolo.",
                    failedReset: "Il tavolo non può essere resettato.",
                    fields: {
                        requireInfo: "Inserimento del testo libero",
                        seats: "Numero di posti a sedere",
                        tableNumber: "Numero del tavolo",
                    },
                    hidePosId: "Nascondere l'ID POS",
                    permalink: {
                        copiedClipboard: "L'URL è stato copiato negli appunti.",
                        create: "Creare un link diretto",
                        failedCreate: "Non è stato possibile creare un link diretto.",
                        failedDelete: "Il link diretto non può essere cancellato.",
                        reallyDelete: "Questo link diretto dovrebbe essere cancellato in modo permanente?",
                        mode: "Modalità",
                    },
                    successReset: "Il tavolo è stato resettato con successo.",
                    tableNumerInUse: "Numero di tavolo o ID POS già in uso",
                    table: "Tavolo",
                },
                task: {
                    failedStart: "L'esecuzione dell'attività non può essere avviata.",
                    fields: {
                        duration: "Durata",
                        interval: "Intervallo",
                        nextExecution: "Prossima esecuzione",
                        result: "Risultato",
                        started: "Avviato",
                    },
                    started: "L'attività è stata avviata.",
                },
                transaction: {
                    allLocations: "Tutte le ubicazioni",
                    allStates: "Tutti gli stati",
                    fields: {
                        amount: "Importo",
                        fees: "Tassa",
                        paymentMethod: "Mezzo di pagamento",
                        paymentMethodButton: "Pulsante del mezzo di pagamento",
                        provider: "PSP",
                        client: "Client",
                    },
                },
                useCase: {
                    preorderRoomsWithoutPlanningException: "Per questa Applicazione di Ordine con l'impostazione “Ordinare per: Ora o più tardi” manca una pianificazione per: {{roomNames}}. Si prega di aggiungere o ampliare una pianificazione.",
                    orderApplicationCopiedAndEditingNow: "Applicazione di ordine copiata. Ora state modificando la versione copiata dell’applicazione di ordine.",
                    failedDelete: "L'applicazione non può essere rimossa perché è utilizzata dal servizio {{dependingName}}.",
                    tooManyQuickPaymentMethodsEnabled: "È possibile abilitare fino a {{maxEnabledPaymentMethodsCount}} mezzi di pagamento rapido.",
                    atLeastOneDeliveryAreaRequiredError: "È richiesta almeno un'area di consegna",
                    minimumTotalUnitsPerOrderGreaterThanMaximumError: "Il numero totale minimo di unità per ordine non può essere superiore al massimo.",
                    minimumTotalUnitsPerOrderInvalidError: "Il numero totale minimo di unità per ordine deve essere almeno 1.",
                    maximumTotalUnitsPerOrderInvalidError: "Il numero totale massimo di unità per ordine deve essere almeno 1.",
                    fields: {
                        buyerRequirement: "Requisito dell'ordinante",
                        consumptionSite: "Luogo di consumo",
                        fulfillmentPositionDisplayMode: "Visualizzare l'adempimento",
                        fulfillmentHandling: "Dove?",
                        fulfillmentTimeMode: "Visualizzare il tempo di adempimento",
                        tip: "Mancia",
                        usePayment: "Pagamento",
                        usePreorder: "Ordinare per",
                        maxPreorderPeriod: "Periodo massimo di pre-ordine",
                    },
                    guest: "Ospite",
                    payment: {
                        offline: "Mezzi di pagamento offline",
                        online: "Mezzi di pagamento online",
                        other: "Altri",
                        paymentDevices: "Dispositivi di pagamento",
                    },
                    preorderOff: "Ora",
                    preorderOn: "Ora o più tardi",
                    waiter: "Camerieri",
                    operators: "Operatori",
                    endUsers: "Utenti finali",
                    quickButton: "Mezzo di pagamento rapido",
                    defaultMessageToUserBeforeOrder: "Salve, attendiamo con ansia il tuo ordine.",
                    defaultOrderReminderPushNotificationMessage: "Il tuo ordine è previsto per il ritiro tra 1 ora",
                    defaultOrderReminderPushNotificationTitle: "Ritiro previsto",
                    pickupOrderPushNotificationTitle: "Ritirare l'ordine",
                    pickupOrderPushNotificationMessage: "Il tuo ordine è pronto per il ritiro",
                    notRevenueEffective: "Non rilevante per il fatturato",
                    permission: "Autorizzazione",
                },
                notification: {
                    notifiedWhenOrderReadyWithDuration: "Sarai avvisato quando il tuo ordine sarà pronto per il ritiro. Tempo di attesa previsto (indicativo, può variare in qualsiasi momento):",
                    notifiedWhenOrderReadyWithPosition: "Sarai avvisato quando il tuo ordine sarà pronto per il ritiro. Posizione attuale nella lista d'attesa:",
                },
                user: {
                    allRoles: "Tutti i ruoli",
                    allUsers: "Tutti gli utenti",
                    anonymous: "Anonimo",
                    anonymousUser: "Utente finale anonimo",
                    failedResetPassword: "Non è stato possibile reimpostare la password.",
                    fields: {
                        claimType: "Tipo di permesso",
                        devices: "Dispositivo",
                        emailConfirmed: "E-mail confermata",
                        lastLogin: "Ultimo accesso",
                        loginProviders: "Accesso via",
                    },
                    newGrant: "Nuovo permesso",
                    noGrants: "Nessuno permesso assegnato",
                    onlyAnonymousUser: "Solo utenti anonimi",
                    onlySignedUpUsers: "Solo utenti registrati",
                    passwordSet: "La password è stata cambiata con successo.",
                    reallyRemoveGrant: "Davvero revocare il permesso?",
                    removeGrant: "Revocare",
                    signedUp: "Registrato",
                },
                voucher: {
                    alreadyUsedCannotBeDeleted: "Il voucher è già stato utilizzato e non può essere eliminato.",
                    fields: {
                        created: "Creato",
                        expiryDate: "Data di scadenza",
                        initialValue: "Valore iniziale",
                        balance: "Saldo",
                        code: "Codice voucher",
                        internalNote: "Nota interna",
                        isActive: "Abilitato / Disabilitato",
                        cancellation: "Annullamento",
                    },
                    voucherCode: {
                        copiedClipboard: "Codice voucher è stato copiato negli appunti.",
                    },
                },
                voucherDesign: {
                    addEmptyTextBox: "Aggiungi una casella di testo vuota",
                    areYouSureYouWantToLeave: "Hai modifiche non salvate. Se lasci questa scheda, verranno perse. Vuoi continuare?",
                    areYouSureYouWantToRemoveTemplate: "Sei sicuro di voler rimuovere questo modello di design del voucher? Questa operazione ripristinerà il modello predefinito.",
                    backgroundColor: "Colore di sfondo",
                    backgroundImage: "Immagine di sfondo",
                    clear: "Cancella",
                    edit: "Modifica",
                    emptyTextBox: "Casella di testo vuota",
                    errorRemovingTemplate: "Si è verificato un errore durante la rimozione del modello di design del voucher.",
                    expirationDate: "Data di scadenza",
                    failedDeleteImage: "Impossibile eliminare l'immagine. Riprova.",
                    imageLibrary: "Immagini personalizzate",
                    invoiceAddress: "Indirizzo di fatturazione",
                    loadingImages: "Caricamento immagini...",
                    locationAddress: "Indirizzo della sede",
                    locationName: "Nome della sede",
                    logo: "Logo",
                    marginSize: "Dimensione margine",
                    noImagesAvailable: "Nessuna immagine disponibile",
                    pageSettings: "Impostazioni della pagina",
                    predefinedImages: "Immagini",
                    preview: "Anteprima",
                    qrCode: "Codice QR",
                    reallyDeleteImage: 'Sei sicuro di voler eliminare "{{name}}"?',
                    toolbar: {
                        alignCenter: "Allinea al centro",
                        alignJustify: "Giustifica",
                        alignLeft: "Allinea a sinistra",
                        alignRight: "Allinea a destra",
                        bold: "Grassetto",
                        bulletList: "Elenco puntato",
                        heading1: "Titolo 1",
                        heading2: "Titolo 2",
                        heading3: "Titolo 3",
                        heading4: "Titolo 4",
                        heading5: "Titolo 5",
                        horizontalRule: "Linea orizzontale",
                        italic: "Corsivo",
                        orderedList: "Elenco numerato",
                        paragraph: "Paragrafo",
                        strike: "Barrato",
                        textColor: "Colore del testo",
                        textType: "Tipo di testo",
                        underline: "Sottolineato",
                    },
                    upload: "Carica",
                    uploadedImage: "Immagine caricata",
                    variables: "Testo",
                    variablesNotPresent: "Le seguenti variabili non sono presenti nel documento: {{variables}}",
                    voucherBalance: "Saldo voucher",
                    voucherCode: "Codice voucher",
                    voucherDesign: "Design voucher",
                },
            },
        },
    },
};

export function initTranslations() {
    currentTranslations.resources.en.translation = {
        ...currentTranslations.resources.en.translation,
        ...resx.en,
    };
    currentTranslations.resources.de.translation = {
        ...currentTranslations.resources.de.translation,
        ...resx.de,
    };
    currentTranslations.resources.fr.translation = {
        ...currentTranslations.resources.fr.translation,
        ...resx.fr,
    };
    currentTranslations.resources.it.translation = {
        ...currentTranslations.resources.it.translation,
        ...resx.it,
    };
    i18next.init(currentTranslations);
}
